{
   "common": {
      "activate": "Activate",
      "authRedirecting": "Taking you to secure sign in...",
      "back": "Back",
      "cancel": "Cancel",
      "continue": "Continue",
      "deactivate": "Deactivate",
      "delete": "Delete",
      "downloads": "Downloads",
      "edit": "Edit",
      "email": "Email",
      "emptyData": "There are no items to display.",
      "loading": "Loading...",
      "location": "Location",
      "nextPage": "Next page",
      "prevPage": "Previous page",
      "ready": "Ready",
      "save": "Save",
      "saving": "Saving...",
      "saveChanges": "Save Changes",
      "search": "Search",
      "settings": "Settings",
      "view": "View",
      "input": {
         "maxLength": "Maximum {{number}} characters allowed",
         "minValue": "The minimum allowed value is {{number}}"
      },
      "yourEmail": "Your email address",
      "activateTitle": "Are you sure you want to activate '{{ name }}'?",
      "deactivateTitle": "Are you sure you want to deactivate '{{ name }}'?",
      "recaptchaAttribution": "This site is protected by reCAPTCHA and the Google <privacyLink>Privacy Policy</privacyLink> and <termsLink>Terms of Service</termsLink> apply."
   },
   "delete": {
      "confirmTitle": "Confirmation",
      "cancel": "No, Thanks",
      "confirm": "Yes, I’m sure"
   },
   "search": "Search",
   "login": "Login",
   "SEARCH": "SEARCH",
   "logout": "Logout",
   "requiredField": "This is a required field. Please enter a value.",
   "invalidEmail": "Email address is invalid. Example: user@example.com.",
   "homePage": "Go to Homepage",
   "uploadPicture": "Upload picture",
   "generalErrors": "Call request failed!",
   "notFoundErrors": "Not found!",
   "contactSupport": "Contact support",
   "yourAccountHasBeenDeactivated": "Your account has been deactivated.",
   "pleaseContactSupport": "Please contact support to have your account reset.",
   "somethingsWentWrong": "Somethings went wrong",
   "loading": "Loading",
   "back": "Back",
   "members": "members",
   "member": "member",
   "gameGuide": {
      "loading": "Loading guide…",
      "notFound": "This game guide isn't available.",
      "share": "Share",
      "vs": "vs",
      "at": "at",
      "watchOn": "Watch on",
      "eventType": {
         "TOURNAMENT": "Tournament",
         "TRAINING_CAMP": "Training Camp",
         "SHOWCASE": "Showcase",
         "LEAGUE": "League",
         "OTHER": "Event"
      },
      "heroSub": "Book your stay and a share of every booking supports the team.",
      "tripAtAGlance": "Trip at a glance",
      "dates": "Dates",
      "roomsFrom": "Rooms from",
      "perNight": "/ night",
      "seeHotels": "See hotels",
      "trackPrices": "Track Prices",
      "proceedsSupport": "{{rate}}% of every booking supports {{org}}",
      "destination": "Destination",
      "checkIn": "Check-in",
      "checkOut": "Check-out",
      "guests": "Guests",
      "searchHotels": "Search Hotels",
      "night": "night",
      "viewRates": "View Rates",
      "moreHotels": "More Places to Stay",
      "trackTitle": "Not ready to book?",
      "trackBody": "Start tracking prices for this trip and we'll email you the moment hotel rates drop.",
      "priceTrackHint": "Tap the bell to track a hotel's price and we'll let you know when it drops.",
      "gameInfo": "Game Info",
      "matchup": "The Matchup",
      "events": "Game Events",
      "learnMore": "Learn more",
      "hotels": "Where to Stay",
      "hotelsLoading": "Finding hotels…",
      "officialHotel": "Official Hotel",
      "viewAllHotels": "View All Hotels",
      "restaurants": "Where to Eat",
      "thingsToDo": "Things to Do",
      "sponsor": "Sponsor",
      "viewOnMaps": "View on Google Maps",
      "heroChip": "{{siteName}} · {{chip}}",
      "organizedByLine": "Organized by {{site}} · Partner: {{org}}",
      "tickerStay": "Hotels near {{place}}",
      "ratingExcellent": "Excellent",
      "ratingGreat": "Great",
      "ratingGood": "Good",
      "experienceTitle": "Experience {{place}} · Visitor center",
      "experienceBody": "Need recommendations beyond this page? The visitor center staff know every corner of town — stop in before the game and ask for the game-day map.",
      "planMore": "Plan more of your stay",
      "venueType": {
         "HOME": "Home game",
         "AWAY": "Away game",
         "NEUTRAL": "Neutral site"
      },
      "welcome": "Welcome, {{org}} fans",
      "gamePreview": "Game preview",
      "lodging": "Lodging",
      "eventsEyebrow": "Around the game",
      "introMatchup": "What to expect on game day, and what to know before you go.",
      "introEvents": "Extra events happening around the game.",
      "introHotels": "Stay close to the action — hotels near the venue, priced for your dates.",
      "introMoreHotels": "More places to stay near the venue if the first picks don't fit.",
      "introRestaurants": "Local favorites near the hotel — filter by meal time to see what fits your day.",
      "introThingsToDo": "Things to see and do before and after the game.",
      "teamBlockTitle": "Book through the team block to keep the group together.",
      "teamBlockBody": "Rates shown are the lowest available for your party. Free cancellation until Aug 15 — no booking fees, and payments can be split into two installments.",
      "moreLodging": "More lodging",
      "fuelUp": "Fuel up",
      "offTheField": "Off the field",
      "kickoff": "Kickoff",
      "broadcast": "Broadcast",
      "allMeals": "All",
      "milesToPlace": "{{distance}} to {{place}}",
      "perNightShort": "/nt",
      "reserve": "Reserve",
      "reserveHotel": "Reserve {{name}}",
      "trust": {
         "hotels": "3M+ hotels worldwide",
         "tripTypes": "Personal, business, or team trips",
         "proceedsBack": "{{rate}}% back to {{org}}"
      },
      "rail": {
         "title": "Your game day trip",
         "partnerTrip": "Partner trip",
         "travelers": "Travelers",
         "program": "Program",
         "roomsAdults": "{{rooms}} room · {{adults}} adults",
         "chooseHotel": "Choose your hotel",
         "reserveSelected": "Reserve selected hotel",
         "checkAvailability": "Check availability",
         "ratesNotLive": "Hotel rates aren't live yet",
         "ratesNotLiveBody": "Prices for this trip drop soon — track the search and we'll email you the moment they do.",
         "trackSearch": "Track this search",
         "questionsTitle": "Questions? Talk to a human.",
         "organizedBy": "Organized by",
         "teamBlockNotice": "Team-block rates locked through Aug 15 — 12 rooms left at this price.",
         "forOrg": "For {{org}}",
         "questionsBody": "Our trip support team can help with your booking."
      },
      "category": {
         "COFFEE": "Coffee",
         "BREAKFAST": "Breakfast",
         "LUNCH": "Lunch",
         "DINNER": "Dinner"
      }
   },
   "planSeason": {
      "loading": "Loading your season…",
      "notFound": "We couldn't load this season.",
      "eyebrow": "Plan Your Season",
      "backToOrg": "Return to Team Portal",
      "travelHub": "Official travel hub",
      "heading": "Plan your",
      "headingAccent": "season",
      "subtitle": "We've curated team hotels & suggestions based on proximity to the venue + 2 bed availability, but you have the flexibility to book any property you'd like!",
      "share": "Share Schedule",
      "readyToBook": "Ready to book",
      "shareCopied": "Schedule link copied.",
      "home": "Home",
      "away": "Away",
      "title": "Plan your {{program}} season",
      "titleGeneric": "Plan your season",
      "tbd": "Date TBD",
      "signInPrompt": "Sign in to save your plan, dismiss games, select hotels, and attach trips.",
      "signIn": "Sign in",
      "emptySchedule": "This season's schedule isn't published yet. Check back soon.",
      "browseHotels": "Browse hotels",
      "hideHotels": "Hide hotels",
      "viewHotels": "View hotels",
      "viewAllHotels": "View all hotels",
      "viewGuide": "View guide",
      "trackPrices": "Track prices",
      "trackingStarting": "Starting…",
      "trackError": "Couldn't start price tracking.",
      "noHotelsToTrack": "No hotels found to track for this game.",
      "book": "Book",
      "viewTrip": "View trip",
      "findDifferent": "Find a different hotel",
      "fromPrice": "From ${{price}} / night",
      "hotelsLoading": "Finding hotels…",
      "noHotelsFound": "No hotels found for this game.",
      "whereToStay": "Where to stay",
      "hotelsAvailable_one": "{{count}} hotel available",
      "hotelsAvailable_other": "{{count}} hotels available",
      "hotelsRadius": "Within a {{distance}} radius",
      "hotelsRadiusKm": "Within {{distance}}",
      "stay": {
         "datesLabel": "Dates",
         "guestsLabel": "Guests",
         "change": "Change",
         "changeDatesAria": "Change dates, currently {{dates}}",
         "changeGuestsAria": "Change guests, currently {{guests}}",
         "nights_one": "{{count}} night",
         "nights_other": "{{count}} nights",
         "apply": "Update hotels",
         "sheetTitle": "Your dates and guests",
         "pickCheckOut": "Pick a check-out date",
         "eventDates": "Event dates: {{dates}}",
         "reset": "Reset to event dates",
         "missesEvent": "Your dates don't overlap the event.",
         "noHotels": "No hotels found"
      },
      "selectForGame": "Select for this game",
      "selectedForGame": "Selected",
      "selectedHotel": "Selected hotel",
      "bookedTrip": "Your trip",
      "hotelTiers": {
         "team": "Team hotel",
         "sponsor": "Official sponsor",
         "luxury": "Luxury pick",
         "budget": "Budget pick",
         "recommended": "Recommended"
      },
      "listedHotels": {
         "regionLabel": "Hotels picked for this game",
         "checkingRates": "Checking rates…",
         "starClass": "{{stars}}-star hotel",
         "findingMore": "Finding more hotels nearby…"
      },
      "noLocationTitle": "We couldn't find a location to search.",
      "noLocationBody": "This game doesn't have a location we can map yet. You can still search hotels manually or attach an existing trip.",
      "searchHotelsManually": "Search hotels",
      "notGoingCount": "Not going ({{count}})",
      "restore": "Restore",
      "going": "Going",
      "notGoing": "Not going",
      "attachTrip": "Attach existing trip",
      "openGuide": "Open game guide",
      "suggestMatch": "We found a trip that matches this game.",
      "linkTrip": "Link trip",
      "attachTitle": "Attach a trip to {{opponent}}",
      "noTrips": "No upcoming trips to attach.",
      "attach": "Attach",
      "status": {
         "booked": "Booked",
         "selected": "Hotel selected",
         "notStarted": "Not started",
         "notGoing": "Not going"
      },
      "summary": {
         "games": "{{count}} games",
         "booked": "{{count}} booked",
         "selected": "{{count}} selected",
         "gamesLabel": "Games",
         "bookedLabel": "Booked",
         "selectedLabel": "Selected"
      },
      "primaryStay": {
         "regionLabel": "Your team's hotel",
         "badge": "Team hotel",
         "badgeHelp": "Where the team is staying",
         "stars": "{{count}}\u00a0star",
         "stars_other": "{{count}}\u00a0stars",
         "fromVenue": "{{distance}} from the venue",
         "from": "From",
         "perNightShort": "/nt",
         "milesFromPlace": "{{distance}} from {{place}}",
         "perNight": "per night",
         "chooseRoom": "Pick a room",
         "beds": "{{count}} bed",
         "beds_other": "{{count}} beds",
         "refundable": "Free cancellation",
         "selectRoom": "Reserve",
         "noRooms": "No rooms are available here for these dates.",
         "roomProceeds": "{{amount}}+ to {{orgName}}",
         "ratesError": "We couldn't load rooms for this hotel just now.",
         "checkHotel": "Check the hotel",
         "viewAllRooms": "View All Rooms",
         "viewRoom": "See photos and details for {{room}}",
         "recommendedBadge": "Recommended",
         "recommendedBadgeHelp": "Our pick for this trip",
         "recommendedRegionLabel": "Recommended place to stay",
         "sponsorBadge": "Official sponsor",
         "sponsorBadgeHelp": "The official hotel sponsor",
         "sponsorRegionLabel": "Official sponsor hotel",
         "luxuryBadge": "Something nicer",
         "luxuryBadgeHelp": "A step up for this trip",
         "luxuryRegionLabel": "A nicer place to stay",
         "budgetBadge": "Best value",
         "budgetBadgeHelp": "Easy on the budget for this trip",
         "budgetRegionLabel": "Best value place to stay",
         "optionBadge": "Top option nearby",
         "optionBadgeHelp": "The top option in the area",
         "optionRegionLabel": "Top option nearby"
      },
      "otherStays": {
         "regionLabel": "Other places to stay",
         "title": "Other options",
         "team": "Team Hotel",
         "recommended": "Recommended",
         "budget": "Best value",
         "luxury": "Something nicer",
         "fromVenue": "{{distance}} from the venue",
         "driveUnder": "Under 10\u00a0min drive to the venue",
         "driveApprox": "~{{minutes}}\u00a0min drive to the venue",
         "findRoom": "Reserve",
         "sponsor": "Official sponsor"
      },
      "curated": {
         "noStrongMatch": "No hotel nearby is a strong match for this organization's preferences yet, so these are the top options in the area."
      },
      "selectProgramFirst": "Please select a program before booking.",
      "actionFailed": "We couldn't save that. Please try again.",
      "nextModal": {
         "titleLead": "Ready to book for",
         "titleName": "{{name}}?",
         "body": "Your next game is coming up! Secure your hotel now and keep the momentum going.",
         "bodyEvent": "Your next event is coming up! Secure your hotel now and keep the momentum going.",
         "maybeLater": "Maybe later",
         "view": "View"
      }
   },
   "edit": "Edit",
   "active": "Active",
   "inactive": "Inactive",
   "activate": "Activate",
   "remove": "Remove",
   "name": "Name",
   "index": "Index",
   "slug": "Slug",
   "description": "Description",
   "assignRoles": "Assign Roles",
   "assignRole": "Assign Role",
   "user": {
      "updateSuccess": "Update user profile successfully",
      "updateFail": "Update user profile Fail",
      "changeStatusSuccess": "Change user status successfully",
      "changeStatusFail": "Change user status Fail",
      "payments": {
         "addCard": {
            "tooManyAttempts": "Too many payment attempts. Please wait a while and try again.",
            "blocked": "We couldn't add this card to your account. Please contact support if you believe this is a mistake."
         }
      },
      "addedit": {
         "addUser": "Add User",
         "editUser": "Edit User",
         "cancel": "No, Thanks",
         "confirm": "Yes, I’m sure",
         "confirmTitle": "Confirmation"
      }
   },
   "transaction": {
      "program": "Program",
      "organization": "Organization",
      "dateRange": "Date range",
      "export": "Export",
      "exportPopup": {
         "confirmTitle": "Export transactions",
         "cancel": "Cancel",
         "download": "Download Transactions",
         "downloading": "Downloading...",
         "dateRange": "Date Range",
         "site": "Site",
         "organization": "Organization Name",
         "program": "Program Name",
         "travelers": "Traveler Name",
         "success": "Transactions exported. Your download should begin shortly.",
         "error": "Could not export transactions. Please try again."
      },
      "bookingStatusColumn": "Booking Status",
      "amountColumn": "Amount",
      "bookingChange": "Booking change",
      "travelerView": {
         "COST_SAVINGS": "Cost savings",
         "NOTHING": "Nothing shown"
      }
   },
   "coupon": {
      "codeType": "Code Type",
      "addEdit": {
         "addCoupon": "Add Coupon",
         "editCoupon": "Edit Coupon",
         "disCountAmountConstraints": "Discount Amount Constraints",
         "usageLimits": "Usage Limits",
         "dateAndTimeConstraints": "Date and Time Constraints",
         "userAndBookingEligibility": "User and Booking Eligibility",
         "titles": {
            "discountType": "Code Type",
            "discountValue": "Discount Value",
            "netRate": "Net Rate",
            "code": "Code",
            "minimumNights": "Minimum Number of Nights",
            "maximumDiscountPerUse": "Maximum Discount per Use",
            "minimumPurchaseAmount": "Minimum Purchase Amount",
            "totalGlobalUses": "Total Global Uses",
            "usesPerUser": "Uses per User",
            "validFrom": "Valid From",
            "validUntil": "Valid Until",
            "firstBookingOnly": "New Users Only / First Booking Only (Restrict coupon use to users who have never completed a booking.)",
            "userSegmentIds": "Apply only to specific user Organizations",
            "description": "Description"
         },
         "placeholders": {
            "selectDiscountType": "Select code type",
            "enterDiscountValue": "e.g., 50.00",
            "enterCode": "e.g., AAAAA",
            "enterMinimumNights": "e.g., 2",
            "enterMaximumDiscountPerUse": "e.g., 500.00",
            "enterMinimumPurchaseAmount": "e.g., 100.00",
            "enterTotalGlobalUses": "e.g., 500",
            "enterUsesPerUser": "e.g., 2",
            "enterValidFrom": "e.g., Aug 1, 2025",
            "enterValidUntil": "e.g., Sep 15, 2025",
            "selectUserSegmentIds": "Select organizations",
            "enterDescription": "Instead of the commission being split 50/50 for proceeds, this would result in a 25% commission and 75% proceeds."
         },
         "validations": {
            "requiredCodeType": "Code type is required. Please select a code type.",
            "requiredDiscountValue": "Discount value is required. Please enter a discount value.",
            "invalidCodeType": "Code type is invalid. Please select a valid code type.",
            "requiredCode": "Code is required. Please enter a coupon code.",
            "invalidDateFormat": "Invalid date. Please use {{format}} format.",
            "untilAfterFrom": "Until date must be after or equal to From date. Please adjust the dates.",
            "maxCodeLength": "Code must not exceed {{value}} characters. Please shorten your code.",
            "maxDescriptionLength": "Description must not exceed {{value}} characters. Please shorten your description.",
            "maxPercentDiscountValue": "Discount value must not exceed 100. Please enter a value between 0 and 100."
         }
      }
   },
   "activityLogs": {
      "dateRange": "Date range",
      "export": "Export",
      "exportPopup": {}
   },
   "bookingFailureTracker": {},
   "rating": {
      "amazing": "Amazing",
      "excellent": "Excellent",
      "great": "Great"
   },
   "review": {
      "hotelId": "hotel_id",
      "dataId": "data_id",
      "placeId": "place_id",
      "dataCid": "data_cid",
      "placeholders": {
         "enterHotelId": "Enter hotel_id",
         "enterDataId": "Enter data_id",
         "enterPlaceId": "Enter place_id",
         "enterDataCid": "Enter data_cid"
      },
      "validations": {
         "requiredHotelId": "hotel_id is required. Please enter a valid hotel ID."
      }
   },
   "hotelBlacklist": {
      "addEdit": {
         "addHotelBlacklist": "Add Hotel Blacklist",
         "titles": {
            "hotelId": "Hotel ID"
         },
         "placeholders": {
            "enterHotelId": "Enter hotel ID"
         }
      }
   },
   "versionPage": {
      "project": "Project",
      "versionNumber": "Version Number",
      "currentTimestamp": "Current Timestamp",
      "environment": "Environment",
      "buildNumber": "Build Number",
      "branch": "Branch",
      "commit": "Commit"
   },
   "loginPage": {
      "signInToMileMarker": "Sign in to Mile Marker",
      "notRegistered": "Not registered?",
      "createAccount": "Create account"
   },
   "navbar": {
      "userProfile": "User Profile",
      "userManagement": "User",
      "organization": "Organization",
      "organizationSettings": "Organization Settings",
      "admin": "Site Admin",
      "profile": "Profile",
      "myProfile": "My Profile",
      "myAccount": "My Account",
      "myFavorites": "My Favorites",
      "myTrips": "My Trips",
      "landing": "Landing Page",
      "paymentMethods": "Payment Methods",
      "Program": "Program"
   },
   "userProfilePage": {
      "savedGuests": {
         "title": "Saved guests",
         "helper": "These guests are added to your bookings automatically. Turn off auto-add to keep someone saved without adding them.",
         "empty": "No saved guests yet.",
         "add": "Add a guest",
         "edit": "Edit",
         "delete": "Delete",
         "save": "Save",
         "cancel": "Cancel",
         "autoAdd": "Auto-add",
         "autoAddAria": "Auto-add {{name}} to my bookings",
         "editAria": "Edit {{name}}",
         "deleteAria": "Delete {{name}}",
         "deleteTitle": "Delete saved guest?",
         "deleteBody": "{{name}} won't be added to your future bookings. Bookings already made keep their names.",
         "deleteConfirm": "Delete",
         "limit": "You can save up to {{max}} guests.",
         "duplicate": "This guest is already saved.",
         "error": "Something went wrong. Please try again.",
         "saved": "Saved guest updated.",
         "deleted": "Saved guest deleted.",
         "firstNameRequired": "Enter a first name.",
         "lastNameRequired": "Enter a last name."
      },
      "address": "Address",
      "addYourInfo": "Add your information and a photo to complete your profile.",
      "almostDone": "Almost Done",
      "aptSuiteFloor": "Apt, Suite, Floor",
      "basicInformation": "Basic Information",
      "birthDate": "Date of birth",
      "changePassword": "Change Password",
      "countryRegion": "Country/Region",
      "email": "Email",
      "errorSizeImage": "The maximum size allowed for file upload is 8 MB",
      "errorTypeImage": "Only extension jpg | jpeg | png | gif is allowed",
      "firstName": "First Name",
      "loyaltyNumber": "Loyalty Number",
      "gender": "Gender",
      "lastName": "Last Name",
      "mobileNumber": "Mobile Number",
      "organizations": "Organizations",
      "postcode": "Postcode",
      "role": "Role",
      "roles": "Roles",
      "save": "Save",
      "saveAndContinue": "Save & Continue",
      "skip": "Skip",
      "state": "State",
      "townCity": "Town/City",
      "updateProfileSuccess": "Update user profile successfully",
      "uploadPicture": "Upload picture",
      "originalOrgName": "Original Organization's Name"
   },
   "userTripPage": {
      "upcomingTrips": "Upcoming trips",
      "pastTrips": "Past trips",
      "detailLoading": "Loading trip details",
      "detailError": {
         "title": "We couldn’t load this trip",
         "content": "Something went wrong while retrieving your booking. Please try again.",
         "retry": "Try again"
      }
   },
   "sidebar": {
      "milemarker": "Mile Marker",
      "manageTrips": "Trips",
      "programSchedules": "Schedules",
      "userProfile": "User Profile",
      "dashboard": "Dashboard",
      "profile": "Profile",
      "userManagement": "Users",
      "organization": "Organization",
      "users": "Users",
      "organizations": "Organizations",
      "roles": "Roles",
      "organizationSettings": "Organization Settings",
      "myTokens": "My Tokens",
      "siteAdmin": "Site Admin",
      "openMainMenu": "Open main menu",
      "transactions": "Transactions",
      "proceedsReport": "Proceeds Report",
      "coupon": "Coupon",
      "review": "Custom Reviews",
      "hotelBlacklist": "Hotel Blacklist",
      "settings": "Settings",
      "siteConfigRegistry": "Site config registry",
      "fonts": "Fonts",
      "activityLogs": "Activity Logs",
      "bookingFailureTracker": "Booking Failure Tracker",
      "disputes": "Disputes",
      "fraudWatch": "Fraud Watch",
      "touristOverride": "Tourist Override",
      "teamHotels": "Team hotels",
      "orgAdminHome": "Organization admin",
      "orgAdminTrips": "Trips",
      "orgAdminProceeds": "Proceeds"
   },
   "userManagementPage": {
      "addUser": "Add User",
      "editUser": "Edit User",
      "fullName": "Full Name",
      "status": "Status",
      "members": "Members",
      "email": "Email",
      "overview": "Overview",
      "searchForUsers": "Search for users",
      "role": "Role",
      "createSuccessMessage": "Create user successfully",
      "editSuccessMessage": "Update user successfully",
      "editImageSuccessMessage": "Update user's avatar successfully",
      "removeSuccessMessage": "Remove member successfully",
      "errorSizeImage": "The maximum size allowed for file upload is 8 MB",
      "errorTypeImage": "Only extension jpg | jpeg | png | gif is allowed",
      "createFailMessage": "Create user fail",
      "editFailMessage": "Update user fail",
      "requiredField": "This is a required field. Please enter a value.",
      "invalidEmail": "Email address is invalid. Example: user@example.com.",
      "getUsersMessageFail": "Get list user unsuccessfully",
      "nameLengthMin": "Value length is invalid. Length must be greater than 1",
      "nameLengthMax": "Value length is invalid. Length must be lower than 100",
      "roleMin": "User must have at least one role",
      "addUserToOrg": "Add Member",
      "editUserInOrg": "Edit User In Organization",
      "emailExist": "This email already exists on the system. You can add to Organization",
      "copiedName": "Copied user's name to clipboard",
      "copiedEmail": "Copied user's email to clipboard",
      "createdAt": "Created At",
      "lastedLogin": "Lasted Login"
   },
   "myAccount": {
      "contactInfo": "Contact information",
      "myTrips": "My Trips",
      "menu": {
         "myAccountDescription": "Manage your personal information, contact details",
         "myTripsDescription": "Place to view, modify, or cancel your travel bookings and reservations.",
         "paymentMethodsDescription": "View, add, and manage the cards saved to your account"
      }
   },
   "myTokensManagement": {
      "myTokens": "My Tokens",
      "expireDate": "Expire Date",
      "status": "Status",
      "addToken": "Add Token",
      "searchToken": "Search for Token",
      "day": "day",
      "addTokenSuccessfully": "Added Token Successfully",
      "deleteTokenSuccessfully": "Deleted Token Successfully",
      "expiredOn": "Expired on",
      "expiresOn": "Expires on",
      "delete": "Delete",
      "copiedToken": "Copied token to clipboard"
   },
   "modal": {
      "cancel": "Cancel",
      "save": "Save",
      "change": "Change",
      "share": {
         "title": {
            "proceeds": "Maximize Your Impact",
            "savings": "Share the Savings",
            "neutral": "Share This Page"
         },
         "description": {
            "proceeds": "Share this page with your friends, family, and network to help support {{supportName}}.",
            "savings": "Share this page with your friends, family, and network so they can save on hotels with {{orgName}}.",
            "neutral": "Share this page with your friends, family, and network so they can book hotels with {{orgName}}."
         }
      }
   },
   "orgSettingPage": {
      "addUserOrganization": "Add User Organization",
      "editUserOrganization": "Edit User Organization"
   },
   "organizationModal": {
      "name": "Organizations Name",
      "description": "Description"
   },
   "paginate": {
      "showing": "Show",
      "of": "of"
   },
   "export": "Export",
   "chooseHere": "Choose here",
   "Select": "Select",
   "searchResult": {
      "title": "No results in this page",
      "subTitle": "Perhaps check spelling and try again"
   },
   "changePassword": {
      "title": "Change Password",
      "description": "Please change your password",
      "validationTitle": "Your password needs to:",
      "messageSuccess": "Reset password successfully, please check your email to change password",
      "sureResetPasswordTitle": "Are you sure you want to reset your password?",
      "sureResetPasswordContent": "You will receive an email with a link to reset your password.",
      "messageFail": "Change password fail",
      "emailVerifiedTitle": "Email Verified",
      "emailVerifiedContent1": "Your email address was successfully verified and ready to use. You will be redirected to the ",
      "emailVerifiedContent2": "Home page",
      "emailVerifiedContent3": " by click the link below",
      "invalidTitle": "Invalid Link",
      "invalidContent1": "This link has already been used. To reset your password, return to the login page and select “",
      "invalidContent2": "Forgot Your Password",
      "invalidContent3": "” to send a new email",
      "loginPage": "Go to Login",
      "newPassInvalid": "New Password invalid!",
      "confirmPassInvalid": "Please enter the same value again",
      "newPassword": "New Password",
      "currentPassword": "Current Password",
      "newPasswordConfirm": "Confirm Password"
   },
   "notFoundPage": {
      "title": "Page Not Found",
      "contentText1": "We’re sorry, the page you requested could not be found.",
      "contentText2": "Please go back to the homepage"
   },
   "guards": {
      "genericError": {
         "title": "Something went wrong",
         "content": "We couldn't load this page. Please try again.",
         "retry": "Try again"
      }
   },
   "emailVerificationPage": {
      "title": "Please verify your email",
      "buttonResend": "Resend Verification Email",
      "successMessage": "Resend Email Verification successfully "
   },
   "roleManagementPage": {
      "buttonAddRoleLabel": "Add Role",
      "placeholderSearch": "Search for roles",
      "Table": {
         "ColumnColName": "Name",
         "ColumnColType": "Type",
         "countPermission": "Count of permission",
         "ColumnColPermission": "Permissions",
         "description": "Description"
      },
      "RoleModal": {
         "ModalEditTitle": "Edit Role",
         "ModalAddTitle": "Add Role",
         "levelMinError": "Role level can not less than ",
         "RoleNameLabel": "Name",
         "description": "Description",
         "RoleTypeLabel": "Type",
         "editSuccessMessage": "Update role successfully",
         "createSuccessMessage": "Create role successfully"
      },
      "copiedName": "Copied role's name to clipboard",
      "deleteSuccessfully": "Delete Role successfully",
      "buttonDeleteRoleLabel": "Delete"
   },
   "dashboard": {
      "notification": "You don't have any Organization",
      "note": "Please Contact an Administator to enable your account."
   },
   "action": {
      "viewDetails": "View Details",
      "edit": "Edit",
      "organizations": "Organizations"
   },
   "userDetail": {
      "backToUsers": "Back to Users",
      "backToMembers": "Back to Members",
      "haveNoOrgNotification": "This user doesn’t have any Organization yet",
      "note": "Please Contact an Administrator",
      "notificationNotRoles": "This user doesn’t have any Role yet",
      "noteNotRoles": "Please Contact an Administrator"
   },
   "validations": {
      "required": "This is a required field. Please enter a value.",
      "invalidEmail": "Email address is invalid. Example: user@example.com.",
      "requiredEmail": "Email address is required. Please enter your email address.",
      "requiredFirstName": "First name is required. Please enter your first name.",
      "requiredLastName": "Last name is required. Please enter your last name.",
      "requiredRole": "Role is required. Please select a role.",
      "requiredOrganization": "Organization is required. Please select an organization.",
      "existed": "{{field}} already exists. Please choose a different {{field}}.",
      "invalidUrl": "URL is invalid. Please enter a valid URL, e.g., https://example.com.",
      "invalidDate": "Invalid date. Please use MM/DD/YYYY format."
   },
   "header": {
      "register": "Register",
      "signIn": "Sign in",
      "signOut": "Sign out",
      "redirecting": "Redirecting..."
   },
   "landing": {
      "hero": {
         "title": "Book the same hotels. Fund the teams you love.",
         "subtitle": "{{siteName}} offer the same hotels at the same prices as other sites—only we share our earnings back with your favorite teams"
      },
      "fundraisingLink": "Does your program need more revenue? Get in touch →",
      "supportBadges": {
         "properties": "3M+ properties worldwide",
         "trips": "Great for Personal, Business, and Team trips",
         "giveback": "Same hotels. Same prices. Real support."
      },
      "trustTicker": {
         "caption": "Trusted inventory from top hotel brands"
      },
      "valueProposition": {
         "sameHotels": {
            "title": "Same Hotels",
            "description": "We've partnered with leading suppliers to bring you the same hotel properties you'd find on other top travel sites."
         },
         "samePrices": {
            "title": "Same Prices",
            "description": "Our exclusive rates allow you to pay the same prices as major travel sites, but without any markups or hidden fees, all while supporting your team."
         },
         "givesBack": {
            "title": "Real Support",
            "description": "When you book through {{siteName}}, we share 50% of proceeds with your chosen team at no extra cost to you."
         },
         "footer": "Your booking experience stays the same.<br/>Our model simply routes earnings back to your cause."
      },
      "useCases": {
         "personal": {
            "title": "Personal Travel",
            "description": "Weekend getaways, family trips, events—support your cause every time you book."
         },
         "business": {
            "title": "Business Travel",
            "description": "Keep your policy and preferred hotels—channel savings into community impact."
         },
         "team": {
            "title": "Team & Group Travel",
            "description": "Teams, clubs, tournaments—coordinate rooms and fundraise with every stay."
         }
      },
      "stats": {
         "properties": "3M+ properties",
         "propertiesDescription": "Global coverage across cities, suburbs, and event hubs.",
         "trips": "All kinds of trips",
         "tripsDescription": "Personal, Business, and Team.",
         "impact": "When you book through your org page, we share our earnings with that cause—no extra cost to you."
      },
      "whoWeAre": {
         "title": "Who We Are",
         "description": "We started {{siteName}} to turn everyday travel into effortless fundraising. After years in tech and travel, we saw how much commission the industry keeps—while impactful organizations struggle for funding. So we built a booking experience that matches what you know on price and selection, but channels our earnings back to the causes you choose. It's that simple: same hotels, same prices, real giveback.",
         "learnMore": "Learn more →"
      },
      "supporter": {
         "howItWorks": {
            "title": "How {{siteName}} Works",
            "step1": {
               "title": "Find Your Organization",
               "description": "Search for the nonprofit you want to support and select them from our directory."
            },
            "step2": {
               "title": "Book Your Travel",
               "description": "Book hotels at the same prices you'd find anywhere else - no markup, no extra cost."
            },
            "step3": {
               "title": "Support Your Cause",
               "description": "Your organization automatically receives 50% of proceeds from your hotel booking."
            }
         },
         "benefits": {
            "title": "Why Book Through {{siteName}}?",
            "samePrice": {
               "title": "Same Prices, More Impact",
               "description": "You pay the same rates as other travel sites, but your money goes further for causes you care about."
            },
            "anyTravel": {
               "title": "Any Travel Counts",
               "description": "Business trips, vacations, weekend getaways - any hotel booking supports your chosen organization."
            }
         },
         "findOrganization": {
            "title": "Find Your Nonprofit to Support",
            "description": "Search for the organization you'd like to support and start booking travel that gives back.",
            "searchPlaceholder": "Select an organization"
         }
      },
      "slogan": "Big Travel is stealing your funding.",
      "description": "Travel companies make large commissions off of your supporters' personal travel. Keep those commissions & turn them into incremental proceeds, no matter how far away the trips take them.",
      "find": "Find a Nonprofit to Support"
   },
   "organization": {
      "landing": {
         "title": "Search Nonprofits",
         "description": "Find the organization you'd like to support.",
         "search": "Select an organization",
         "ExploringLifeStoriesThroughTravel": "Exploring Life-Stories Through Travel.",
         "weMakeLargeCommissions": "We make large commissions off of supporters’ personal travel. We keep those commissions & turn them into incremental donations, no matter how far away the trips take them.",
         "howNPTWorks": "How NPT Works",
         "programTitle": "You can make a general donation to Openland, or choose a specific program you'd like to support.",
         "socialProof": {
            "badge": "Join the movement",
            "message": {
               "proceeds": "<bold>{{name}}</bold> booked and generated <bold>{{amount}}</bold> of support.",
               "savings": "<bold>{{name}}</bold> booked and saved <bold>{{amount}}</bold>."
            }
         },
         "chapters": {
            "selectLabel": "Select your local chapter",
            "selectTeamLabel": "Select your team",
            "searchPlaceholder": "Search chapters...",
            "noResults": "No chapters found"
         },
         "selectTeamModal": {
            "title": "Select your team!",
            "subtitle": "See your team’s hotel for every event this season",
            "searchPlaceholder": "Search teams...",
            "noResults": "No teams found",
            "close": "Close"
         },
         "gameGuides": {
            "eyebrow": "Game Day Travel Guide",
            "titleLead": "Game day",
            "titleAccent": "travel guide",
            "home": "Home",
            "away": "Away",
            "neutral": "Neutral site",
            "factDate": "Date",
            "factTime": "Time",
            "factVenue": "Venue",
            "factWatch": "Watch on",
            "factStay": "Suggested stay",
            "tileHotels": "Hotels near the venue",
            "tileHotelsDesc": "Rooms close to the game, ready for your dates.",
            "tileEat": "Where to eat",
            "tileEatDesc": "Local spots for before and after the game.",
            "tileDo": "Things to do",
            "tileDoDesc": "Ways to fill out the rest of your trip.",
            "intro": "Everything for your trip in one place — hotels near the venue, where to eat, and things to do around the game.",
            "nextUp": "Next up",
            "featuredMatchup": "Featured matchup",
            "featuredEvent": "Featured event",
            "cta": "View the guide",
            "moreCount": "+{{count}} more guides this season",
            "moreThisSeason": "More guides this season",
            "seasonLink": "See the full season schedule"
         },
         "seasonPlanner": {
            "title": "Plan Your Season",
            "heroEyebrow": "Season {{season}}",
            "heroTitleLead": "Plan your",
            "heroTitleAccent": "season schedule",
            "viewFullSchedule": "View full schedule",
            "upcomingEvents_one": "{{count}} upcoming event",
            "upcomingEvents_other": "{{count}} upcoming events",
            "upcomingGames_one": "{{count}} upcoming game",
            "upcomingGames_other": "{{count}} upcoming games",
            "scrollForMore": "Scroll for more",
            "description": "Browse the full schedule, pick hotels for every game, and support {{orgName}} with every booking.",
            "descriptionEvents": "Browse the full schedule, pick hotels for every event, and support {{orgName}} with every booking.",
            "programLabel": "Program",
            "cta": "Start planning"
         },
         "heroVideo": {
            "play": "Watch our story"
         },
         "events": {
            "eyebrow": "Upcoming Events",
            "intro": "RSVP, find nearby hotels, and plan your trip for what's coming up.",
            "nextUp": "Next up",
            "more": "More events",
            "rsvp": "RSVP",
            "remindMe": "Remind me",
            "searchHotels": "Search hotels",
            "cta": "View event details"
         },
         "howItWorks": {
            "intro": "Same hotels, same prices — {{orgName}} gets {{percent}}% of proceeds."
         },
         "impactPanel": {
            "headline": "of proceeds go to {{orgName}}",
            "youBook": "You book a hotel",
            "weShare": "{{siteName}} shares proceeds"
         },
         "share": {
            "title": {
               "proceeds": "Book hotels to support {{supportName}}",
               "savings": "Save on hotels with {{orgName}}",
               "neutral": "Book hotels with {{orgName}}"
            },
            "description": {
               "proceeds": "{{orgName}} partners with {{siteName}}. When you book, we send 50% of proceeds to {{supportName}} - same hotels, same rates, real impact.",
               "savings": "{{orgName}} partners with {{siteName}}. Book the same hotels for less - lower prices on every booking.",
               "neutral": "{{orgName}} partners with {{siteName}}. Book your hotels for {{orgName}} trips in one place."
            },
            "sms": {
               "proceeds": "Support {{supportName}} with your next hotel booking at no extra cost to you",
               "savings": "Save on your next hotel booking with {{orgName}}",
               "neutral": "Book your next hotel with {{orgName}}"
            }
         },
         "sponsorModal": {
            "leavingTitle": "You are leaving {{siteName}}",
            "noProceedsTitle": "Proceeds will not be generated for {{orgName}}"
         },
         "quote": {
            "chips": {
               "proceeds": "Proceeds support {{orgName}}",
               "samePrices": {
                  "proceeds": "Same prices as anywhere",
                  "savings": "Lower prices than anywhere",
                  "neutral": "Hotels picked for your trip"
               },
               "hotels": "300+ Hotel brands"
            }
         },
         "eyebrows": {
            "howItWorks": "Getting started",
            "impact": "The impact",
            "benefits": "Why book here",
            "faq": "FAQ",
            "whatsNext": "What's next"
         },
         "impact": {
            "samePriceLabel": "Same Price As Other Sites",
            "proceedsLabel": "Proceeds To {{orgName}}",
            "proceedsToPrefix": "Proceeds To",
            "howTitle": "You Pay The Same Rate",
            "howSubtitle": "Here's where it actually goes",
            "adsLabel": "Other sites spend big on ads",
            "msrpLabel": "Hotels Sell Us Rooms at Wholesale Rates",
            "orgCashLabel": "We skip the ads and give that cash to {{orgName}}",
            "orgCashPrefix": "We skip the ads and give that cash to"
         },
         "season": {
            "schedule": "Season schedule",
            "yourSeason": "Your Season",
            "marqueeTitleLead": "Your season,",
            "marqueeTitleAccent": "on the marquee",
            "unifiedTitleLead": "Everything for your season,",
            "unifiedTitleAccent": "in one place",
            "fullSeason": "Full season",
            "restaurants": "{{count}} restaurants",
            "thingsToDo": "{{count}} things to do",
            "fromPerNight": "Rooms from ${{price}}/night",
            "planAll": "Plan all {{count}} games",
            "planAllEvents": "Plan all {{count}} events",
            "moreGuides": "+{{count}} more guides",
            "guideBadge": "Guide",
            "trackHotelPrices": "Track Hotel Prices",
            "tracking": "Tracking",
            "startPlanning": "Start Planning Your Season",
            "scrollBack": "Scroll back",
            "scrollAhead": "See more games",
            "noUpcoming": "No upcoming games on this schedule",
            "loading": "Loading the schedule…",
            "loadError": "We couldn't load the schedule right now.",
            "retry": "Try again"
         }
      },
      "addedit": {
         "proceeds": {
            "title": "Proceeds & Margin Split",
            "travelerView": "What the traveler sees",
            "viewProceeds": "Proceeds",
            "viewProceedsDescription": "Travelers see what their booking raises for the organization. A traveler share, if set, also lowers the price and shows as a saving.",
            "viewSavings": "Cost savings",
            "viewSavingsDescription": "Travelers see what they save, never the organization's share. Needs a traveler share above 0%. Savings under $5 per night per room are not advertised.",
            "viewNothing": "Nothing",
            "viewNothingDescription": "Travelers see neither proceeds nor savings. The organization still earns its share, and a traveler share still lowers the price.",
            "platformPct": "Platform %",
            "orgPct": "Organization proceeds %",
            "travelerPct": "Traveler share %",
            "travelerPctHelp": "The part of the margin passed back to the traveler as a lower price.",
            "sumError": "The three percentages must sum to 100",
            "costSavingsShareError": "Cost savings needs a traveler share above 0%. To advertise neither proceeds nor savings, choose Nothing.",
            "rangeError": "Each percentage must be between 0 and 100",
            "proceedsRateLabel": "Proceeds rate",
            "proceedsRateHelp": "Enter the percentage of booking proceeds (0 to 100) that goes to the organization. Defaults to 50%.",
            "previewToOrganization": "To Organization",
            "previewToPlatform": "To {{siteName}}",
            "previewToTraveler": "To Traveler (discount)",
            "resetToDefault": "Reset to Default",
            "splitHelp": "How each booking's margin is divided. The three values must total 100%.",
            "platformRequiredError": "The platform share must be above 0%. A 0% platform share is a booking that earns nothing."
         },
         "activateDescription": "Reactivating this organization will restore access for all associated members and reinstate full functionality. All previously retained data, memberships, and settings will become active immediately.",
         "activateTitle": "Activate this organization",
         "addOrganization": "Add Organization",
         "basicInfo": "Basic Info",
         "basicInfoDescription": "These are basic details needed to set up your new organization.",
         "branding": "Branding",
         "brandingDescription": "These are branding settings associated with your organization.",
         "changeImageSuccess": "Change image organization successfully",
         "changeStatusFail": "Change status organization fail",
         "changeStatusSuccess": "Change status organization successfully",
         "colorPrimaryDescription": "If set, this will be the primary color for CTAs, links, default avatars, header",
         "colorLightPrimaryDescription": "Hover dropdown item, price background when booking and others",
         "colorSecondaryDescription": "Background active, hover for CTAs, buttons",
         "colorCallToActionDescription": "Color of “Find a Room” button and the donation text",
         "confirmTitle": "Confirmation",
         "copiedName": "Copied organization's name to clipboard",
         "copiedSlug": "Copied organization's slug to clipboard",
         "count": "Count",
         "customHeader": "Custom Section Header",
         "customImage": "Custom Image",
         "customSubHeader": "Custom Section Sub Header",
         "customText": "Custom Section Text",
         "deactivateDescription": "Deactivating this organization will suspend access for all associated members; however, no user accounts or organizational data will be removed. Memberships, settings, and records will be retained, and the organization can be reactivated at any time to restore full access.",
         "deactivateTitle": "Deactivate this organization",
         "detailPage": "Details page",
         "detailPageDescription": "Update images follow template below for details page, search result",
         "editFail": "Update organization fail",
         "editOrganization": "Edit Organization",
         "editSuccess": "Update organization successfully",
         "getOrganizationsFail": "Get list organization unsuccessfully",
         "heroDescriptionLabel": "Hero Description",
         "landingPage": "Landing page",
         "landingPageDescription": "Update images and texts follow template below.",
         "lightPrimary": "Light Primary",
         "lightView": "Light View",
         "callToAction": "Call to Action",
         "tertiary": "Tertiary (Sidebar, navbar)",
         "headerText": "Top Nav Text",
         "heroText": "Hero Text",
         "logo": "Logo",
         "nameDescription": "This is any human-readable identifier for the organization that will be used by end-users to direct them to their organization in your application.",
         "namePlaceholder": "Enter a name identifier for this organization",
         "note": "Please click \"Add Member\" button to continue",
         "notification": "This Organization doesn't have any user yet",
         "organization": "Organization",
         "organizationId": "Organization ID",
         "overview": "Overview",
         "primary": "Primary",
         "saveFail": "Add new organization fail",
         "saveSuccess": "Add new organization successfully",
         "secondary": "Secondary",
         "slugDescription": "This will appear in the URL for the organization (like nonprofittrip.com/orgs/org-name). Use lowercase letters, numbers, and hyphens only.",
         "slugPlaceholder": "Enter a slug identifier for this organization",
         "status": "Status",
         "user": "User",
         "whiteLogo": "White Logo",
         "cancel": "No, Thanks",
         "confirm": "Yes, I’m sure",
         "program": "Program",
         "addProgram": "Add Program",
         "createProgram": "Create Program",
         "programDescription": "Add which program you'd like to support",
         "programPicker": "Program Picker",
         "programPickerDescription": "Control how travelers choose which program their proceeds support.",
         "hideGeneralFund": "Hide General Fund",
         "hideGeneralFundDescription": "Remove the site-wide General Fund from the program picker. Ignored if this organization has no active programs of its own.",
         "programHelperText": "Picker Help Text",
         "programHelperTextDescription": "Shown with the program picker. Leave empty to use the default text.",
         "heroBannerLabel": "Add background color for Hero banner",
         "angleControl": "Angle Control",
         "heroHeading": "Hero Heading",
         "guidingTitle": "How it works",
         "beneficiary": "Beneficiary",
         "beneficiaryDescription": "Optional. If set, this name replaces the nickname in proceeds messaging (e.g. Make-a-Wish).",
         "beneficiaryPlaceholder": "e.g. Make-a-Wish",
         "officialHotelSponsorId": "Official Hotel Sponsor ID",
         "officialHotelSponsorIdPlaceholder": "e.g. grand_hyatt_denver",
         "officialHotelSponsorBookingUrl": "Official Hotel Sponsor Booking URL",
         "officialHotelSponsorBookingUrlPlaceholder": "https://www...",
         "preferredHotelIds": "Preferred Hotel IDs",
         "preferredHotelIdsPlaceholder": "e.g. hotel_id_1, hotel_id_2, hotel_id_3",
         "preferredHotelIdsDescription": "Comma-separated list of hotel IDs that will display a \"Preferred Partner\" badge in search results.",
         "previewHotelId": "Preview Hotel ID",
         "customizeTextForBenefit": "Customize Text for Benefit",
         "commissionText": "Commission Text",
         "defaultCommissionText": "Default Text",
         "customComissionText": "Custom Text (optional)",
         "enterCustomTextPlaceholder": "Enter custom text here (Optional, overrides default)",
         "hotelpartnerTicker": "Hotel Partner Ticker Logo on Hero Banner",
         "hierarchy": "Hierarchy",
         "schedule": "Schedule",
         "payoutRouting": "Payout Routing",
         "payoutRoutingDescription": "Control how proceeds payouts are routed between the club and its chapters.",
         "payoutConsolidation": "Consolidate Chapter Payouts",
         "payoutConsolidationDescription": "Roll every chapter's proceeds into a single club-level payout to {{orgName}}. Chapters can opt out individually.",
         "payoutOptOut": "Opt Out of Club Consolidation",
         "payoutOptOutDescription": "{{orgName}} keeps receiving its payout directly instead of being included in the club-level payout.",
         "chapterManagement": "Chapter Management",
         "chapterManagementDescription": "Manage local chapters linked to this national organization.",
         "singleEventNoHierarchy": "Single Event organizations are standalone: they can't have chapters or be a chapter of another organization.",
         "singleEventHasParent": "Single Event organizations can't be a chapter. Remove the parent organization to keep this type.",
         "singleEventInvariants": {
            "SINGLE_EVENT_NO_PARENT": "A Single Event organization cannot have a parent organization.",
            "SINGLE_EVENT_NO_CHILDREN": "A Single Event organization cannot have child organizations (chapters).",
            "SINGLE_EVENT_ONE_EVENT": "A Single Event organization cannot have more than one active event.",
            "SINGLE_EVENT_NO_SCHEDULE": "A Single Event organization cannot have a schedule or season plan."
         },
         "parentOrganization": "Parent Organization",
         "parentOrganizationDescription": "This organization is a chapter of the parent shown below.",
         "addChapter": "Add Chapter",
         "removeChapter": "Remove",
         "changeParent": "Change Parent",
         "removeParent": "Remove Parent",
         "searchOrganizations": "Search organizations...",
         "noChapters": "No chapters linked yet.",
         "selectOrganization": "Select Organization",
         "hierarchyUpdated": "Hierarchy updated successfully",
         "hierarchyUpdateFailed": "Failed to update hierarchy",
         "photosInherited": {
            "badge": "Inherited from the club.",
            "hint": "This chapter has no photos of its own, so it shows the club's. Add or remove a photo to give it its own set; delete them all to go back to the club's."
         },
         "viewLivePage": "View live page",
         "organizationType": {
            "label": "Organization type",
            "description": "What kind of organization this is. The season planner and landing page adapt to the type. It does not affect proceeds or payouts.",
            "youthSports": "Youth Sports",
            "youthSportsDescription": "Club or travel teams whose families follow a game schedule.",
            "university": "University",
            "universityDescription": "College athletics departments and their fan and alumni travel.",
            "greekLife": "Greek Life",
            "greekLifeDescription": "Fraternities and sororities traveling for chapter and national events.",
            "communityNonprofit": "Community Nonprofit",
            "communityNonprofitDescription": "Nonprofits without a season, whose supporters travel and give year round.",
            "singleEvent": "Single Event",
            "singleEventDescription": "A standalone page for one event. It has a single active event and no chapters or parent organization."
         },
         "teamHotels": {
            "preferAmendableHelp": "Rank hotels whose rates can be changed after booking (dates, guest names) higher, for schedules that move. Never hides a hotel.",
            "preferAmendable": "Prefer changeable rates",
            "tab": "Team Hotels",
            "title": "Team hotel preferences",
            "description": "What this organization wants from a hotel, and how big a block its teams need. We use this to rank hotels for families and to pick team, budget and luxury hotels automatically. Chapters inherit these settings from their club unless they set their own.",
            "weightsNote": "Preferences rank hotels; they do not hide them. Only the never-book lists and the adults-only setting remove a hotel from suggestions and search.",
            "bandLabel": "Quality band",
            "band": {
               "economy": "Economy",
               "economyDescription": "Lowest price wins. Roadside and budget brands rank as well as any.",
               "economyExample": "Super 8, Days Inn",
               "midscale": "Midscale",
               "midscaleDescription": "Dependable mid-tier brands. Where most youth sports travel happens.",
               "midscaleExample": "Comfort Inn, Hampton",
               "upscale": "Upscale",
               "upscaleDescription": "Nicer hotels throughout. Economy brands rank well below.",
               "upscaleExample": "Holiday Inn, Courtyard",
               "luxury": "Luxury",
               "luxuryDescription": "Full-service hotels first, at every tier.",
               "luxuryExample": "Marriott, Westin"
            },
            "bandHelp": "Brands one tier below this band rank lower, and two or more below rank lower still. It is one factor among several. Independent hotels are neither helped nor penalized by this setting.",
            "blockTitle": "The room block",
            "blockSize": "Rooms the team needs",
            "blockSizeHelp": "A team hotel we cannot confirm has this many rooms is still suggested, flagged so you can check the block with the hotel.",
            "roomsSuffix": "rooms",
            "adultsPerRoom": "Adults per room",
            "adultsSuffix": "adults",
            "childrenPerRoom": "Children per room",
            "childrenPerRoomHelp": "Priced at ages 10 and 12. Youth teams usually travel as two adults and two children.",
            "childrenSuffix": "children",
            "blockPreview": "Searching for {{rooms}} rooms, sleeping about {{people}} people.",
            "multiBed": "Prefer rooms with multiple beds",
            "multiBedHelp": "Favors two-queen style rooms, or a bed plus a sofa bed, over a single king. Guides the ranking rather than ruling hotels out.",
            "freeCancellation": "Prefer free cancellation",
            "freeCancellationHelp": "Team hotel picks rank hotels with a refundable rate higher and show that rate. Hotels with only non-refundable rates can still be picked, lower in the list. Traveler search is not affected.",
            "excludeAdultsOnly": "Exclude adults-only hotels",
            "excludeAdultsOnlyHelp": "Hotels that do not admit children are removed from suggestions and from what families see. On by default for youth sports organizations.",
            "limitsTitle": "Preferences",
            "maxDistance": "Maximum distance from the venue",
            "maxDistanceHelp": "We'll show your families hotels within this distance of the venue, so everyone stays close to the action. Up to {{max}}.",
            "maxDistanceError": "Please choose a distance of {{max}} or less to keep your team close to the venue.",
            "milesSuffix": "miles",
            "kmSuffix": "km",
            "minStars": "Preferred minimum stars (ranks lower, does not hide)",
            "minStarsHelp": "Hotels under this rank lower on every surface and in suggestions. Hotels with no star rating always rank after rated ones, whatever this is set to. Leave at 0 for no preference.",
            "minGuestRating": "Preferred minimum guest rating (ranks lower, does not hide)",
            "minGuestRatingHelp": "Out of 5. Hotels under this rank lower; hotels with no rating are not penalized.",
            "maxNightlyRate": "Preferred nightly rate ceiling (ranks lower, does not hide)",
            "maxNightlyRateHelp": "Hotels over this rank lower, the further over the lower. Leave blank for no preference.",
            "brandsTitle": "Brands and hotels",
            "preferredChains": "Preferred brands",
            "preferredChainsHelp": "Comma separated. These rank higher, they are not required.",
            "blockedChains": "Never book these brands",
            "blockedChainsHelp": "Comma separated. These are never offered, whatever they earn us.",
            "blockedHotels": "Never book these hotels",
            "blockedHotelsHelp": "Comma separated hotel ids.",
            "amenities": "Required amenities",
            "amenitiesHelp": "A missing amenity counts against a team hotel and is flagged for you. Only judged for hotels whose amenity data we actually have.",
            "amenity": {
               "breakfast": "Breakfast",
               "parking": "Parking",
               "pool": "Pool",
               "laundry": "Laundry",
               "gym": "Gym",
               "shuttle": "Shuttle"
            },
            "rangeError": "Must be between {{min}} and {{max}}",
            "integerError": "Must be a whole number",
            "conflictError": "A brand cannot be both preferred and never-book"
         }
      }
   },
   "footer": {
      "allRightsReserved": "All rights reserved.",
      "justGoodTravel": "Just Good Travel, Inc.",
      "license": "License",
      "privacy": "Privacy",
      "tripSupport": "Trip support",
      "supportHours": "Weekdays 9am to 5pm CT. 24/7 for urgent issues during your stay.",
      "clearRates": "Book hotels for your whole team in one place — clear rates, one link.",
      "company": "Company",
      "support": "Support"
   },
   "No results": "No results",
   "Search": "Search",
   "defaultConfiguration": {
      "heroHeader": "Committed to conserving nature for life.",
      "heroDescription": "{{orgName}} protects the natural and open spaces of northeastern Illinois and the surrounding region to ensure cleaner air and water, protect natural habitats and wildlife, and help balance and enrich our lives.",
      "heroHeaderMobile": "Committed to conserving nature for life.",
      "heroDescriptionMobile": "{{orgName}} protects the natural and open spaces of northeastern Illinois and the surrounding region to ensure cleaner air and water, protect natural habitats and wildlife, and help balance and enrich our lives.",
      "firstStep": "Search top hotels",
      "firstStepSub": "Over 3 million properties from all major brands you love",
      "secondStep": "Book the best rates",
      "secondStepSub": {
         "proceeds": "We charge you the same rate you pay elsewhere",
         "savings": "We charge you less than the rate you pay elsewhere",
         "neutral": "Hotels near the action, picked for your trip"
      },
      "thirdStep": {
         "proceeds": "{{programName}} get {{percent}}%",
         "savings": "You pay less",
         "neutral": "Travel together"
      },
      "thirdStepSub": {
         "proceeds": "We share the proceeds with {{programName}} - no extra cost to you",
         "savings": "We pass part of the margin back to you as a lower price",
         "neutral": "Everyone books from the same list of curated hotels"
      },
      "sectionSubDescription": "With over 60 years of strong experience in serving people and nature, our experts share their vision and lessons learned for a more sustainable future.",
      "helperText": {
         "proceeds": "You can choose a program to support or have proceeds benefit the general fund",
         "savings": "You can choose a program. Pricing is the same either way.",
         "neutral": "You can choose a program. Pricing is the same either way."
      }
   },
   "ssrMeta": {
      "organization": {
         "title": {
            "proceeds": "{{orgName}} on {{siteName}} - Book hotels at the same prices to support {{orgName}}",
            "savings": "{{orgName}} on {{siteName}} - Save on hotels with {{orgName}}",
            "neutral": "{{orgName}} on {{siteName}} - Book hotels with {{orgName}}"
         },
         "description": {
            "proceeds": "Book hotels and 50% of proceeds support {{orgName}}. Same prices, same hotels, more impact.",
            "savings": "Book hotels with {{orgName}} for less than you pay elsewhere.",
            "neutral": "Book hotels with {{orgName}} on {{siteName}}."
         }
      },
      "hotels": {
         "title": {
            "proceeds": "Hotels supporting {{orgName}}",
            "savings": "Hotels for less with {{orgName}}",
            "neutral": "Hotels with {{orgName}}"
         },
         "titleInPlace": {
            "proceeds": "Hotels in {{placeName}} supporting {{orgName}}",
            "savings": "Hotels in {{placeName}} for less with {{orgName}}",
            "neutral": "Hotels in {{placeName}} with {{orgName}}"
         },
         "description": {
            "proceeds": "Browse hotels and 50% of proceeds support {{orgName}}. Same prices, same hotels, more impact.",
            "savings": "Browse hotels with {{orgName}} for less than you pay elsewhere.",
            "neutral": "Browse hotels with {{orgName}}."
         },
         "descriptionInPlace": {
            "proceeds": "Browse hotels in {{placeName}}. Same prices, same hotels, and 50% of proceeds support {{orgName}}.",
            "savings": "Browse hotels in {{placeName}} with {{orgName}} for less than you pay elsewhere.",
            "neutral": "Browse hotels in {{placeName}} with {{orgName}}."
         }
      },
      "hotel": {
         "description": {
            "proceeds": "Book {{hotelName}} on {{siteName}}: same prices, same hotel, and 50% of proceeds support {{orgName}}.",
            "savings": "Book {{hotelName}} on {{siteName}} with {{orgName}} for less than you pay elsewhere.",
            "neutral": "Book {{hotelName}} on {{siteName}} with {{orgName}}."
         }
      },
      "event": {
         "description": {
            "proceeds": "Join {{orgName}} for {{eventName}}. Book your hotel through {{siteName}} and 50% of proceeds support the cause.",
            "savings": "Join {{orgName}} for {{eventName}}. Book your hotel through {{siteName}} for less than you pay elsewhere.",
            "neutral": "Join {{orgName}} for {{eventName}}. Book your hotel through {{siteName}}."
         }
      },
      "plan": {
         "description": {
            "proceeds": "Plan your hotels for the whole season supporting {{orgName}}. Book at the same prices you see elsewhere, and about half of every booking supports the cause.",
            "savings": "Plan your hotels for the whole season with {{orgName}}, for less than you pay elsewhere.",
            "neutral": "Plan your hotels for the whole season with {{orgName}} in one place."
         },
         "descriptionForTeam": {
            "proceeds": "Plan your hotels for every {{team}} game this season in one place. Book at the same prices you see elsewhere, and about half of every booking supports {{orgName}}.",
            "savings": "Plan your hotels for every {{team}} game this season in one place, for less than you pay elsewhere.",
            "neutral": "Plan your hotels for every {{team}} game this season in one place."
         }
      },
      "game": {
         "where": " in {{placeName}}",
         "descriptionNoOrg": "Traveling for {{matchup}}? Your game-day guide: where to stay, eat, and explore{{where}}. Book a hotel.",
         "description": {
            "proceeds": "Traveling for {{matchup}}? Your game-day guide: where to stay, eat, and explore{{where}}. Book a hotel and support {{orgName}}.",
            "savings": "Traveling for {{matchup}}? Your game-day guide: where to stay, eat, and explore{{where}}. Book a hotel and save with {{orgName}}.",
            "neutral": "Traveling for {{matchup}}? Your game-day guide: where to stay, eat, and explore{{where}}. Book a hotel with {{orgName}}."
         }
      }
   },
   "revenueFlow": {
      "revenue": "WHERE YOUR DOLLARS GO",
      "title": "You pay the same rate.",
      "subtitle": "Here's where it actually goes.",
      "otherSitesTitle": "Other travel sites",
      "ourSiteTitle": "{{siteName}}",
      "segHotel": "Hotel cost",
      "segAds": "Ads",
      "segOperations": "Operations",
      "footnote": "Hotels sell rooms at wholesale. Online travel sites mark them up to MSRP. We skip the ad spend so the margin reaches {{orgName}} instead, at no extra cost to you.",
      "dismiss": "Dismiss"
   },
   "dragFileDescription": "Drag & Drop your file or",
   "myFavorites": {
      "saved": "Saved hotels",
      "findRoom": "Find a Room"
   },
   "trip": {
      "cancelOffer": {
         "keepProceeds": "Keeping your booking still raises {{amount}} for {{orgName}}.",
         "savings": "Your new rate is {{amount}} below the public price.",
         "proceeds": "Your new booking still raises {{amount}} for {{orgName}}.",
         "checkingTitle": "Checking today’s price",
         "checking": "Checking today’s price for your room...",
         "title": "We found you a lower price",
         "body": "We can rebook you at {{price}} (save {{saving}}). Your new booking is also free to cancel.",
         "detail": "Same hotel, same dates, same room. You keep your current booking until the new one is confirmed, and you can review the change before anything happens.",
         "rebook": "Rebook at {{price}}",
         "cancelAnyway": "Cancel anyway",
         "notCheaperTitle": "Our price hasn’t dropped",
         "notCheaper": "Today’s price for your room isn’t lower than what you paid.",
         "refund": "If you cancel, you’ll get {{amount}} back.",
         "refundPolicy": "If you cancel, any refund follows the cancellation policy of your booking.",
         "continueCancel": "Cancel booking"
      },
      "modify": {
         "override": {
            "label": "Reason for changing after the deadline",
            "help": "This booking is inside the 24-hour change cutoff. Admins can still change it; the reason is kept on the change history.",
            "required": "Enter a reason"
         },
         "stay": {
            "button": "Change room or guests",
            "hint": "Pick another room, or change the number of guests or the dates.",
            "title": "Change your stay",
            "searchTitle": "What would you like?",
            "adults": "Adults",
            "children": "Children",
            "childAge": "Age of child {{number}}",
            "selectAge": "Select age",
            "add": "Add",
            "remove": "Remove",
            "search": "See available rooms",
            "searching": "Looking for rooms...",
            "roomsTitle": "Available rooms",
            "refundableOnly": "Only fully refundable rates are shown, so you can still change or cancel for free.",
            "noRooms": "No fully refundable rooms are available for these dates and guests. Try other dates.",
            "currentRoom": "Your current room",
            "freeUntil": "Free cancellation until {{date}}",
            "choose": "Choose",
            "chooseRoom": "Choose {{room}}",
            "guestsTitle": "Who's staying?",
            "guestsIntro": "Enter a name for every guest, as on their ID.",
            "continue": "Continue",
            "reviewTitle": "Review your change",
            "currentStay": "Currently booked",
            "newStay": "New stay",
            "room": "Room",
            "guestsSummary": "{{adults}} adults, {{children}} children",
            "currentGuests": "Current guests",
            "newGuests": "New guests",
            "newCancellation": "Your new booking can be cancelled for free until {{date}}.",
            "newCancellationUnknown": "The cancellation policy for your new booking will be in your updated confirmation.",
            "processing": "Updating your booking with the hotel. This can take a minute. Please keep this page open.",
            "success": "Your booking is updated. We've emailed you an updated confirmation.",
            "pending": "The hotel is still confirming your change. We'll email you once it's done. Until then your current booking stays as it is.",
            "rejected": "The hotel couldn't make this change, so your booking stays as it was and nothing was charged.",
            "searchAgain": {
               "PRICE_CHANGED": "The price of this room changed. Please choose again.",
               "NO_AVAILABILITY": "This room is no longer available for these dates. Please choose another room.",
               "QUOTE_EXPIRED": "These prices have expired. Please search again."
            },
            "priceChanged": "The price of this room changed while you were reviewing. Please check the new amount before confirming.",
            "fromDates": "The dates of this booking need a new reservation at the hotel. See the rooms available for those dates?",
            "seeRooms": "See rooms for these dates",
            "historyTitle": "Changes to this booking",
            "historyEntry": "Changed on {{date}}",
            "historyBefore": "Before",
            "historyAfter": "After",
            "historySettling": "The price difference is still being processed."
         },
         "wizard": {
            "title": "Change booking",
            "subtitle": "Change the dates, room or number of guests at {{hotel}}.",
            "backToTrip": "Back to your trip",
            "cancel": "Cancel",
            "progress": "Step {{current}} of {{total}}: {{label}}",
            "steps": {
               "stay": "Your stay",
               "rooms": "Room",
               "guests": "Guests",
               "review": "Review"
            },
            "loadError": "We couldn't load this booking. Please try again in a few minutes.",
            "notEligibleTitle": "This booking can't be changed online",
            "stay": {
               "nonRefundable": "This booking is non-refundable, but the hotel lets you change its dates. Only the dates can change: the room and guests stay as they are, the new stay is non-refundable too, and the hotel may charge a difference.",
               "datesOnly": "Pick new dates. The room and guests of this booking can't change.",
               "heading": "What would you like to change?",
               "intro": "Pick new dates, change the number of guests, or leave both as they are to switch rooms. You'll see your options and the exact price difference before anything changes.",
               "current": "Currently booked",
               "dates": "Dates",
               "guests": "Guests",
               "room": "Room",
               "price": "Current total",
               "continue": "See my options",
               "searching": "Checking with the hotel...",
               "sameStayHint": "Want a different room for the same dates? Leave everything as it is and select See my options.",
               "namesOnly": "Only need to fix a guest's name?",
               "namesLink": "Edit guest names",
               "namesHint": "Fix a misspelling or add a guest's name. Your dates, room and price stay the same.",
               "nonRefundableAdmin": "This booking isn't free to cancel, so only its dates can change, through the hotel's own amendment. The room and guests stay as they are.",
               "datesOnlyAdmin": "Pick new dates. The room and guests of this booking can't change.",
               "guestsContactSupport": "To change the number of guests on this booking, please contact support.",
               "underOne": "Under 1"
            },
            "how": {
               "title": "How changes work",
               "amend": "Sometimes the hotel can simply move your reservation to the new dates. Your confirmation number stays the same.",
               "rebook": "Otherwise we book your new room first and only then cancel your current reservation, for free. You're never left without a room.",
               "refundable": "New rooms we book for you are always fully refundable. If the hotel moves your current reservation instead, we show you its cancellation terms before you confirm.",
               "price": "You only pay the difference, or get it back."
            },
            "rooms": {
               "heading": "Choose your room",
               "keepTitle": "Keep your room",
               "keepBadge": "Same reservation",
               "keepBody": "The hotel can move your current reservation to these dates. Your confirmation number stays the same.",
               "keepChoose": "Keep my room",
               "otherTitle": "Or choose a new room",
               "otherIntro": "Another room means a new reservation: we book it first, then cancel your current one for free.",
               "why": {
                  "hotelCantMove": "The hotel can't move your current reservation to these dates, so this change is made as a new reservation. We book your new room first, then cancel your current one for free.",
                  "guests": "A different number of guests needs a new reservation. We book your new room first, then cancel your current one for free.",
                  "room": "Another room means a new reservation. We book your new room first, then cancel your current one for free.",
                  "dates": "New dates are booked as a new reservation. We book your new room first, then cancel your current one for free."
               },
               "choose": "Choose this room",
               "total": "New total {{amount}}",
               "options": "Options for this room",
               "otherRoomsFailed": "We couldn't load other rooms just now. You can still keep your room, or try again later.",
               "keepReservationTitle": "Keep your reservation",
               "keepBodyNewRoom": "The hotel can move your reservation to these dates, in a different room. Your confirmation number stays the same.",
               "keepNotFreeHint": "Prefer to stay fully refundable? Choose a new room below.",
               "otherRoomsNeedAges": "To see other rooms, go back and enter each child's age.",
               "roomOnly": "Room only",
               "sameRoomType": "Same room type as now",
               "diffMore": "{{amount}} more",
               "diffLess": "{{amount}} back",
               "noDiff": "No change in price"
            },
            "guests": {
               "heading": "Who's staying?",
               "intro": "Add every adult who might check in. Only the lead guest's name is required.",
               "optional": "optional",
               "bothNames": "Enter a first and last name, or leave both empty",
               "continue": "Review change"
            },
            "review": {
               "changeability": {
                  "changeable": "The hotel may allow changes to the new stay's dates or guest names later, subject to availability and any price difference.",
                  "fixed": "The new stay can't be changed after it's booked.",
                  "losesTitle": "Your new booking can't be changed again",
                  "losesBody": "Your current booking lets you change its dates. The new rate doesn't: once it's booked, its dates, room and guests can't be changed.",
                  "losesAck": "I understand the new booking can't be changed after it's booked."
               },
               "heading": "Review your change",
               "howTitle": "What happens when you confirm",
               "amend1": "We ask the hotel to move your current reservation to the new dates.",
               "amend2": "Your confirmation number stays the same, and we email you an updated confirmation.",
               "amendSafety": "If the hotel can't make the change, your current reservation stays as it is and nothing is charged.",
               "rebook1": "We book your new room at the hotel.",
               "rebook2": "Once it's confirmed, we cancel your current reservation. That cancellation is free.",
               "rebook3": "Your booking keeps the same reference in My Trips. The hotel issues a new confirmation number, which we email you, sometimes a few hours later.",
               "rebookSafety": "If the hotel can't confirm the new room, nothing changes: your current reservation stays as it is and nothing is charged.",
               "methodAmend": "Same reservation, new dates",
               "methodRebook": "New reservation",
               "newStay": "Your new stay",
               "cancellationTitle": "Cancellation policy",
               "freeUntil": "Fully refundable. Free cancellation until {{date}}.",
               "freeUnknown": "Fully refundable. The exact deadline will be in your updated confirmation.",
               "summary": "Price summary",
               "paid": "Current total",
               "newTotal": "New total",
               "difference": "Difference",
               "confirm": "Confirm change",
               "notCharged": "Nothing is charged until you confirm.",
               "extraToPay": "Extra to pay",
               "youGetBack": "You get back",
               "noDifference": "Price difference",
               "guestNames": "Guest names"
            },
            "outcome": {
               "completed": "Your booking is updated",
               "pending": "Your change is being confirmed",
               "rejected": "Your booking stays as it was",
               "declined": "Your card was declined",
               "pendingCard": "The hotel is still confirming your change. This usually takes less than an hour. Your current reservation stays valid until then. You may see a temporary hold for the price difference on your card; it's released if the change doesn't go through. We'll email you either way.",
               "pendingInvoice": "The hotel is still confirming your change. This usually takes less than an hour. Your current reservation stays valid until then, and nothing is added to the invoice unless the change goes through. We'll email you either way.",
               "refundTiming": "Your refund of {{amount}} will reach your card within 5 to 10 business days.",
               "previousCancelled": "Your previous reservation is cancelled for free. You don't need to do anything about it.",
               "canStillChange": "You can still change or cancel this booking from My Trips."
            },
            "admin": {
               "charge": "The traveller's card ending {{last4}} will be charged an additional {{amount}}.",
               "chargeNoCard": "The card on this booking will be charged an additional {{amount}}.",
               "refund": "{{amount}} will be refunded to the traveller's card ending {{last4}} within 5 to 10 business days.",
               "refundNoCard": "{{amount}} will be refunded to the card on this booking within 5 to 10 business days.",
               "notCharged": "Nothing is charged until you confirm. The traveller gets the updated confirmation by email.",
               "declined": "The traveller's card was declined, so nothing was changed. Ask them to update their card in Payment methods, then try again.",
               "refundTiming": "The refund of {{amount}} reaches the traveller's card within 5 to 10 business days.",
               "canStillChange": "The booking can still be changed or cancelled from Manage Trips.",
               "pendingCard": "The hotel is still confirming the change. The traveller's current reservation stays valid until then, and their card may show a temporary hold for the difference. We email them either way.",
               "pendingInvoice": "The hotel is still confirming the change. The current reservation stays valid until then, and nothing is added to the invoice unless the change goes through. We email the traveller either way.",
               "success": "The booking is updated. We've emailed the traveller an updated confirmation.",
               "backToTrip": "Back to the trip"
            },
            "agreement": {
               "newStayChangeability": {
                  "changeable": "Date changes to the new stay may be allowed later, subject to the hotel's approval, availability and any price difference.",
                  "fixed": "The new stay can't be changed after this change: no changes to dates, room or guests.",
                  "unknown": "Whether the new stay can be changed later depends on the hotel; contact support to ask.",
                  "loses": "The booking being changed allowed date changes. The new stay does not: after this change, its dates, room and guests can't be changed."
               },
               "labelStart": "I have read and agree to the ",
               "required": "Please check the box to accept the agreement for this change.",
               "charge": {
                  "card": "We will charge the difference of {{amount}} to your card ending {{last4}} once the change is confirmed.",
                  "noCard": "We will charge the difference of {{amount}} to your card once the change is confirmed."
               },
               "refund": {
                  "card": "We will refund the difference of {{amount}} to your card ending {{last4}} once your original payment has settled. Your card issuer decides when the refund appears.",
                  "noCard": "We will refund the difference of {{amount}} to your card once your original payment has settled. Your card issuer decides when the refund appears."
               },
               "noDifference": "The price does not change.",
               "roomChange": "On the new dates the hotel moves you to a different room.",
               "warningNoRefund": "The new dates are not free to cancel. If you cancel after this change, you will not get a refund.",
               "warningPartial": "If you cancel after this change, you will only get part of your payment back, as shown above."
            }
         },
         "button": "Change booking",
         "menuTitle": "What would you like to change?",
         "changeStay": "Change dates, room or guests",
         "changeStayHint": "See your options and the price difference, step by step.",
         "cardButton": "Change booking",
         "changeDates": "Change dates",
         "changeDatesHint": "Move your check-in, check-out, or both.",
         "editNames": "Edit guest names",
         "editNamesHint": "Update who is staying on this booking.",
         "editNamesSupportHint": "We'll send this to the hotel and email you to confirm once it's done.",
         "editNamesSupportSent": "Your guest name change is with the hotel. We'll email you to confirm once it's done.",
         "roomOrGuests": "To change the room or the number of guests, please contact support.",
         "inProgress": "A change to this booking is being processed. You can make another change once it's done.",
         "close": "Close",
         "back": "Back",
         "genericError": "Something went wrong. Please try again in a few minutes.",
         "reasons": {
            "UNSUPPORTED_PROVIDER": "This booking can't be changed online. Please contact support.",
            "NOT_CONFIRMED": "This booking is still being confirmed with the hotel. Please try again in a few minutes.",
            "NOT_ACTIVE": "This booking can no longer be changed.",
            "CHECKIN_PASSED": "Changes can't be made after check-in. Please contact support.",
            "PAYMENT_STATE": "This booking can't be changed while a payment or refund is being processed.",
            "INVOICE_BOOKING": "This booking was paid by invoice. Please contact support to change it.",
            "MODIFICATION_IN_PROGRESS": "Another change to this booking is still being processed.",
            "CANCEL_IN_PROGRESS": "This booking is being cancelled, so it can't be changed.",
            "NOT_ALLOWED_BY_SUPPLIER": "The hotel doesn't allow this change online. Please contact support.",
            "SUPPLIER_UNAVAILABLE": "We couldn't reach the hotel just now. Please try again in a few minutes.",
            "NON_REFUNDABLE": "This booking can no longer be changed online. Dates, room, and guests can only be changed while the booking can still be cancelled for free.",
            "PAST_CUTOFF": "Changes had to be made by {{date}}. Please contact support.",
            "MULTI_ROOM": "Guest names on a booking with more than one room can't be changed online. Please contact support.",
            "NO_AVAILABILITY": "The hotel has no availability for those dates. Try different dates.",
            "UNCHANGED_DATES": "Those are the dates you already have.",
            "INVALID_DATES": "Check-out must be after check-in, and check-in can't be in the past.",
            "REBOOK_REQUIRED": "The dates of this booking can't be changed online yet. Please contact support.",
            "DATE_CHANGE_DISABLED": "Changing dates online isn't available yet. Please contact support.",
            "CARD_REQUIRED": "There's no saved card on this booking to cover a price difference. Please contact support.",
            "QUOTE_NOT_ACTIVE": "This price is no longer available. Please review the change again.",
            "ORIGINAL_NOT_FREE": "This booking can no longer be changed online, because it is past its free cancellation. Please contact support.",
            "NON_REFUNDABLE_RATE": "Only fully refundable rates can be chosen. Please pick another room.",
            "NR_CHANGE_LOWER_PRICE": "This booking is non-refundable, so it can only move to dates that cost the same or more. Try other dates, or contact us for help.",
            "INVALID_GUESTS": "Enter the lead guest's first and last name. For other guests, fill in both names or leave both empty.",
            "REBOOK_DISABLED": "This change isn't available online yet. Please contact support.",
            "ORIGINAL_CANCEL_FAILED": "The hotel couldn't make this change, so your booking stays as it was.",
            "PRICE_CHANGED": "The price changed. Please review the change again.",
            "QUOTE_EXPIRED": "These prices have expired. Please search again.",
            "CHILD_AGES_REQUIRED": "Enter the age of each child so the hotel can price the room.",
            "default": "This change can't be made online. Please contact support."
         },
         "support": {
            "button": "Ask support to make this change",
            "buttonStandalone": "Submit request",
            "sent": "Request sent",
            "title": "Ask support to make this change",
            "intro": "This opens a conversation with our support team. Edit the message if you like; replies go to your email.",
            "subjectLabel": "Subject",
            "messageLabel": "Message",
            "subject": "Change request for booking {{ref}}",
            "required": "This can't be empty",
            "tooLong": "Please keep this under {{max}} characters",
            "send": "Send to support",
            "cancel": "Cancel",
            "success": "Sent. Replies will go to {{email}}.",
            "reference": "Reference: {{id}}",
            "existing": "You already sent this request. Replies will go to {{email}}.",
            "unavailable": "Support requests aren't available right now. Please try again later.",
            "tooMany": "You've sent several requests recently. Please wait a while before sending another.",
            "nonRefundable": {
               "title": "Request a cancellation or change",
               "intro": "This booking is non-refundable, so it can't be cancelled or changed online. Send us a request and we'll ask the hotel.",
               "subject": "Cancellation or change request for booking {{ref}}",
               "message": {
                  "intro": "Hello, I'd like to cancel or change my booking {{ref}} at {{hotel}} ({{dates}}).",
                  "introNoHotel": "Hello, I'd like to cancel or change my booking {{ref}} ({{dates}}).",
                  "closing": "Could you ask the hotel what's possible? Here's what I'd like:"
               }
            },
            "names": {
               "title": "Edit guest names",
               "intro": "Enter each guest's name as it appears on their ID. We'll send this to the hotel and email you to confirm once it's done.",
               "label": "Guest names",
               "help": "One guest per line, lead guest first.",
               "required": "Enter at least one guest name",
               "subject": "Guest name change for booking {{ref}}",
               "success": "Thanks. We're sending this to the hotel and will email you at {{email}} to confirm once it's done.",
               "message": {
                  "intro": "Hello, I'd like to change the guest names on my booking {{ref}} at {{hotel}} ({{dates}}).",
                  "introNoHotel": "Hello, I'd like to change the guest names on my booking {{ref}} ({{dates}}).",
                  "closing": "Could you ask the hotel to update them to the names below? Thank you."
               }
            },
            "message": {
               "intro": "Hello, I'd like to change my booking {{ref}} at {{hotel}} ({{dates}}).",
               "introNoHotel": "Hello, I'd like to change my booking {{ref}} ({{dates}}).",
               "dates": "New dates requested: {{checkIn}} to {{checkOut}}.",
               "names": "Guest names requested: {{names}}.",
               "stay": "Requested: {{guests}}, {{checkIn}} to {{checkOut}}.",
               "refusal": "The site said: \"{{refusal}}\"",
               "closing": "Could you make this change for me? Thank you."
            }
         },
         "names": {
            "title": "Edit guest names",
            "intro": "Enter names as they appear on each guest's ID.",
            "leadGuest": "Lead guest",
            "guest": "Guest {{number}}",
            "childGuest": "Guest {{number}} (child)",
            "leadAdult": "Adult 1 · Lead guest",
            "adultOptional": "Adult {{number}} (optional)",
            "childOptional": "Child {{number}} (optional)",
            "firstName": "First name",
            "lastName": "Last name",
            "help": "Accents, apostrophes and hyphens are fine. The hotel receives names in plain letters, so O'Brien is sent as OBrien.",
            "required": "Enter a name",
            "latinOnly": "Use Latin letters, as on the guest's ID",
            "save": "Save names",
            "success": "Guest names updated. We've emailed you an updated confirmation.",
            "pending": "The hotel is processing your change. We'll email you once it's done.",
            "rejected": "The hotel couldn't accept this change. Please contact support."
         },
         "dates": {
            "nonRefundable": {
               "note": "Non-refundable: the hotel lets you change the dates of this booking. Cancelling would still forfeit the stay."
            },
            "title": "Change dates",
            "currentStay": "Currently booked",
            "newDates": "New dates",
            "pickDates": "Select check-in and check-out",
            "deadline": "Changes can be made online until {{date}}.",
            "review": "Review change",
            "reviewTitle": "Review your change",
            "newStay": "New stay",
            "nights_one": "{{count}}\u00a0night",
            "nights_other": "{{count}}\u00a0nights",
            "currentPrice": "Current price",
            "newPrice": "New price",
            "charge": "You'll be charged an additional {{amount}} to your card ending {{last4}}.",
            "chargeNoCard": "You'll be charged an additional {{amount}} to the card on this booking.",
            "refund": "You'll be refunded {{amount}} to your card ending {{last4}} within 5 to 10 business days.",
            "refundNoCard": "You'll be refunded {{amount}} to the card on this booking within 5 to 10 business days.",
            "noChange": "No change in price",
            "invoiceCharge": "{{amount}} will be added to the invoice for this booking. No card is charged.",
            "invoiceCredit": "{{amount}} will be credited to the invoice for this booking. No card is refunded.",
            "freeCancellationUntil": "Free cancellation until {{date}}",
            "notFree": {
               "title": "These new dates can't be cancelled for free",
               "windowPassed": "Check-in on the new dates is too close for free cancellation.",
               "nonRefundable": "The rate for the new dates is non-refundable.",
               "partialRefund": "If you cancel after this change, only part of the price will be refunded.",
               "unknown": "If you cancel after this change, you may not get your money back.",
               "amountAtRisk": "If you cancel after this change, none of the {{amount}} for this stay will be refunded.",
               "acknowledge": "I understand these new dates can't be cancelled for free.",
               "confirmHint": "Tick the box above to confirm the change.",
               "nowRequired": "These new dates are no longer free to cancel. Please read the warning below and confirm again. Nothing was changed or charged."
            },
            "nonRefundableAdmin": {
               "note": "Non-refundable: the hotel allows a date change through Booking Holdings; a cancellation would still forfeit the stay.",
               "supplierTotal": "Booking Holdings new total",
               "supplierExtra": "Booking Holdings additional cost",
               "supplierRefund": "Booking Holdings refund",
               "supplierHint": "Supplier figures from the Booking Holdings quote. The traveller pays the price difference in the summary."
            },
            "roomChanged": "The hotel will move you to a different room for these dates.",
            "priceChanged": "The price changed while you were reviewing. Please check the new amount before confirming.",
            "confirm": "Confirm change",
            "success": "Your dates are changed. We've emailed you an updated confirmation.",
            "pending": "Your change is being processed. We'll email you once it's done. Your card won't be charged unless the hotel accepts it.",
            "rejected": "The hotel couldn't accept this change, so nothing was changed or charged.",
            "declined": "Your card was declined, so nothing was changed. You can update your card in",
            "paymentMethods": "Payment methods"
         }
      },
      "cancel": "No, Thanks",
      "confirm": "Yes, I’m sure",
      "cancelBooking": "Cancel booking",
      "cancelTitle": "Are you sure you want to cancel this user's trip?",
      "cancelDescription": "This action cannot be undone. The user will be notified, the trip will be marked as canceled, and a full refund will be issued according to the refund policy.",
      "card": {
         "hotelPhoto": "Hotel photo",
         "showOnMap": "Show on map",
         "checkIn": "Check-in",
         "checkOut": "Check-out",
         "paidOn": "Paid on",
         "totalPaid": "Total paid",
         "rooms_one": "{{count}} room",
         "rooms_other": "{{count}} rooms",
         "cancel": "Cancel reservation"
      },
      "detail": {
         "bookingId": "Booking ID",
         "bookingSummary": "Booking Summary",
         "confirmationNumber": "Confirmation Number",
         "roomStayDetail": "Room & Stay Details",
         "program": "Program",
         "resendConfirmation": "Resend confirmation email",
         "resendConfirmationModalTitle": "Resend confirmation email",
         "sendToEmail": "Send to email",
         "resendSend": "Send",
         "resendSuccess": "Confirmation email sent successfully",
         "additionalGuests": "Additional Guests",
         "resendError": "Failed to send confirmation email",
         "cancellation": {
            "heading": "Cancellation policy",
            "tableWhen": "Cancel",
            "tableRefund": "Refund",
            "freeBefore": "Free cancellation before {{date}}",
            "partialBefore": "Partially refundable: {{pct}}% refund if you cancel before {{date}}",
            "partialBeforeAmount": "Partially refundable: {{pct}}% ({{refund}}) back if you cancel before {{date}}",
            "riskFreeBody": "Cancel before {{date}} and you’ll pay nothing.",
            "riskFreeOnline": "You can cancel online from this page.",
            "noSelfCancel": "This booking can't be cancelled online because cancelling now would not refund any money.",
            "noSelfCancelHelp": "If you need help, email us at",
            "pendingSelfCancel": "You can cancel online once your booking is confirmed.",
            "pendingSelfCancelHelp": "Need to cancel sooner? Email us at",
            "invoiceSelfCancel": "Our team arranged this booking, so we handle any changes or cancellations.",
            "invoiceSelfCancelHelp": "To cancel, email us at",
            "tierAfter": "After {{after}}",
            "tierBefore": "Before {{before}}",
            "tierBetween": "After {{after}} and before {{before}}"
         },
         "page": {
            "phone": "Phone:",
            "email": "Email:",
            "hotelPhoto": "Hotel photo",
            "statusConfirmed": "Your booking is confirmed",
            "statusOther": "Your booking is {{status}}",
            "confirmationNumber": "Confirmation number",
            "checkIn": "Check-in",
            "checkOut": "Check-out",
            "room": "Room",
            "adults_one": "{{count}} adult",
            "adults_other": "{{count}} adults",
            "children_one": "{{count}} child",
            "children_other": "{{count}} children",
            "guests": "Guests",
            "guestName": "Guest name",
            "loyalty": "Loyalty member ID",
            "payment": "Payment",
            "taxesAndFees": "Taxes & fees",
            "coupon": "Coupon",
            "totalPaid": "Total paid",
            "paymentMethod": "Payment method",
            "paymentDate": "Payment date",
            "paymentStatus": "Payment status",
            "processing": "Processing",
            "refundPending": "Refund pending",
            "program": "Program",
            "generatedFor": "Generated for {{orgName}}",
            "payAtHotel": "Paid to the hotel at check-in",
            "payAtHotelNote": "Not included in the total paid. The hotel collects these when you arrive.",
            "cancelledAt": "You cancelled on {{date}}.",
            "cancelButton": "Cancel your booking",
            "refundFailedTitle": "Refund failed",
            "refundFailedBody": "Your refund request didn't go through. Please try again in a few minutes."
         },
         "refundAmount": "Refund amount",
         "noRefund": "No refund",
         "roomInfo": {
            "bedCount": "Bed count",
            "bedType": "Bed type",
            "amenities": "List of amenities"
         }
      },
      "payment": {
         "leaveThisPage": "Leave this Page",
         "statyOnThisPage": "Stay on this Page"
      },
      "status": {
         "completed": "Completed",
         "waitingToTravel": "Waiting to travel",
         "cancelled": "Cancelled",
         "voided": "Voided",
         "preprocessing": "Preprocessing",
         "processing": "Processing",
         "confirmed": "Confirmed",
         "unconfirmed": "Unconfirmed",
         "ok": "Ok"
      },
      "cancelModal": {
         "confirmButton": "Cancel reservation",
         "continue": "Continue",
         "keep": "No, thanks",
         "question": "Are you sure you want to cancel this booking?",
         "body": "This can’t be undone. Your booking will be cancelled, and any refund due goes back to your card under the cancellation policy below.",
         "noRefundWarning": "You won’t get any money back if you cancel this booking.",
         "reasonTitle": "Cancel booking",
         "reasonPrompt": "Tell us why you’re cancelling",
         "reasonDifferentHotel": "Decided on a different hotel not offered here",
         "reasonDifferentHotelHere": "Will book a different hotel on this site",
         "freeBefore": "Free cancellation before {{date}}.",
         "refundAfter": "After that, you get back {{pct}}% ({{amount}}).",
         "noRefundAfter": "No refund after that.",
         "partialRefundWarning": "This is a partial refund, not a full refund. You’ll get back {{refund}} of the {{paid}} you paid.",
         "partialRefundReminder": "Partial refund: you’ll get back {{refund}} of the {{paid}} you paid.",
         "details": {
            "bookingId": "Booking ID",
            "hotel": "Hotel",
            "confirmation": "Hotel confirmation #",
            "checkIn": "Check-in",
            "checkOut": "Check-out",
            "nights": "Nights",
            "room": "Room",
            "ratePlan": "Rate plan",
            "amenities": "Included amenities",
            "totalRefund": "Total refund",
            "policyGuide": "See the cancellation policy guide",
            "unsettled": "This payment hasn't settled yet, so any refund due may take a few extra days to process.",
            "reasonLabel": "Cancellation reason *",
            "reasonPlaceholder": "Select a reason"
         },
         "breakdown": {
            "paid": "You paid",
            "refund": "Refund",
            "charged": "You’ll be charged",
            "adminPaid": "Paid",
            "adminCharged": "Not refunded"
         }
      },
      "refund": {
         "cancelledTitle": "Booking cancelled",
         "leadAmount": "Your refund of {{amount}} is on its way.",
         "lead": "Your refund is on its way.",
         "timingSettled": "We send it to your card automatically, usually the same day. Your bank may then take 5 to 7 business days to show it on your statement.",
         "timingUnsettled": "We send it to your card once your payment finishes processing, usually within 1 to 2 days. Your bank may then take 5 to 7 business days to show it on your statement.",
         "noRefund": "Your booking is cancelled. Under its cancellation policy, no refund is due.",
         "manualSuccessTitle": "Booking Cancelled",
         "manualSuccess": "The booking has been cancelled. There is no payment method on file, so any refund due will be processed manually by our team.",
         "manualCancelNote": "This booking has no payment method on file. Any refund due will be processed manually by our team.",
         "noRefundWarning": "Cancelling now refunds nothing. The hotel keeps the full payment for this booking."
      }
   },
   "supportAvailability": {
      "heading": "Need help?",
      "weekdayHours": "Monday to Friday, 9am to 5pm Central Time",
      "trip": {
         "chat": "Chat with us",
         "orEmail": "or email",
         "email": "Email",
         "reply": "For changes, cancellations, or receipts, we reply {{hours}}.",
         "stayIssue": "A problem at the hotel, like trouble checking in? Call",
         "stayIssueAnyTime": "any time, 24/7."
      },
      "standard": {
         "email": "Email",
         "orCall": "or call",
         "call": "Call",
         "hours": "We're available {{hours}}.",
         "urgentNote": "Urgent issue during your stay? Call any time, 24/7."
      },
      "perk": "You'll always reach a real person on our own team."
   },
   "helpArticles": {
      "label": "Help articles:",
      "add-a-night": "Adding a night",
      "cancel-a-booking": "Cancelling and refunds",
      "change-a-booking": "Changing a booking",
      "check-in-basics": "Check-in basics",
      "choose-or-change-organization": "Choosing an organization",
      "confirmation-and-receipts": "Confirmation and receipts",
      "contact-us": "How to reach us",
      "coupons-and-discounts": "Coupons and discounts",
      "for-organizations": "For organizations",
      "how-proceeds-work": "How proceeds work",
      "how-to-book": "How to book",
      "multiple-rooms-and-guests": "Multiple rooms and guests",
      "my-trips": "Using My Trips",
      "payment-declined": "Why a payment is declined",
      "payment-methods-and-saved-cards": "Saved cards",
      "price-alerts-and-emails": "Price alerts and emails",
      "problem-at-the-hotel": "Problem at the hotel",
      "rate-types": "Refundable and non-refundable rates",
      "season-planner": "Using the season planner",
      "sign-in-and-account": "Signing in and your account",
      "whats-included-in-your-rate": "What your rate includes",
      "declineQuestion": "Why was my payment declined?",
      "refundQuestion": "When will my refund arrive?",
      "selfServeLead": "Related help articles:"
   },
   "myPayments": {
      "default": "Default",
      "setDefault": "Set as default",
      "details": {
         "action": "Edit details",
         "title": "Card details",
         "subtitle": "Stored with {{card}} and used to fill in checkout when you pay with it.",
         "nameSection": "Name on card",
         "billingSection": "Billing address",
         "billingHint": "Checked against your card issuer, so use the address on your card statement.",
         "errors": {
            "firstNameRequired": "Billing first name is required. Please enter the name on the card.",
            "lastNameRequired": "Billing last name is required. Please enter the name on the card.",
            "addressRequired": "Address is required. Please enter your billing address.",
            "addressTooShort": "Address is too short. Please enter a valid address of at least 2 characters.",
            "cityRequired": "City is required. Please enter your city."
         },
         "save": "Save",
         "saving": "Saving…",
         "cancel": "Cancel",
         "success": "The details on this card were updated",
         "error": "We couldn't update the details on this card. Please try again."
      },
      "editCard": {
         "title": "Edit card",
         "action": "Edit",
         "success": "Your card was updated successfully"
      },
      "hostedAddCard": {
         "title": "Add New Card",
         "subtitle": "Your card details are entered securely with Authorize.net — they never touch our servers.",
         "loading": "Preparing secure form…",
         "loadingCaption": "Secured by Authorize.Net · 256-bit SSL",
         "loadingSteps": {
            "connect": "Opening a secure connection to Authorize.Net…",
            "encrypt": "Your card details are encrypted before they leave your browser",
            "offsite": "They go straight to Authorize.Net — never to our servers",
            "pci": "PCI DSS compliant payment processing"
         },
         "error": "We couldn't start the secure card form. Please try again.",
         "retry": "Try again",
         "success": "Successfully add new card"
      }
   },
   "claimAccount": {
      "loading": "Getting your account ready...",
      "redirecting": "Taking you to create your account...",
      "invalidTitle": "This link is no longer valid",
      "invalidBody": "Create an account with the email your trip was booked under, and your trips will be there when you sign in.",
      "createAccount": "Create your account"
   },
   "booking": {
      "guestNames": {
         "recommended": "Recommended",
         "frontDeskRule": "The front desk can only check in guests named on the reservation. Each name must match the guest’s photo ID exactly.",
         "explanation": "Save yourself a last-minute call: add every adult who might check in now.",
         "explanationYouthSports": "Not sure which parent will travel? Add both now and skip a last-minute call.",
         "explanationRooms": "Booking {{rooms}} rooms? Add the adults for every room here. The names go on the whole reservation.",
         "saveGuest": "Save {{name}} and add them to my future bookings",
         "savedGuest": "Saved guest",
         "removeSaved": "Remove",
         "removeSavedAria": "Remove {{name}} from this booking",
         "reminderTitle": "Add anyone else who might check in?",
         "reminderSave": "Save and add to future bookings",
         "reminderBothNames": "Enter both a first and last name.",
         "reminderNeedOne": "Enter a name, or continue without adding one.",
         "addCheckout": "Add and complete booking",
         "skipCheckout": "Complete without adding",
         "addContinue": "Add and continue",
         "skipContinue": "Continue without adding",
         "addRebook": "Add and continue",
         "skipRebook": "Continue without adding",
         "addChange": "Add and confirm change",
         "skipChange": "Confirm without adding",
         "namesNotAdded": "Your new dates are confirmed, but we couldn't add the guest names. You can add them from Edit guest names."
      },
      "agreementChangeability": {
         "changeable": "Date changes may be allowed after booking, subject to the hotel's approval, availability and any price difference.",
         "fixed": "This rate can't be changed after booking: no changes to dates, room or guests.",
         "fixedRefundable": "This rate can't be changed after booking. It can be cancelled for free until the deadline above and booked again.",
         "unknown": "Changes after booking depend on the hotel; contact support to ask."
      },
      "bookingFor": {
         "title": "Booking for",
         "description": "Admins can book for a traveler. The trip goes into their account, their card is charged, and they get the confirmation email.",
         "myself": "Myself",
         "traveler": "A traveler",
         "searchLabel": "Search travelers by name or email",
         "searchPlaceholder": "Search by name or email",
         "noResults": "No travelers found on this site.",
         "newTraveler": "New traveler",
         "newTravelerTitle": "New traveler",
         "firstName": "First name",
         "lastName": "Last name",
         "email": "Email",
         "newTravelerNote": "If this email already has an account, we'll use that account.",
         "existingMatch": "{{email}} already belongs to {{name}}. Booking for them puts this trip in their account and sends them the confirmation. Use a traveler's own email unless this is who you mean.",
         "existingMatchConfirm": "Book for this account",
         "existingMatchChange": "Use a different email",
         "newTravelerInvalid": "Enter a first name, last name and a valid email.",
         "createFailed": "We couldn't create this traveler. Try again.",
         "createAndSelect": "Book for this traveler",
         "cancel": "Cancel",
         "change": "Change",
         "claimNote": "They don't have an account yet. Their confirmation email will include a link to create one.",
         "pickTraveler": "Pick a traveler to book for, or choose Myself."
      },
      "adminPayment": {
         "title": "Payment",
         "card": "Card",
         "cardDescription": "Charge a card now",
         "invoice": "Invoice",
         "invoiceDescription": "Book now, collect payment later",
         "invoiceCode": "Invoice code",
         "invoiceCodeHint": "For example, the QuickBooks invoice number. You can add it later.",
         "invoiceNote": "Invoice note",
         "internalNote": "Internal note",
         "internalNoteHint": "Only admins see this. Never shown to the traveler.",
         "tooLong": "Keep this under {{max}} characters."
      },
      "pageTitle": "Complete your booking",
      "billingAddressTitle": "Billing Address",
      "contactDetailsTitle": "Contact Details",
      "hotelContactTitle": "Hotel contact",
      "yourContactTitle": "Your Contact",
      "yourContactNote": "The person making this booking. We'll send the confirmation here.",
      "guestsTitle": "Who might check in?",
      "guestsSummaryAdults_one": "{{count}} adult",
      "guestsSummaryAdults_other": "{{count}} adults",
      "guestsSummaryChildren_one": "{{count}} child",
      "guestsSummaryChildren_other": "{{count}} children",
      "guestsNote": "Names must match each guest's ID at check-in.",
      "sameAsContact": "I'm staying at the hotel. Use my name for the lead guest",
      "leadGuestLabel": "Lead guest",
      "leadGuestMirrorHint": "Synced with Your Contact",
      "adultLabel": "Adult {{n}}",
      "childLabel": "Child {{m}} · age {{age}}",
      "optional": "(optional)",
      "addAnotherGuest": "Add another guest",
      "addChildGuest": "Add a child",
      "addGuestHint": "Optional. If you add a guest, enter their first and last name.",
      "removeGuest": "Remove",
      "removeGuestAria": "Remove {{label}}",
      "duplicateGuestNameWarning": "Two guests have the same name. If they are different people, add a middle name or initial as shown on their ID (e.g. John A Smith).",
      "additionalGuests": "Additional guests",
      "guestForm": {
         "phoneNumber": "Phone number",
         "nameTooLong": "Name must be {{max}} characters or fewer.",
         "nameLatin": "Please enter the name in Latin letters, as shown on the passport.",
         "adultFirstNameRequired": "Adult {{n}}'s first name is required.",
         "adultLastNameRequired": "Adult {{n}}'s last name is required.",
         "childFirstNameRequired": "Child {{m}}'s first name is required.",
         "childLastNameRequired": "Child {{m}}'s last name is required.",
         "adultFirstNameTitle": "Adult {{n}} first name",
         "adultLastNameTitle": "Adult {{n}} last name",
         "childFirstNameTitle": "Child {{n}} first name",
         "childLastNameTitle": "Child {{n}} last name"
      },
      "agreementLabelStart": "I have read and agree to the ",
      "agreementRequired": "Please check the box to accept the Booking & Cancellation Agreement.",
      "legalFooter": "Your card statement will show a charge from {{statementDescriptor}}.",
      "addCard": {
         "title": "Add a card",
         "saving": "Saving your card…",
         "close": "Close",
         "inlineTitle": "Secure card form",
         "inlineEditTitle": "Edit card details",
         "unsavedWarning": "This card hasn't been saved yet. Choose Save Card below to continue.",
         "unsavedWarningWithCard": "This card hasn't been saved yet. Choose Save Card below to use it, or close this form to pay with your saved card ending {{last4}}.",
         "unsavedEditWarning": "Your changes haven't been saved yet. Choose Save Card below to keep them, or close this form to leave the card as it was.",
         "inlineHostedBy": "Hosted by Authorize.Net — details never touch our servers",
         "tile": "Add a Card",
         "emptyNote": "Add a card to complete your booking. Card details are entered securely with Authorize.net and saved for future trips — they never touch our servers.",
         "requiredError": "Please add or select a card to complete your booking."
      },
      "paymentFailed": {
         "title": "Booking failed",
         "generic": "Your transaction could not be completed. Please try again with a different payment method.",
         "issuerDeclined": "Your card issuer declined this transaction. Please contact your card issuer to approve it and try again, or use a different card.",
         "checkDetails": "Please double-check your card number, expiration, and billing address, then try again. If this keeps happening, try another card.",
         "supportPrompt": "Still having trouble? Email us at"
      },
      "fraudBlocked": {
         "title": "We need to confirm this booking with you",
         "velocityMessage": "For your security, we've paused payments on this account after a few unsuccessful attempts. Our team can lift it right away and finish your booking for you.",
         "attemptLimitMessage": "There have been several payments on this account in a short time, so we've paused new ones for a little while. Please try again later, or contact our team and we can finish your booking for you.",
         "blockedMessage": "We couldn't process this booking automatically. Our team can review it and finish the booking for you.",
         "callUs": "Call us at",
         "orEmail": "or email",
         "hours": "We answer booking questions {{hours}}. After hours, leave a voicemail and we'll call you back."
      },
      "billingFirstName": "Billing first name",
      "billingFirstNamePlaceholder": "First name",
      "billingLastName": "Billing last name",
      "billingLastNamePlaceholder": "Last name",
      "billingCompany": "Company (optional)",
      "billingCompanyPlaceholder": "Club, team or business name",
      "billingCityInStreetWarning": "Remove the city from Street Address 1. It belongs in the City field, and repeating it here can fail your card's address check.",
      "completeBooking": "Complete Booking",
      "nonRefundableConfirm": {
         "titleConfirm": "Check the cancellation terms",
         "noticeTitle": {
            "none": "This room is non-refundable.",
            "partial": "This room is only partly refundable."
         },
         "noticeBody": {
            "fixed": "There are no refunds or changes for any reason as soon as the booking is completed.",
            "unknown": "There are no refunds or changes for any reason as soon as the booking is completed.",
            "changeable": "There are no refunds for any reason as soon as the booking is completed."
         },
         "recommendUntil": "We strongly recommend booking a refundable rate: free cancellation until {{date}} for {{amount}} more.",
         "recommendUntilNoExtraCost": "We strongly recommend booking a refundable rate: free cancellation until {{date}} at no extra cost.",
         "recommend": "We strongly recommend booking a refundable rate: free cancellation for {{amount}} more.",
         "recommendNoExtraCost": "We strongly recommend booking a refundable rate: free cancellation at no extra cost.",
         "recommendMealsDiffer": "The refundable rate comes with a different meal plan, and the price includes it.",
         "switching": "Switching to the changeable rate...",
         "actionReservePartial": "Reserve this rate",
         "actionReserveNone": "Reserve non-refundable",
         "actionChoosePartial": "Choose this rate",
         "actionChooseNone": "Choose non-refundable",
         "actionSwitchAmendable": "Switch to the changeable rate (+{{amount}})",
         "actionSwitchRefundable": "Switch to fully refundable (+{{amount}})",
         "actionAmendable": "Switch to the changeable rate and book for {{total}}",
         "ack": {
            "noneFixed": "I understand this booking can't be changed, cancelled or refunded.",
            "none": "I understand this booking can't be cancelled or refunded.",
            "partialFixed": "I understand the refund limits and that this booking can't be changed.",
            "partial": "I understand the refund limits."
         },
         "termChange": {
            "fixed": "Your dates, room and guests can't be changed after booking.",
            "changeable": "The hotel may allow date or guest-name changes after booking, subject to availability and any price difference. You can ask from Change booking in My Trips. Room type and number of guests can't be changed.",
            "unknown": "Whether the hotel allows changes after booking is up to the hotel."
         },
         "amendableNoExtraCost": "At no extra cost, you can change your dates later ({{total}} total). Same room, same dates.",
         "amendablePrice": "For {{amount}} more, you can change your dates later ({{total}} total). Same room, same dates.",
         "amendableHeading": "A changeable rate for the same room",
         "titleAmendableOffer": "Keep the option to change your dates?",
         "pickedRefundableEarlier": "You picked a free-cancellation rate for this stay earlier, but the rate you're booking now is non-refundable.",
         "orgNudge": {
            "YOUTH_SPORTS": "Tournaments get rescheduled and brackets change. Free cancellation keeps your plans flexible.",
            "UNIVERSITY": "Game times move and the weather turns. Free cancellation keeps your plans flexible.",
            "default": "Plans change. With free cancellation you can cancel before the deadline at no cost."
         },
         "upgradeLoading": "Checking for a free-cancellation rate for this room...",
         "termPartialRefund": "{{pct}}% back if you cancel before {{date}}.",
         "termPartialNoRefundAfter": "No refund if you cancel after {{date}} or don't show up.",
         "termPartialGeneric": "Only part of the price comes back if you cancel, and nothing if you don't show up.",
         "actionUpgrade": "Add free cancellation and book for {{total}}",
         "actionKeepNone": "Keep non-refundable and book for {{total}}",
         "actionKeepPartial": "Keep this rate and book for {{total}}",
         "actionBookNone": "Book non-refundable for {{total}}",
         "actionBookPartial": "Book this rate for {{total}}",
         "actionKeepNoneNoTotal": "Keep non-refundable and book",
         "actionKeepPartialNoTotal": "Keep this rate and book",
         "actionBookNoneNoTotal": "Book non-refundable",
         "actionBookPartialNoTotal": "Book this rate",
         "actionBack": "Go back",
         "upgrading": "Adding free cancellation..."
      },
      "nonRefundableRate": {
         "title": {
            "fixed": "Non-refundable, non-changeable rate",
            "changeable": "Non-refundable rate",
            "unknown": "Non-refundable rate"
         },
         "body": {
            "fixed": "This rate is non-refundable and non-changeable. You can't cancel it for a refund or change your dates, room, or guests after booking.",
            "changeable": "This rate is non-refundable: you can't cancel it for a refund. The hotel may allow date or guest-name changes after booking, subject to availability and any price difference.",
            "unknown": "This rate is non-refundable: you can't cancel it for a refund. Whether the hotel allows changes after booking is up to the hotel."
         }
      },
      "policySummary": {
         "noneChangeable": "Non-refundable · Date changes may be allowed",
         "noneOnly": "Non-refundable",
         "full": "Free cancellation until {{date}}",
         "partial": "Partially refundable: {{pct}}% back if you cancel before {{date}}",
         "partialAmount": "Partially refundable: {{amount}} back if you cancel before {{date}}",
         "none": "Non-refundable, non-changeable"
      },
      "deadlineRefundAfter": "After {{date}}, you get back {{pct}}% ({{amount}}).",
      "refundSchedule": {
         "full": "Free cancellation until {{date}}.",
         "partial": "Cancel before {{date}} and you get back {{amount}}.",
         "refundAfter": "After {{date}}, you get back {{amount}}.",
         "arrival": "If you cancel on or after check-in day ({{date}}), or don't show up, you get back {{amount}}.",
         "noRefundAfter": "No refund after {{date}}."
      },
      "deadlineNoRefund": "No refund after {{date}}.",
      "priceHold": {
         "label": "Your price is held for"
      },
      "priceSummary": {
         "taxesAndFees": "Taxes & fees",
         "totalDueToday": "Total due today",
         "includesTaxes": "The full amount, taxes and fees included",
         "payAtHotelTitle": "Paid to the hotel at check-in",
         "payAtHotelNote": "Not included in the total above. The hotel collects these when you arrive."
      },
      "mobileSummary": {
         "dates_one": "{{checkIn}} – {{checkOut}} · {{count}} night",
         "dates_other": "{{checkIn}} – {{checkOut}} · {{count}} nights",
         "total": "Total due today"
      },
      "refundableUpgrade": {
         "added": "Free cancellation added until {{date}}",
         "switchBack": "Switch back to the non-refundable rate",
         "switchBackSaving": "Switch back to the non-refundable rate and save {{amount}}"
      },
      "agreementCancellation": {
         "nonRefundable": "This rate is non-refundable. You can't cancel it for a refund.",
         "unavailable": "This rate’s refund amount is currently unavailable: please contact support for cancellation details.",
         "before": "Cancel before {{date}}: {{pct}}% refund.",
         "from": "From {{date}}: {{pct}}% refund.",
         "fromNonRefundable": "From {{date}}: non-refundable.",
         "beforeUnavailable": "Cancel before {{date}}: refund amount unavailable.",
         "fromUnavailable": "From {{date}}: refund amount unavailable."
      },
      "completeBookingProcessing": "Processing...",
      "deleteCard": {
         "action": "Delete card",
         "success": "The card was deleted successfully",
         "error": "An error occurred while deleting this card."
      },
      "program": {
         "title": {
            "proceeds": "Choose a Program to Support",
            "savings": "Choose a Program",
            "neutral": "Choose a Program"
         },
         "current": {
            "proceeds": "Supporting {{program}}",
            "savings": "Program: {{program}}",
            "neutral": "Program: {{program}}"
         },
         "change": "Change",
         "changeAria": "Change the program"
      },
      "duplicateBooking": {
         "title": "Book a Second Room?",
         "message": "You already have a booking for these dates. Please confirm you wish to add a second room for the same dates.",
         "viewMyTrips": "View My Trips",
         "confirm": "Yes, add a second room",
         "cancel": "Cancel"
      },
      "prebookUnavailable": {
         "pickAnotherRoom": {
            "title": "Room No Longer Available",
            "message": "This room is no longer available. Please choose a different room at this hotel.",
            "cta": "Pick Another Room",
            "destination": "room selection"
         },
         "countdown": "Taking you back to {{destination}} in {{seconds}}s…"
      },
      "successPlanner": {
         "redirect_one": "Taking you back to your season in {{count}} second...",
         "redirect_other": "Taking you back to your season in {{count}} seconds...",
         "note": "Your trip details are always in My Trips.",
         "backToSeason": "Back to my season now",
         "goToMyTrips": "Go to My Trips"
      },
      "successBilledBy": "Confirmed. Your card was billed {{amount}} by {{statementDescriptor}}.",
      "successMyTrips": {
         "redirect_one": "Redirecting you to My Trips in {{count}} second...",
         "redirect_other": "Redirecting you to My Trips in {{count}} seconds...",
         "note": "This window will close and take you directly to your trip details.",
         "goToMyTrips": "Go to My Trips now"
      },
      "hotelAlternatives": {
         "title": "This hotel seems to be having technical difficulties.",
         "message": {
            "withResults": "We couldn't complete your booking at this property. We recommend one of these instead.",
            "loading": "We couldn't complete your booking at this property. We're finding similar hotels for your stay…",
            "noResults": "We couldn't complete your booking at this property. Head back to search to find another hotel for your stay."
         },
         "reassurance": {
            "notCharged": "You won't be charged for this failed booking.",
            "searchSaved": "Your search details (dates, guests, rooms) are saved.",
            "handpicked": "We've selected similar hotels with great availability and ratings."
         },
         "recommendedTitle": "Recommended hotels for you",
         "recommendedSubtitle": "Similar options in the same area, with great amenities and availability.",
         "amenities": "Amenities",
         "perNight": "/nt",
         "viewHotel": "View Hotel",
         "viewHotelLabel": "View {{name}}",
         "help": {
            "title": "Need help?",
            "message": "Our team is here to assist you. If you continue to experience issues, please contact support."
         },
         "backToSearch": "Back to search"
      }
   },
   "bookingSecurity": {
      "pillars": {
         "secure": {
            "title": "Secure Transactions",
            "subtitle": "256-bit SSL encrypted"
         },
         "support": {
            "title": "24/7 Stay Support",
            "subtitle": "Help during your stay, day or night"
         },
         "payments": {
            "title": "Trusted Payments",
            "subtitle": "Verified merchant processing"
         }
      },
      "section": {
         "title": "Your payment is secure",
         "subtitle": "Card details are encrypted and processed by Authorize.Net. We never store your full card number on our servers."
      },
      "acceptedCards": "Accepted cards: Visa, Mastercard, American Express, JCB, Diners, UnionPay"
   },
   "recaptcha": {
      "challenge": {
         "ariaLabel": "Security verification",
         "title": "Please verify you are human",
         "description": "Complete the challenge below to continue.",
         "loadFailed": "We couldn't load the verification challenge. Please check your connection or disable any content/ad blockers, then try again.",
         "retry": "Retry",
         "unverifiedTitle": "We couldn't verify your browser",
         "unverifiedDescription": "This is on our side, not yours. Complete the quick check below to continue, or reload the page.",
         "reload": "Reload page"
      }
   },
   "Phone number": "Phone number",
   "Street address": "Street address",
   "City": "City",
   "Zip": "Zip",
   "Company Name": "Company Name",
   "VAT Number": "VAT Number",
   "Full Guest Name": "Full Guest Name",
   "Guest email": "Guest email",
   "From": "From",
   "Before": "Before",
   "After": "After",
   "Free cancellation before": "Free cancellation before",
   "CountriesTooltipDesc": "Some countries and hotels have citizenship based priced adjustments. If booked with a value that doesn’t match your passport, you may owe additional fees at check in.",
   "How it works": "How it works",
   "Enter payment details": "Enter payment details",
   "Street Address 1": "Street Address 1",
   "Street Address 2": "Street Address 2",
   "Card payment": "Card payment",
   "Expires": "Expires",
   "Your Card": "Your Card",
   "Favorite name": "Favorite name",
   "Add to favorites": "Add to favorites",
   "Remove from favorites": "Remove from favorites",
   "Your Favorites": "Your Favorites",
   "Remove from your favorites": "Remove from your favorites",
   "Add to your favorites": "Add to your favorites",
   "Create a new list": "Create a new list",
   "Name your list": "Name your list",
   "Use Custom Video": "Use Custom Video for \"How it Works\"",
   "Homepage Video Settings": "Homepage Video Settings",
   "Video (allow to set the default video for the home page)": "Video (allow to set the default video for the home page)",
   "Uploaded global video successfully": "Uploaded global video successfully",
   "Error while uploading video": "Error while uploading video",
   "This hotel has been saved to your Favorites. You can also add it to one or more of your lists": "This hotel has been saved to your Favorites. You can also add it to one or more of your lists",
   "Added to Favorites": "Added to Favorites",
   "Manage Favorites": "Manage Favorites",
   "Popular Destinations": "Popular Destinations",
   "Org Destinations": "{{orgName}}'s Destinations",
   "Destinations": "Destinations",
   "Add popular destinations for organization": "Add popular destinations for organization",
   "Add Destination": "Add Destination",
   "Update Destination": "Update Destination",
   "Trending Destinations": "Trending Destinations",
   "Add broader trending destinations to inspire travelers (e.g. Cabo, Vegas, London).": "Add broader trending destinations to inspire travelers (e.g. Cabo, Vegas, London).",
   "Add Trending Destination": "Add Trending Destination",
   "Update Trending Destination": "Update Trending Destination",
   "Site Trending Destinations": "Site Trending Destinations",
   "Default trending destinations shown when an organization has not set its own.": "Default trending destinations shown when an organization has not set its own.",
   "Add Site Trending Destination": "Add Site Trending Destination",
   "Update Site Trending Destination": "Update Site Trending Destination",
   "Successfully added Destination": "Successfully added Destination",
   "Please select an address": "Please select an address",
   "Hero Description For Mobile": "Hero Description For Mobile",
   "Hero Header For Mobile": "Hero Header For Mobile",
   "Hero for Mobile": "Hero for Mobile",
   "Hero for Desktop": "Hero for Desktop",
   "Desktop": "Desktop",
   "Mobile": "Mobile",
   "Preview": "Preview",
   "Events": "Events",
   "Booking": "Booking",
   "Add events for organization": "Add events for organization",
   "Add Event": "Add Event",
   "Update Event": "Update Event",
   "Successfully added Event": "Successfully added Event",
   "Add your details below to let everyone know if you’re coming!": "Add your details below to let everyone know if you’re coming!",
   "events": {
      "hotelsAvailable_one": "{{size}} hotel available",
      "hotelsAvailable_other": "{{size}} hotels available",
      "mileRadius": "Within a {{mileNumber}}-mile radius",
      "viewAllHotels": "View all hotels",
      "recommended": "Recommended",
      "pickTrip": "Our pick for this trip",
      "toStay": "Where to Stay",
      "otherOptions": "Other Options",
      "findHotelNow": "Find a hotel now!",
      "findHotelForEventNow": "Find a hotel for {{name}} now!",
      "rsvp": {
         "tooManyAttempts": "You've sent too many RSVPs. Please wait a while and try again.",
         "error": "We couldn't save your RSVP. Please try again."
      },
      "Thanks for letting us know you can make it!": "Thanks for letting us know you can make it!",
      "Thanks for letting us know you’re interested.": "Thanks for letting us know you’re interested.",
      "once you’ve confirmed your plans": "once you’ve confirmed your plans",
      "You’ve successfully RSVP’d.": "You’ve successfully RSVP’d.",
      "We hope to see you at the next one!": "We hope to see you at the next one!",
      "Thinking about it": "Interested",
      "I'll be there!": "Going!",
      "Can't make it": "Can't go",
      "Book your stay with Nonprofit Trips below to support": "Book your stay with Nonprofit Trips below to support",
      "Learn how Nonprofit Trips is helping": "Learn how Nonprofit Trips is helping",
      "addEdit": {
         "Update your RSVP": "Update your RSVP",
         "startDate": "Start Date",
         "startTime": "Start Time",
         "stayStartDate": "Check-in Date",
         "stayEndDate": "Check-out Date",
         "endDate": "End Date",
         "endTime": "End Time",
         "title": "Title",
         "description": "Description",
         "previewHotelId": "Preview Hotel ID for this event",
         "location": "Location",
         "activeEvent": "Active Event",
         "rsvpSummary": "RSVP Summary",
         "rsvpFor": "RSVP for",
         "save": "Save",
         "ok": "Ok",
         "modalDescription": "These are the official dates of your event and will be visible to attendees.",
         "hotelStayDates": "Hotel Stay Dates",
         "hotelStayDateDescription": "These dates help attendees find the right nights to book. Defaults to Event Dates. Adjust if attendees are likely to arrive early or stay late.",
         "placeholders": {
            "enterStartDate": "e.g., 08-01-2025",
            "enterEndDate": "e.g., 09-15-2025"
         },
         "failedUpdateHotelDesignations": "Failed to update hotel designations.",
         "titleEventName": "Event Name *",
         "placeholderEventName": "Enter event name",
         "placeholderLocation": "Selected from Mapbox search",
         "close": "Close",
         "locationPlaceholder": "[Location]",
         "hotelTiers": "Hotel tiers",
         "thisIsHowYourEvent": "This is how your event appears to attendees and in all previews.",
         "eventDates": "Event Dates",
         "toAttendees": "Not shown to attendees",
         "importantToKnow": "Important to know",
         "eventDatesAreVisible": "Event Dates are visible to attendees and cannot be changed without affecting the event.",
         "hotelStayDatesAreHidden": "Hotel Stay Dates are hidden and used only for hotel search. This helps attendees find the right nights to book without confusion."
      },
      "rsvpMode": {
         "label": "RSVP Mode",
         "fullRsvp": "Full RSVP",
         "remindMe": "Remind Me",
         "disabled": "Disabled",
         "orgDefault": "Default RSVP mode for new events",
         "remindMeButton": "Remind Me to Book",
         "remindMeHeader": "Get a Reminder for",
         "remindMeIntro": "Enter your details and we'll remind you when it's time to book!",
         "remindMeConfirm": "Remind Me",
         "remindMeSuccess": "We'll remind you when it's time to book!",
         "searchHotels": "Search Hotels"
      }
   },
   "experiments": {
      "landingSignup": {
         "card": {
            "ariaLabel": "Sign up for member-exclusive savings",
            "badge": "MEMBER EXCLUSIVE",
            "title": "Member exclusive rates",
            "headline": "Member exclusive rates",
            "subline": "Sign up free to unlock member pricing on every stay",
            "body": "Sign up free to unlock member pricing on every stay"
         },
         "cta": {
            "google": "Continue with Google",
            "email": "Continue with email",
            "or": "or"
         },
         "footer": {
            "haveAccount": "Have an account?",
            "signIn": "Sign in",
            "dismiss": "Maybe later"
         }
      },
      "searchInlistCard": {
         "account_pitch": {
            "title": "Account holders get the best deals",
            "body": "Free to join · Supports your organization"
         },
         "rate_watch": {
            "title": "Want us to watch rates in {{destination}} for you?",
            "titleGeneric": "Want us to watch rates for you?",
            "body": "We'll alert you if prices drop for {{checkIn}}–{{checkOut}}",
            "bodyGeneric": "We'll alert you if prices drop on this search"
         },
         "badge": {
            "accountPitch": "✨ Members Only",
            "rateWatch": "🔔 Price Alert"
         },
         "cta": {
            "createAccount": "Create account",
            "watchTrip": "Yes, watch this trip",
            "dismiss": "No thanks"
         }
      },
      "searchPaywall": {
         "title": "See all results + get the best rates",
         "body": "Free account · takes 30 seconds · supports your organization",
         "remainingPill": "{{count}} more hotels available",
         "cta": {
            "google": "Continue with Google",
            "createAccount": "Create free account",
            "dismiss": "I'll stick with these 10"
         }
      }
   },
   "admin": {
      "hotelBlacklist": {
         "tabs": {
            "blacklist": "Blacklisted hotels",
            "hiddenRooms": "Hidden room types"
         },
         "hiddenRoomTypes": {
            "tableLabel": "Hidden room types",
            "hotelId": "Hotel ID",
            "roomName": "Room Name",
            "reason": "Reason",
            "hiddenBy": "Hidden By",
            "dateHidden": "Date Hidden",
            "unhide": "Unhide",
            "unhideRoomAria": "Unhide {{roomName}}"
         }
      },
      "orgWithParent": "{{orgName}} ({{parentOrgName}})",
      "rateBreakdown": {
         "trigger": "Rate Details",
         "badge": "Admin",
         "title": "Rate Breakdown",
         "rateFor": "For this rate: {{room}}",
         "refundable": "refundable",
         "nonRefundable": "non-refundable",
         "unnamedRoom": "room name not given",
         "unknownView": "unknown view",
         "sections": {
            "supplier": "Supplier Data (BH API)",
            "calculation": "Rate Calculation",
            "customer": "Customer-Facing",
            "split": "Margin Split ({{mode}})"
         },
         "rows": {
            "netRate": "Net Rate (NPT pays BH)",
            "minSellPrice": "BH Min Sell Price",
            "includedTaxes": "Included Taxes",
            "taxDueAtHotel": "Tax Due at Hotel",
            "mandatorySurcharges": "Mandatory Surcharges",
            "nights": "Nights",
            "publicRate": "Public Rate",
            "priceRule": "Price Rule Applied",
            "margin": "Margin (share of price)",
            "nightlyRate": "Nightly Rate",
            "commission": "Commission",
            "taxRate": "Tax Rate",
            "incrementalTax": "Incremental Tax",
            "proceeds": "Proceeds",
            "displayedPrice": "Displayed Price (excl. tax)",
            "nightlyShown": "Nightly Rate (shown)",
            "taxesAndFees": "Taxes & Fees (at checkout)",
            "totalCharged": "Total Charged",
            "proceedsToOrg": "Proceeds to Org",
            "netPrice": "Net Price",
            "platformAmount": "Platform Amount",
            "orgProceedsAmount": "Org Proceeds Amount",
            "travelerDiscount": "Traveler Discount",
            "ourPrice": "Our Price",
            "ourNightlyRate": "Our Nightly Rate",
            "savingsPct": "Savings %"
         },
         "formulas": {
            "publicRate": "max(minSellPrice, netRate × 1.10)",
            "publicRateAgreed": "agreedPrice (the price the traveler accepted)",
            "margin": "(publicRate − netRate) ÷ publicRate × 100",
            "nightlyRate": "(publicRate − tax − mandatories) / nights",
            "commission": "publicRate − netRate",
            "taxRate": "includedTax / netRate",
            "incrementalTax": "commission × taxRate",
            "proceeds": "(commission − incTax) × {{rate}}%",
            "displayedPrice": "ourNightlyRate × nights",
            "nightlyShown": "nightlyRate − travelerDiscount / nights",
            "orgProceedsAmount": "= Proceeds above",
            "ourPrice": "publicRate − travelerDiscount"
         },
         "rules": {
            "MIN_SELL_PRICE": "BH min sell price ({{minSellPrice}})",
            "FLOOR_10_PCT": "Net + 10% floor ({{floorPrice}}); BH min sell price was {{minSellPrice}}",
            "AGREED_PRICE": "Price the traveler already accepted ({{agreedPrice}})",
            "unknown": "Not reported by the API"
         },
         "note": "Note: {{note}}"
      },
      "hotelCuration": {
         "openGrid": "Curation grid",
         "curate": "Curate",
         "mapLabel": "Map of the venue and the hotels in the grid",
         "mapPin": "{{number}}: {{hotel}}, {{tier}}",
         "mapPinNotPicked": "not picked",
         "search": {
            "label": "Add a hotel not in the list",
            "placeholder": "Hotel name or address",
            "results": "Matching places",
            "none": "No bookable hotel named like {{name}} near there.",
            "failed": "Could not search for that hotel. Try again.",
            "added_one": "Added {{count}} hotel to the grid.",
            "added_other": "Added {{count}} hotels to the grid."
         },
         "reasons": {
            "label": "Why these picks",
            "title": "Why? (optional)",
            "help": "One click per reason, and a note if you like. This trains the hotel picker; you can skip it.",
            "skip": "Skip",
            "save": "Save reasons",
            "saved_one": "Saved the reason for {{count}} decision.",
            "saved_other": "Saved reasons for {{count}} decisions.",
            "failed": "Could not save the reasons. Your picks are saved.",
            "notePlaceholder": "Note (optional)",
            "noteLabel": "Note for {{hotel}}",
            "action": {
               "ADDED": "{{hotel}} → {{tier}}",
               "MOVED": "{{hotel}} moved to {{tier}}",
               "REORDERED": "{{hotel}} reordered in {{tier}}",
               "REMOVED": "{{hotel}} removed",
               "EXCLUDED": "{{hotel}} excluded"
            },
            "tags": {
               "NOT_AMENDABLE": "Not changeable",
               "AMENDABLE": "Changeable rate",
               "PRICE": "Price",
               "MARGIN": "Margin",
               "LOCATION": "Location",
               "QUALITY": "Quality",
               "TWO_BED_ROOMS": "Two-bed rooms",
               "BRAND": "Brand",
               "AVAILABILITY": "Availability",
               "GUT_CALL": "Gut call"
            }
         },
         "back": "← Team hotels",
         "title": "Hotel curation: {{name}}",
         "titleLoading": "Hotel curation",
         "venuesTbd": "Venues aren't set for this event yet. Distances are from the city centre, and the venue may be a drive away. You can still pick hotels.",
         "loading": "Loading…",
         "loadFailed": "Could not load hotels for this event.",
         "retry": "Try again",
         "showing": "Showing {{shown}} of {{total}} hotels",
         "noRows": "No hotels match. Clear some filters or widen the radius.",
         "gridCaption": "Hotels for this event, one row per hotel",
         "roomsCaption": "Room products at {{hotel}}",
         "expandRooms": "Show rooms at {{hotel}}",
         "collapseRooms": "Hide rooms at {{hotel}}",
         "unknown": "?",
         "yes": "Yes",
         "no": "No",
         "extendedStay": "Extended stay",
         "concerns_one": "{{count}} concern",
         "concerns_other": "{{count}} concerns",
         "minutes_one": "{{count}}\u00a0min",
         "minutes_other": "{{count}}\u00a0min",
         "suggested": "Suggested",
         "engineSays": "Engine: {{tier}}",
         "exclude": "Exclude",
         "picksLabel": "Your picks",
         "nonePicked": "None yet",
         "excludedCount_one": "{{count}} hotel excluded",
         "excludedCount_other": "{{count}} hotels excluded",
         "moveUp": "Move up",
         "moveDown": "Move down",
         "remove": "Remove",
         "save": "Save picks",
         "saving": "Saving…",
         "saved_one": "Saved. {{count}} decision logged.",
         "saved_other": "Saved. {{count}} decisions logged.",
         "savedNote_one": "Last save logged {{count}} decision.",
         "savedNote_other": "Last save logged {{count}} decisions.",
         "saveFailed": "Could not save. Nothing was changed.",
         "unsaved": "Unsaved changes. Suggested picks are only saved when you save.",
         "make": {
            "TEAM": "Team",
            "BUDGET": "Budget",
            "LUXURY": "Luxury"
         },
         "tierNames": {
            "TEAM": "Team",
            "BUDGET": "Budget",
            "LUXURY": "Luxury"
         },
         "tiers": {
            "ECONOMY": "Economy",
            "MIDSCALE": "Midscale",
            "UPSCALE": "Upscale",
            "LUXURY": "Luxury",
            "UNKNOWN": "Unbranded"
         },
         "blockMargin": {
            "title": "What we earn over what families pay, across the cheapest two-bed rooms that fill the block: {{rooms}} rooms from {{products}} room types",
            "noTwoBed": "No two-bed rooms listed: counted the cheapest {{rooms}} rooms of any kind",
            "noTwoBedShort": "no two-bed rooms"
         },
         "basis": {
            "TWO_BED_REFUNDABLE": "Cheapest two-bed refundable rate",
            "TWO_BED": "Cheapest two-bed rate (none refundable)",
            "CHEAPEST": "Cheapest rate (no two-bed room)"
         },
         "rules": {
            "MIN_SELL_PRICE": "Min sell price",
            "FLOOR_10_PCT": "Net + 10% floor",
            "AGREED_PRICE": "Agreed price"
         },
         "availability": {
            "notChecked": "Not checked",
            "short": "short",
            "quoted": "Quoted, no count",
            "refused": "Won't quote",
            "failed": "Check failed"
         },
         "columns": {
            "changeable": "Changeable",
            "hotel": "Hotel",
            "stars": "Stars",
            "rating": "Rating",
            "distance": "Distance",
            "drive": "Drive",
            "parking": "Free parking",
            "breakfast": "Free breakfast",
            "pool": "Pool",
            "bar": "Bar",
            "available": "Rooms avail.",
            "rates": "Rates",
            "twoBed": "2-bed rates",
            "price": "2-bed price",
            "margin": "Block margin",
            "refundable": "Refundable",
            "fit": "Fit",
            "score": "Team score",
            "actions": "Make"
         },
         "roomColumns": {
            "changeable": "Changeable",
            "room": "Room",
            "beds": "Beds",
            "price": "Per night",
            "margin": "Margin",
            "refundable": "Refundable",
            "rule": "Price rule"
         },
         "query": {
            "blockSize": "Block (rooms)",
            "adults": "Adults per room",
            "children": "Children per room (ages 10, 12)",
            "radius": "Radius",
            "miles_one": "{{count}}\u00a0mile",
            "miles_other": "{{count}}\u00a0miles",
            "scoringOrg": "Score for",
            "platformDefault": "Platform default",
            "update": "Update",
            "sessionOnly": "These change this search only. Organization preferences and traveler results are not touched."
         },
         "filters": {
            "search": "Find in list",
            "searchPlaceholder": "Name or address",
            "minStars": "Min stars",
            "minRating": "Min rating",
            "maxDistance": "Max miles",
            "maxPrice": "Max price",
            "twoBed": "Two-bed rooms",
            "freeParking": "Free parking",
            "freeBreakfast": "Free breakfast",
            "refundable": "Refundable"
         }
      },
      "siteConfigRegistry": {
         "tabs": {
            "basicInfo": "Basic Info",
            "homePage": "Home page",
            "trendingDestinations": "Trending Destinations"
         },
         "errors": {
            "invalidTabs": "Changes not saved. Fix the highlighted fields on: {{tabs}}."
         }
      },
      "market": {
         "title": "Market",
         "siteDescription": "Defaults for travelers on this site: the country addresses and residency start on, the phone calling code, distance units and which countries location search lists first.",
         "defaultCountry": "Default country",
         "defaultCountryHint": "Preselected in billing addresses and used as the traveler's country of residence.",
         "phoneDefaultCountry": "Phone default country",
         "phoneDefaultCountryHint": "Calling code preselected in empty phone fields.",
         "distanceUnit": "Distance unit",
         "units": {
            "mi": "Miles (mi)",
            "km": "Kilometers (km)"
         },
         "currency": "Currency",
         "currencyHint": "Bookings are always charged in US dollars.",
         "searchBiasCountries": "Location search preference",
         "searchBiasCountriesHint": "Location search lists places in these countries first, in this order. Keep at least one.",
         "moveUp": "Move {{country}} up",
         "moveDown": "Move {{country}} down",
         "remove": "Remove {{country}}",
         "add": "Add {{country}}",
         "override": "Use a custom market for this organization",
         "overrideHint": "Off: this organization uses the site's market.",
         "overrideHintChapter": "Off: this chapter uses its club's market, or the site's when the club has none.",
         "effective": "In effect for travelers",
         "effectiveHint": "Site edits can take up to a minute to show here.",
         "errors": {
            "searchBiasRequired": "Pick at least one country for location search.",
            "invalid": "Market settings were rejected: {{detail}}",
            "invalidGeneric": "Market settings were rejected. Check the market fields and try again."
         }
      },
      "orgAdmin": {
         "loading": "Loading...",
         "loadFailed": "We couldn't load this right now. Try again in a moment.",
         "scope": {
            "label": "Organization",
            "all": "All of {{name}}",
            "unavailable": "We couldn't load your organization. Sign out and back in, and contact support if this keeps happening."
         },
         "home": {
            "title": "Organization admin",
            "subtitle": "Everything here covers {{orgName}} and the organizations under it.",
            "cards": {
               "schedules": {
                  "title": "Schedules",
                  "description": "See your season schedules and ask us for changes."
               },
               "trips": {
                  "title": "Trips",
                  "description": "Who is traveling, where they're staying and for which event."
               },
               "users": {
                  "title": "Users",
                  "description": "Members and travelers tied to your organization."
               },
               "proceeds": {
                  "title": "Proceeds",
                  "description": "What your organization has earned from bookings."
               }
            }
         },
         "trips": {
            "title": "Trips",
            "tabsLabel": "Trip views",
            "tabs": {
               "byEvent": "By event",
               "all": "All trips"
            },
            "searchPlaceholder": "Search traveler or hotel",
            "from": "Check-in from",
            "to": "to",
            "showCancelled": "Show cancelled",
            "export": "Export CSV",
            "exporting": "Exporting...",
            "exportFailed": "The export didn't download. Try again.",
            "summary": "{{trips}} trips, {{roomNights}} room nights.",
            "summaryCancelled_one": "{{count}} cancelled trip is listed but not counted.",
            "summaryCancelled_other": "{{count}} cancelled trips are listed but not counted.",
            "groupSummary": "{{trips}} trips, {{roomNights}} room nights",
            "unmatchedGroup": "No matching event",
            "empty": "No trips match these filters.",
            "noEvent": "No matching event",
            "inferredEvent": "Matched by dates and location",
            "yes": "Yes",
            "no": "No",
            "columns": {
               "traveler": "Traveler",
               "checkin": "Check-in",
               "checkout": "Check-out",
               "hotel": "Hotel",
               "event": "Event",
               "teamHotel": "Team hotel",
               "organization": "Organization",
               "status": "Status"
            },
            "status": {
               "booked": "Booked",
               "cancelled": "Cancelled"
            }
         },
         "users": {
            "title": "Users",
            "subtitle": "Members of your organization and the travelers who book with it. Read only.",
            "searchPlaceholder": "Search name or email",
            "empty": "No users match these filters.",
            "noName": "No name on file",
            "columns": {
               "name": "Name",
               "email": "Email",
               "organization": "Organization",
               "relationship": "Relationship",
               "bookings": "Bookings"
            },
            "relationship": {
               "member": "Member",
               "traveler": "Traveler"
            }
         },
         "proceeds": {
            "title": "Proceeds"
         },
         "schedules": {
            "readOnlyNote": "Schedules are managed by our team. Spot something wrong? Request a change and we'll reply by email.",
            "noGames": "This schedule has no games yet.",
            "dateTbd": "Date to be announced",
            "columns": {
               "date": "Date",
               "game": "Game or event",
               "location": "Location",
               "homeAway": "Home or away",
               "hotelDates": "Hotel dates",
               "actions": "Actions"
            }
         },
         "requestChange": {
            "open": "Request a change",
            "short": "Request a change",
            "forGame": "Request a change to {{game}}",
            "title": "Request a schedule change",
            "hint": "Tell us what should change. We'll email the schedules team from your address and reply to you by email.",
            "gameLabel": "Game (optional)",
            "noGame": "The whole schedule",
            "messageLabel": "What should change?",
            "messagePlaceholder": "For example: the game on March 3 moved to 7 PM.",
            "cancel": "Cancel",
            "send": "Send request",
            "sending": "Sending...",
            "sent": "Sent. We'll reply by email.",
            "failed": "Your request didn't send. Try again."
         }
      },
      "program": {
         "indexExists": "Index already exists. Use another one"
      },
      "tableLabels": {
         "organizations": "Organizations",
         "programs": "Programs",
         "destinations": "Destinations",
         "schedules": "Schedules",
         "events": "Events",
         "trendingDestinations": "Trending destinations",
         "rsvps": "RSVPs",
         "touristCenterOverrides": "Tourist center overrides",
         "fraudWatch": "Flagged accounts",
         "siteTrendingDestinations": "Site trending destinations",
         "transactions": "Transactions",
         "trips": "Trips",
         "hotelBlacklist": "Hotel blacklist",
         "bookingFailures": "Booking failures",
         "bookingFailureLogs": "Booking failure logs",
         "coupons": "Coupons",
         "disputes": "Disputes",
         "users": "Users",
         "programSchedules": "Program schedules",
         "activityLogs": "Activity logs",
         "proceedsReport": "Payout by team, {{period}}",
         "proceedsReportProgram": "Payout by team for {{name}}"
      },
      "fraudWatch": {
         "title": "Fraud Watch",
         "description": "Accounts flagged by signup scoring, checkout fraud checks, payment lockouts, or payment attempt limits. Open an account to watch its live activity and hold, release, deactivate, clear its lockout, or reset its velocity counters.",
         "emptyQueue": "No flagged accounts.",
         "emptyActivity": "No activity recorded yet.",
         "emptyTimeline": "No status changes yet.",
         "unknownUser": "Unnamed account",
         "liveHint": "Live · refreshes every 10s",
         "viewInFraudWatch": "View in Fraud Watch",
         "openReviews": "{{count}} accounts awaiting review",
         "actionSuccess": "Action applied",
         "actionError": "Could not apply the action",
         "yes": "Yes",
         "no": "No",
         "status": {
            "NONE": "None",
            "WATCH": "Watch",
            "PAYMENT_HOLD": "Payment hold",
            "LOCKED_OUT": "Locked out",
            "REVIEWED_OK": "Reviewed OK"
         },
         "columns": {
            "user": "User",
            "email": "Email",
            "accountAge": "Account age",
            "signupScore": "Signup score",
            "latestScore": "Latest score",
            "status": "Status",
            "bookingAttempts": "Booking attempts",
            "ipCount": "IPs",
            "lastActivity": "Last activity"
         },
         "panels": {
            "activity": "Live activity",
            "risk": "Risk",
            "identity": "Identity",
            "timeline": "State timeline"
         },
         "activityTypes": {
            "api_activity": "API activity",
            "booking_error": "Booking error"
         },
         "risk": {
            "recaptcha": "reCAPTCHA scores",
            "signupRiskId": "minFraud signup ID",
            "lockoutTtl": "Lockout expires in",
            "velocityCounters": "Velocity (current / limit)",
            "emptyVelocityCounters": "No velocity activity recorded",
            "velocityLabels": {
               "card-add/user/hour": "Card adds (per hour)",
               "card-add/user/day": "Card adds (per day)",
               "card-add/new-user/day": "Card adds, new account (per day)",
               "card-form/user/hour": "Card form opens (per hour)",
               "auth/user/hour": "Payment attempts (per hour)",
               "decline/user/window": "Declines (rolling window)"
            }
         },
         "identity": {
            "sessions": "WorkOS sessions",
            "emailVerified": "Email verified",
            "phone": "Phone",
            "accountActive": "Account active"
         },
         "timeline": {
            "byActor": "by {{actor}}",
            "automated": "· automated",
            "events": {
               "SIGNUP_SCORE": "Signup scored",
               "CHECKOUT_BLOCK": "Checkout blocked",
               "LOCKOUT": "Locked out",
               "MANUAL": "Manual action",
               "CARD_FORM": "Card form opened",
               "CARD_SAVE": "Card saved",
               "PAYMENT_DECLINE": "Payment declined",
               "VELOCITY_LIMIT": "Attempt limit reached"
            }
         },
         "armedBanner": {
            "PAYMENT_HOLD": "Payments and card adds are blocked for this account. Only an admin can release it.",
            "LOCKED_OUT": "This account is locked out after repeated payment declines."
         },
         "actions": {
            "hold": {
               "label": "Hold payments",
               "title": "Hold payments",
               "description": "Blocks card adds and payments for this account. Browsing and search stay available.",
               "confirm": "Hold payments"
            },
            "release": {
               "label": "Release",
               "title": "Release account",
               "description": "Clears the hold and restores the normal payment thresholds for this account.",
               "descriptionLockedOut": "Marks this account as reviewed, but does not clear the payment lockout — use Clear lockout as well to let this account attempt a payment again.",
               "confirm": "Release"
            },
            "deactivate": {
               "label": "Deactivate",
               "title": "Deactivate account",
               "description": "Deactivates the account and signs out every active session. This cannot be undone from here.",
               "confirm": "Deactivate"
            },
            "clear-lockout": {
               "label": "Clear lockout",
               "title": "Clear lockout",
               "description": "Removes the decline lockout so the account can attempt a payment again.",
               "confirm": "Clear lockout"
            },
            "reset-velocity": {
               "label": "Reset velocity",
               "title": "Reset velocity counters",
               "description": "Resets this account's payment and card attempt counters so it can pay again right away. Does not clear a decline lockout; use Clear lockout for that.",
               "confirm": "Reset velocity",
               "nothingToReset": "This account's attempt counters are all at zero. If payments are still refused, it is a lockout (use Clear lockout) or a shared network limit that expires within the hour."
            }
         },
         "modal": {
            "noteLabel": "Note (required)",
            "notePlaceholder": "Why are you taking this action?",
            "noteHint": "The note is stored on the audit trail. Ctrl + Enter to confirm.",
            "cancel": "Cancel"
         }
      },
      "proceedsReport": {
         "title": "Proceeds Report",
         "description": "Consolidated proceeds roll-up per club: every chapter's bookings, gross and proceeds, with club totals.",
         "scopeNote": "Amounts are net of refunds and cover every site the club sells on. Dates are inclusive days in UTC, matched against when the booking was made.",
         "selectClub": "Select an organization",
         "noClubs": "No organizations found.",
         "loadingClubs": "Loading organizations…",
         "clubsLoadFailed": "Failed to load the list of organizations.",
         "retry": "Retry",
         "dateRange": "Date range",
         "exportCsv": "Export CSV",
         "exportXlsx": "Export XLSX",
         "exportFailed": "Failed to export the proceeds statement. Please try again.",
         "loadFailed": "Failed to load the proceeds report. Please try again.",
         "empty": {
            "title": "Choose an organization to build the statement",
            "description": "Pick an org and set a period and statement view above — the client-ready statement assembles here automatically, no spreadsheet step.",
            "orgPlaceholder": "Organization"
         },
         "consolidationEnabled": "Payout consolidation enabled",
         "consolidationDisabled": "Payout consolidation disabled",
         "table": {
            "team": "Team",
            "routing": "Payout routing",
            "bookings": "Bookings",
            "refunds": "Refunds",
            "dueNow": "Due now",
            "awaitingTravel": "Awaiting travel",
            "proceeds": "Proceeds",
            "platformAmount": "Platform amount",
            "orgProceedsAmount": "Org proceeds",
            "travelerDiscountAmount": "Traveler discount",
            "committed": "Committed",
            "total": "Total",
            "booking": "Booking",
            "traveler": "Traveler",
            "purchasedDate": "Purchased date",
            "travelStart": "Travel start",
            "travelEnd": "Travel end",
            "status": "Status",
            "amount": "Amount",
            "payoutAmount": "Payout amount",
            "hotelId": "Hotel ID",
            "hotel": "Hotel",
            "paid": "Paid",
            "refund": "Refund",
            "net": "Net",
            "payout": "Payout"
         },
         "routingConsolidated": "Consolidated to club",
         "routingDirect": "Paid directly",
         "timingNote": "Due now is money whose travel has finished or was cancelled. Awaiting travel is potential — those trips have not finished and may still cancel.",
         "consolidatedTotal": "Consolidated payout total",
         "exportPdf": "Export PDF",
         "period": {
            "thisMonth": "This month",
            "thisQuarter": "This quarter",
            "ytd": "Year to date",
            "lastMonth": "Last month",
            "lastQuarter": "Last quarter",
            "lastYear": "Last year"
         },
         "basis": {
            "arCode": "AR",
            "arWord": "receivable",
            "arHint": "Money we collected",
            "apCode": "AP",
            "apWord": "payable",
            "apHint": "Money we owe the org",
            "apNote": "AP shows money we owe the organization (proceeds) for {{period}}, picked by travel end date.",
            "arNote": "AR shows money collected from travelers (paid, refunds and net) for {{period}}, picked by purchase date.",
            "apChip": "AP · Money we owe",
            "arChip": "AR · Money we collected"
         },
         "statement": {
            "periodLabel": "{{preset}} · {{from}} – {{to}}",
            "download": "Download",
            "exportCsv": "Export CSV",
            "exportCsvHint": "Flat transactions + totals block",
            "exportXlsx": "Export XLSX",
            "exportXlsxHint": "Overview + one sheet per program + teams",
            "exportPdf": "Export PDF",
            "exportPdfHint": "Client-ready letterhead, landscape",
            "overviewTab": "Overview",
            "totalDue": "Total due",
            "totalDueHint": "{{total}} bookings · travel completed, unpaid",
            "awaitingTravel": "Awaiting travel · Potential",
            "awaitingTravelHint": "Refundable · subject to cancellation",
            "runningTotal": "Running total",
            "runningTotalHint": "Settled {{settled}} & refunds −{{refunds}} excluded",
            "note": "Awaiting-travel amounts are potential and subject to cancellation — they are not due until travel completes.",
            "totalPerProgram": "Total per program · {{period}}",
                        "programStatus": {
               "open": "Open",
               "closed": "Closed"
            },
            "dueNow": "Due now",
            "potential": "Potential",
            "committed": "Committed",
            "payoutBreakdown": "Payout breakdown by team",
            "payoutBreakdownNote": "Money owed after travel · {{program}}",
            "transactionTotalRow": "Total · {{bookings}}",
            "transactionTotalSplit": "{{dueNow}} travel-complete · {{awaiting}} awaiting travel (potential)",
            "transactionTotalSplitEstimated": "{{dueNow}} travel-complete · {{awaiting}} awaiting travel (estimated)",
            "transactionDetail": "Transaction detail",
            "transactionDetailNote": "{{total}} in period · {{teams}}",
            "bookingCount_one": "{{count}} booking",
            "bookingCount_other": "{{count}} bookings",
            "teamCount_one": "{{count}} team",
            "teamCount_other": "{{count}} teams",
            "emptyProgram": "No bookings in this period.",
            "payoutByTeam": "Payout by team · {{period}}",
            "payoutByTeamNote": "Money owed after travel · {{name}}",
            "clubTotalRow": "Total · {{name}}",
            "programTotalRow": "Total · {{name}}",
            "bookingsSplit": "{{dueNow}} due now · {{awaiting}} awaiting",
            "bookingsSplitWithCancelled": "{{dueNow}} due now · {{awaiting}} awaiting · {{cancelled}}",
            "cancelledCount_one": "+{{count}} cancelled",
            "cancelledCount_other": "+{{count}} cancelled",
            "keptWithCancelled": "{{bookings}} · {{cancelled}}",
            "estimated": "Estimated",
            "breakdown": {
               "title": "Payout breakdown",
               "commission": "Commission",
               "orgShare": "Org share",
               "percent": "{{value}}%",
               "incrementalTax": "Incremental tax",
               "ccFee": "Card processing fee",
               "ccFeeRate": "Card processing fee ({{value}}%)",
               "invoiceFee": "Invoice fee ({{value}}%)",
               "customerSuccessCost": "Customer success",
               "couponBonus": "Coupon bonus"
            },
            "emptyTeams": "No team has bookings in this period.",
            "loadFailed": "Failed to load the transactions. Please try again.",
            "cards": {
               "paid": "Paid",
               "paidProgram": "Paid · this program",
               "arRefunds": "Refunds",
               "arRefundsProgram": "Refunds · this program",
               "net": "Net · paid minus refunds",
               "netProgram": "Net · this program",
               "netHint": "{{paid}} paid − {{refunds}} refunds",
               "proceedsSplitHint": "{{dueNow}} due now · {{awaiting}} awaiting travel",
               "proceedsSplitEstimatedHint": "{{dueNow}} due now · {{awaiting}} estimated",
               "apDueNow": "Due now · Proceeds",
               "apDueNowProgram": "Due now · proceeds · this program",
               "apAwaiting": "Awaiting travel · Potential",
               "apAwaitingProgram": "Awaiting travel · Potential · this program",
               "apAwaitingEstimated": "Estimated · awaiting travel",
               "apAwaitingEstimatedProgram": "Estimated · awaiting travel · this program",
               "apProceeds": "Proceeds · In period",
               "apProceedsProgram": "Proceeds · in period · this program",
               "bookingsGrossHint": "{{bookings}} · gross {{gross}}",
               "refundsHint": "{{refunded}} refunded · {{cancelled}} cancelled",
               "apDueNowProgramHint": "{{bookings}} · travel ended — owed to the org · gross {{gross}}",
               "apAwaitingProgramHint": "{{bookings}} · gross {{gross}} · not due until travel completes",
               "apProceedsHint": "{{bookings}} · paid {{paid}} · refunds {{refunds}} · net {{net}}"
            },
            "programFigures": {
               "paid": "Paid",
               "net": "Net",
               "awaitingTravel": "Awaiting travel",
               "refunds": "Refunds",
               "dueNow": "Due now",
               "potentialProceeds": "Potential proceeds",
               "estimatedProceeds": "Estimated proceeds",
               "proceedsTotal": "Proceeds total"
            }
         },
         "txnStatus": {
            "awaitingTravel": "Awaiting travel",
            "committed": "Committed",
            "dueNow": "Due now",
            "cancelled": "Cancelled",
            "voided": "Voided"
         }
      },
      "gameGuide": {
         "title": "Game Guide",
         "back": "Back to schedule",
         "loading": "Loading…",
         "error": "Something went wrong.",
         "noGuide": "No guide yet for this game.",
         "createGuide": "Create Guide",
         "published": "Published",
         "draft": "Draft",
         "publish": "Publish",
         "unpublish": "Unpublish",
         "saveDraft": "Save Draft",
         "draftSaved": "Draft saved.",
         "viewGuide": "View Guide",
         "delete": "Delete Guide",
         "saved": "Saved.",
         "destination": "Destination",
         "destinationHint": "Pick the city/place used for hotels, restaurants, and things to do.",
         "searchPlace": "Search for a place",
         "selectPlaceFirst": "Select a destination to enable generation and hotels.",
         "setLocationInSchedule": "Set this game's location in the schedule editor to enable generation and hotels.",
         "locationFromSchedule": "Location & stay dates are set on the game in the schedule editor.",
         "stayDates": "Hotel stay: {{checkIn}} – {{checkOut}} (set in the schedule)",
         "teamHotelSet": "Team hotel: {{id}}",
         "teamHotelFromSchedule": "Team hotel is set on the game in the schedule editor.",
         "placeSaved": "Destination saved.",
         "generateAll": "Generate Guide Content",
         "generating": "Generating…",
         "generatingShort": "Generating…",
         "generatingHint": "This can take up to a minute — we research the matchup and find the best places. You can leave this open.",
         "generatingMsg": {
            "all": "Generating the full guide — overview, matchup, restaurants, and things to do…",
            "matchup": "Researching and writing the matchup introduction…",
            "overview": "Writing the destination overview…",
            "hotels": "Writing the hotels intro…",
            "restaurants": "Finding the best restaurants nearby…",
            "thingsToDo": "Finding things to do in the area…",
            "hero": "Finding hero images for the destination…"
         },
         "generated": "Guide content generated.",
         "generate": "Generate",
         "regenerate": "Regenerate",
         "regenerateIntro": "Regenerate intro",
         "extraContext": "Extra AI Context",
            "aiAssistant": "AI Assistant",
            "improveWithAi": "Improve with AI",
            "improveWithAiHint": "Enhance writing, fix grammar, and make content better.",
            "regenerateAllSections": "Regenerate all sections",
            "regenerateAllHint": "Get a fresh version of all AI-generated content.",
            "generateHint": "Let AI research and generate a complete guide based on your destination. You can review, customize, and publish when you're ready.",
            "regenerateImages": "Regenerate Images",
            "sectionNav": "Guide sections",
            "matchupSub": "AI-researched intro to the matchup — notable storylines, players, and history.",
            "overviewSub": "High-level overview of the matchup and what to expect.",
            "hotelsSub": "Intro and stay details shown with the hotel options.",
            "heroSub": "Choose the image shown at the top of the public guide.",
            "restaurantsSub": "Restaurants shown on the public page, grouped by meal.",
            "thingsToDoSub": "Manage the places and categories displayed on the public page.",
            "customEventsSub": "Add custom events for this guide.",
            "introLabel": "Short intro (shown above this section on the public page)",
            "ratingLabel": "Rating",
            "addRow": "Add Row",
            "dragHandle": "Drag to reorder",
            "dragHint": "Drag to reorder the items",
            "eventDate": "Date",
            "eventTime": "Time",
         "extraContextHint": "Optional notes added to every AI prompt for this guide — e.g. the team's age group, tone, or things to emphasize.",
         "extraContextPlaceholder": "e.g. Audience is parents of U14 travel players; keep it practical and family-friendly.",
         "customizePrompt": "Customize AI prompt",
         "customizePromptHint": "Replaces the default instruction for this section. Leave blank to use the built-in prompt.",
         "promptPlaceholder": "Describe exactly what the AI should write for this section…",
         "resetPrompt": "Reset to default",
         "matchup": "Matchup Introduction",
         "matchupHint": "AI-researched intro to the matchup — notable storylines, players, and history. Editable.",
         "overview": "Overview",
         "hotelSettings": "Hotel Search Settings",
         "hotelsIntro": "Hotels intro",
         "introPlaceholder": "Short intro shown above this section on the public page",
         "teamHotel": "Team hotel ID (optional)",
         "teamHotelPlaceholder": "e.g. holiday_inn_express_state_college",
         "teamHotelHint": "If set and this hotel appears in results, it's highlighted on the public guide as where the team stays, just below the official sponsor.",
         "checkIn": "Check-in",
         "checkOut": "Check-out",
         "adults": "Adults",
         "rooms": "Rooms",
         "heroImage": "Hero image",
         "generateImages": "Generate images",
         "restaurants": "Restaurants",
         "thingsToDo": "Things to Do",
         "customEvents": "Custom Events",
         "add": "Add",
         "adding": "Adding…",
         "addByLink": "Add from Google Maps:",
         "mapsLinkPlaceholder": "Paste a Google Maps place link",
         "lookupFailed": "Couldn't read that Google Maps link.",
         "remove": "Remove",
         "save": "Save",
         "name": "Name",
         "blurb": "Description",
         "sponsor": "Sponsor",
         "highlight": "Highlight",
         "eventTitle": "Title",
         "eventLocation": "Location",
         "eventLink": "Link",
         "eventDescription": "Description",
         "category": {
            "COFFEE": "Coffee",
            "BREAKFAST": "Breakfast",
            "LUNCH": "Lunch",
            "DINNER": "Dinner"
         }
      },
      "programSchedule": {
         "title": "Program Schedules",
         "editingFor": "Editing for",
         "featureOnLanding": "Feature on landing page",
         "featured": "Featured",
         "featuredSet": "This game is now featured on the landing page",
         "featuredCleared": "Featured game cleared — the landing page shows the next upcoming guide",
         "featuredUpdateFailed": "Failed to update the featured game",
         "setLandingDefault": "Set as landing page default program",
         "landingDefault": "★ Landing page default program",
         "landingDefaultLabel": "Landing page default program",
         "landingDefaultSet": "This program is now the landing page default",
         "landingDefaultCleared": "Landing page default cleared — the first program with a schedule is used",
         "landingDefaultFailed": "Failed to update the landing page default program",
         "tabs": {
            "schedules": "Schedules",
            "events": "Events",
            "tvNetworks": "TV Networks",
            "opponents": "Opponents"
         },
         "events": {
            "searchLabel": "Search events",
            "searchPlaceholder": "Search by name or venue…",
            "locationFilterPlaceholder": "City, state or venue…",
            "dateFrom": "From",
            "dateTo": "To",
            "addEvent": "Add Event",
            "empty": "No library events yet.",
            "name": "Event name",
            "venue": "Venue",
            "venuePlaceholder": "Rocky Top Sports World",
            "locationPlaceholder": "Gatlinburg TN",
            "locationSearchHint": "Search and pick a place from the dropdown; free text is geocoded (and checked) on save.",
            "locationPicked": "✓ Place picked from Mapbox — used as-is, no location checks needed.",
            "hotelNightsHint": "Hotel nights are optional — when blank, attached schedules get check-in = start date − 1 day and check-out = end date.",
            "attachedCount": "Attached",
            "view": "View",
            "edit": "Edit",
            "createTitle": "Add Library Event",
            "editTitle": "Edit Library Event",
            "formHelp": "Shared across every club. Changes propagate to all attached schedules (except fields a schedule has overridden).",
            "save": "Save Event",
            "nameRequired": "Event name is required",
            "created": "Library event created",
            "createFailed": "Failed to create the library event",
            "updated": "Library event updated — attached schedules synced",
            "updateFailed": "Failed to update the library event",
            "deleted": "Library event deleted — attached rows kept as standalone events",
            "deleteFailed": "Failed to delete the library event",
            "deleteConfirm": "Delete \"{{name}}\"? {{count}} attached schedule row(s) will be detached and keep their current data.",
            "attachedSchedules": "Attached schedules ({{count}})",
            "viewAttachedSchedules": "View {{count}} attached schedule(s)",
            "noAttachments": "Not attached to any schedule yet.",
            "overridesCount": "{{count}} override(s)",
            "detach": "Detach",
            "removeConfirmTitle": "Delete Event",
            "removeConfirmSubtitle": "Choose how deleting this event affects attached team schedules.",
            "removeModeRemove": "Remove from schedules (soft-delete game rows)",
            "removeModeRemoveDesc": "Soft-deletes the event and removes its game rows from all attached team schedules.",
            "removeModeDetach": "Detach only (keep game rows)",
            "removeModeDetachDesc": "Soft-deletes the event, but leaves game rows on team schedules as standalone games.",
            "impactSummaryTitle": "Impact Summary",
            "affectedSchedulesCount": "{{count}} team schedule(s) attached",
            "travelerImpactInfo": "{{planned}} traveler(s) planned, {{booked}} active booking(s) across affected schedules",
            "travelerSafetyNotice": "Existing traveler bookings and trips are unaffected and will remain intact.",
            "removeSelectedTeamsTitle": "Remove Selected Teams",
            "removeSelectedTeamsSubtitle": "Choose how to remove {{count}} selected team schedule(s) from this event.",
            "confirmRemoveAction": "Confirm Action",
            "removedFromSchedules": "Event removed from schedules",
            "detached": "Row detached — it keeps its data as a standalone event",
            "detachFailed": "Failed to detach the row",
            "attachTo": "Attach to schedules",
            "noSchedules": "No schedules for this organization.",
            "alreadyAttached": "already attached",
            "attachSelected": "Attach ({{count}})",
            "attached": "Event attached — a derived row was added to each schedule",
            "attachFailed": "Failed to attach the event",
            "unresolvedLocation": "Location \"{{location}}\" is not resolved to a map place yet",
            "rangeDates": "Date Range",
            "searchByName": "Search by name",
            "eventDates": "Event dates",
            "hotelStay": "Hotel check-in / check-out",
            "dateRange": "Date range",
            "stats": {
               "total": "Total events",
               "needsReview": "Need location review (this page)",
               "attached": "Attached teams (this page)"
            },
            "locationWarningBadge": "Location warning",
            "outsideCoverageBadge": "Outside US, CA, MX",
            "findDuplicates": "Find duplicate events across clubs…",
            "hideDedupe": "Hide duplicate finder",
            "noDuplicates": "No duplicate event rows found.",
            "dedupeFailed": "The duplicate scan could not be run.",
            "dedupeRetry": "Try again",
            "mergeIntoLibrary": "Merge {{count}} rows into a library event",
            "merged": "Library event created and rows linked",
            "mergeFailed": "Failed to merge the rows",
            "pickerTitle": "Attach this row to a shared library event",
            "pickerPlaceholder": "Search the events library…",
            "pickerEmpty": "No matching library events.",
            "attachFromLibrary": "Attach from events library…",
            "attachedBanner": "Linked to library event \"{{name}}\" — synced fields are read-only; use Override to edit one.",
            "override": "override",
            "overridden": "overridden",
            "overriddenHint": "This field is overridden on this row — library updates will not change it. Click to re-sync.",
            "syncedHint": "This field syncs from the library event. Click to override it for this row only.",
            "libraryMatch": "Library match",
            "linkTo": "Link to \"{{name}}\"",
            "linkedPreviewNote": "Showing the library event's values — these are what will be saved.",
            "dedupeClubs": "{{count}} club(s)",
            "dedupeLocationConflict": "Two different locations",
            "dedupeLocationConflictHelp": "Rows in this group name more than one place — this may be two different events that share a name and a date. Merging moves every row to the event's location.",
            "unknownClub": "Unknown club",
            "unknownProgram": "No program",
            "unnamedSchedule": "Unnamed schedule",
            "noLocation": "No location",
            "rowKeeps": "Keeps its own {{fields}}",
            "rowKeepsNothing": "Takes every field from the event",
            "reviewMerge": "Review merge of {{count}} rows",
            "selectAllRows": "Select every row in this group",
            "selectRow": "Include {{club}} · {{team}} in this merge",
            "selectedCount": "{{selected}} of {{total}} rows selected",
            "selectAtLeast": "Pick at least {{count}} row(s)",
            "rowExcluded": "Not selected — this row stays as it is",
            "rowNamedHere": "Named \"{{name}}\" on this row",
            "rowRenamedFrom": "Renamed from \"{{from}}\" to \"{{to}}\"",
            "dedupeNameConflict": "{{count}} different names",
            "dedupeNameConflictHelp": "These rows were grouped because they look like the same event, not because they match. Check the names before merging — one of them may be a different event.",
            "nameChoiceTitle": "Name for the merged event",
            "nameChoiceHelp": "The rows spell this event differently. Pick the name the library event should carry.",
            "nameRowCount": "{{count}} row(s)",
            "unifyEventName": "Rename every merged row to \"{{name}}\"",
            "unifyEventNameHelp": "Leave this off to let each row keep the name it already has — the rows still link to the same event.",
            "alreadyInLibraryAs": "Already in the library as \"{{name}}\"",
            "alreadyLinkedRows": "{{count}} row(s) already linked",
            "reviewLink": "Review linking {{count}} rows",
            "linkConfirmTitle": "Link {{count}} rows to \"{{name}}\"",
            "linkConfirmHelp": "These rows are the same event as one already in the library, but are not linked to it. Linking takes the event's fields; anything a row disagrees on is kept on that row.",
            "linkConfirmEvent": "The existing library event",
            "confirmLink": "Link rows",
            "linked": "Rows linked to the library event",
            "linkFailed": "Failed to link the rows",
            "mergeConfirmTitle": "Merge {{count}} rows into one library event",
            "mergeConfirmHelp": "The event takes the fields below and every row links to it. Anything a row disagrees on is kept on that row, not overwritten.",
            "mergeConfirmEventFields": "The library event",
            "mergeConfirmRows": "Rows being linked ({{count}})",
            "confirmMerge": "Merge rows",
            "overrideFields": {
               "eventName": "event name",
               "eventType": "event type",
               "date": "start date",
               "endDate": "end date",
               "time": "time",
               "title": "title",
               "locationName": "location",
               "checkIn": "check-in",
               "checkOut": "check-out"
            },
            "bulk": {
               "open": "Bulk add",
               "title": "Add events from a list",
               "help": "Paste events the same way you paste a schedule. They are parsed and checked here, and become library events — not tied to any team.",
               "pasteLabel": "Paste events",
               "pastePlaceholder": "One event per line: name, dates, location…",
               "parse": "Parse",
               "parsedCount": "{{count}} row(s) parsed",
               "namelessCount": "{{count}} row(s) have no name and cannot be created",
               "editPaste": "Back to the paste",
               "includeRow": "Include {{name}}",
               "alreadyInLibrary": "Looks like \"{{name}}\", already in the library — unchecked.",
               "create": "Create {{count}} event(s)",
               "created": "{{created}} created, {{skipped}} already existed",
               "createFailed": "Failed to create the events",
               "nothingParsed": "Nothing could be parsed from that paste"
            },
            "orgDeleted": "Club deleted",
            "orgDeactivated": "Club deactivated",
            "orgDeletedExcluded": "Deleted club — not merged",
            "ghostRowsExcluded": "{{count}} row(s) belong to a deleted club and will not be merged. Their schedules still exist; the club does not."
         },
         "locationWarnings": {
            "title": "Location needs review",
            "confidence": "confidence {{percent}}%",
            "confirm": "Confirm location",
            "confirmAllFirst": "{{count}} row(s) have location warnings — confirm each or pick a precise place first",
            "reviewBanner": "{{count}} row(s) have location warnings. Confirm each flagged row below (or fix the source data) before saving.",
            "column": "Location check",
            "ok": "✓ OK",
            "vagueBanner": "{{count}} row(s) name only a state. That is broad for a hotel search — you can still save; we'll ask you to confirm.",
            "vagueConfirm": "{{count}} row(s) have a vague location: {{rows}}.\n\nAre you sure you want to save with the vague locations?",
            "outsideCoverage": "Resolved to {{country}} ({{code}}), outside the supported countries ({{supported}})"
         },
         "logosGenerated": "Logo options generated.",
         "generate": "Generate",
         "regenerate": "Regenerate",
         "generateMissing": "Generate Missing Logos",
         "regenerateAll": "Regenerate All",
         "searchPlaceholder": "Search by name",
         "unconfirmedOnly": "Unconfirmed only",
         "add": "Add",
         "addOpponentPlaceholder": "Add an opponent",
         "addNetworkPlaceholder": "Add a TV network",
         "entryAdded": "Added.",
         "entryAddFailed": "Could not add it.",
         "entryRemoved": "Removed.",
         "entryRemoveFailed": "Could not remove it.",
         "libraryEmpty": "Nothing here yet. Logos populate from your schedules' games.",
         "logosHint": "Opponent and TV-network logos are managed in the Opponents and TV Networks tabs.",
         "prev": "Previous",
         "next": "Next",
         "uploadSchedule": "Upload file",
         "pasteData": "Paste CSV/JSON",
         "importSchedule": "Import schedule",
         "importTitle": "Import schedule",
         "importNewEvents": "Import new events",
         "importNewEventsHelp": "Add rows from a CSV, JSON file or pasted text to \"{{name}}\". Existing games stay as they are.",
         "importedToSchedule_one": "{{count}} row added to the schedule.",
         "importedToSchedule_other": "{{count}} rows added to the schedule.",
         "importToScheduleFailed": "Could not add the rows to this schedule.",
         "addToSchedule_one": "Add {{count}} row to schedule",
         "addToSchedule_other": "Add {{count}} rows to schedule",
         "importDuplicateColumn": "Already on schedule?",
         "importAlreadyOnSchedule": "Already on schedule — skipped",
         "importAddAnyway": "Adding anyway",
         "importDuplicateBanner_one": "{{count}} row is already on this schedule (same date and name) and will be skipped unless you tick it.",
         "importDuplicateBanner_other": "{{count}} rows are already on this schedule (same date and name) and will be skipped unless you tick them.",
         "importNewEventsButton": "Import new events",
         "importUnsavedConfirm": "You have new rows that aren't saved yet. Importing reloads the schedule and will discard them. Continue?",
         "importHelp": "Choose the row type, then upload a file or paste CSV/JSON. We'll detect the format automatically.",
         "chooseFile": "Choose file",
         "noFileChosen": "No file chosen",
         "parsing": "Parsing…",
         "pasteTitle": "Paste Schedule",
         "pasteHelp": "Paste your schedule as CSV or JSON. We'll detect the format automatically.",
         "pastePlaceholder": "Date,Time,Opponent,Location,Home/Away,TV Network,Title\n2026-09-05,15:30,Ohio State,\"Columbus, OH\",Away,ESPN,Rivalry",
         "pasteRequired": "Paste some CSV or JSON content first.",
         "parse": "Parse",
         "formatHelp": "New to this? Start from a template or convert your existing schedule with AI:",
         "downloadCsvTemplate": "Download CSV template",
         "downloadJsonTemplate": "Download JSON template",
         "copyAiPrompt": "Copy AI prompt",
         "copyPromptDesc": "Use this prompt to generate your file with AI.",
         "invalidFileType": "Only CSV or JSON files are accepted.",
         "rowsCount": "{{count}} rows",
         "rowsCount_one": "{{count}} row",
         "rowsDetected": "{{count}} rows detected",
         "rowsDetected_one": "{{count}} row detected",
         "programLabel": "Program *",
         "dragAndDrop": "Drag & Drop your file or ",
         "browse": "Browse",
         "acceptedFormats": "Accepted formats: CSV, JSON • Max file size: 50 MB",
         "readyToImport": "Ready to import",
         "previewImport": "Preview Import",
         "allPrograms": "All Programs",
         "status": "Status",
         "promptCopied": "AI prompt copied to clipboard.",
         "promptCopyFailed": "Could not copy the prompt.",
         "organization": "Organization",
         "program": "Program",
         "selectOrganization": "Select an organization",
         "selectProgram": "Select a program",
         "selectProgramFirst": "Select a program before uploading.",
         "selectProgramPrompt": "Select an organization and program to view its schedules.",
         "manage": "Manage",
         "delete": "Delete",
         "deleted": "Schedule deleted.",
         "deleteFailed": "Could not delete the schedule.",
         "uploadFailed": "Could not parse the uploaded file.",
         "active": "Active",
         "inactive": "Inactive",
         "reviewUpload": "Review Schedule Upload",
         "parsedCount": "{{count}} games parsed",
         "skippedCount": "{{count}} rows skipped",
         "scheduleName": "Schedule name",
         "season": "Season",
         "nameRequired": "A schedule name is required.",
         "row": "Row",
         "cancel": "Cancel",
         "saveSchedule": "Save Schedule",
         "created": "Schedule created.",
         "createFailed": "Could not create the schedule.",
         "backToList": "Back to schedules",
         "gamesCount": "{{count}} games",
         "generateAi": "Generate AI Content",
         "regenerateAi": "Regenerate AI Content",
         "enrichStarted": "AI content generated.",
         "enrichFailed": "Could not generate AI content.",
         "enriching": "Generating AI content…",
         "enrichingHint": "Finding images and logos for each game — this can take a minute.",
         "enrichFirst": "Generate AI content first.",
         "loading": "Loading…",
         "notFound": "Schedule not found.",
         "saveGame": "Save Game",
         "gameSaved": "Game saved.",
         "gameSaveFailed": "Could not save the game.",
         "saveAll": "Save Changes",
         "save": "Save",
         "savedAll": "Schedule saved.",
         "saveAllFailed": "Could not save the schedule.",
         "addGame": "Add Game",
         "homeAway": {
            "HOME": "Home",
            "AWAY": "Away",
            "NEUTRAL": "Neutral"
         },
         "hotelDates": {
            "title": "About Hotel Dates",
            "intro": "Hotel check-in and check-out dates help your team manage travel and lodging.",
            "checkInLabel": "Check-in:",
            "checkInBody": "the date your team arrives at the hotel.",
            "checkOutLabel": "Check-out:",
            "checkOutBody": "the date your team departs the hotel.",
            "tipLabel": "Tip:",
            "tipBody": "If your team does not stay overnight, set check-in and check-out to the same date."
         },
         "collapseGame": "Collapse game",
         "dragToReorder": "Drag to reorder game",
         "proTipLabel": "Pro Tip:",
         "proTipBefore": "Drag the handle (",
         "proTipAfter": ") to reorder games. Reordering is saved when you click Save Changes.",
         "expandGame": "Expand game",
         "duplicateGame": "Duplicate Game",
         "saveChanges": "Save Changes",
         "quickAddTitle": "Add Matchup Or Event",
         "quickAddHint": "Create a new game matchup or event for this venue.",
         "reorderTip": "Reorder games by editing their dates; changes are saved with Save Changes.",
         "removeGame": "Remove",
         "manageGuide": "Manage Guide",
         "createGuide": "Create Guide",
         "viewGuide": "View Guide",
         "guideStatus": {
            "none": "No Guide",
            "draft": "Guide: Draft",
            "published": "Guide: Published"
         },
         "homeDefaults": {
            "title": "Home Game Defaults",
            "hint": "Home matchups at the same venue share one set of restaurants and things to do. Set them once and apply them to every guide in the group.",
            "games": "{{count}} home games",
            "venue": "Venue",
            "homeGames": "Home games",
            "homeVenue": "Home venue",
            "thisSeason": "this season",
            "opponentsHere": "Opponents at this venue",
            "guidesReady": "{{withGuide}} of {{total}} guides created",
            "location": "Location: {{place}} · {{count}} home games",
            "opponents": "Opponents: {{names}}",
            "unknownLocation": "Location not set",
            "unknownTeam": "Home team",
            "noCoordinates": "No map location — set this game's location in the schedule so it can be grouped.",
            "setDefaults": "Set Defaults",
            "close": "Close",
            "modalTitle": "Home Game Defaults — {{place}}",
            "modalHint": "These lists are copied into each game's guide. Editing them later does not update guides you've already applied.",
            "overwriteWarning": "Applying replaces the restaurants and things to do on {{count}} game guides. Overview and matchup content stay untouched.",
            "addSomething": "Add at least one restaurant or thing to do before applying.",
            "apply": "Save & Apply to {{count}} games",
            "applying": "Applying…",
            "applied": "{{created}} created · {{updated}} updated · {{failed}} failed",
            "applyFailed": "Could not apply the defaults.",
            "applyResultsTitle": "Per-game results",
            "status": {
               "created": "Created",
               "updated": "Updated",
               "failed": "Failed"
            }
         },
         "newGame": "New game (unsaved)",
         "saveToEnrich": "Save the schedule to generate AI content for this game.",
         "opponentRequired": "Every game needs an opponent name.",
         "rowIdentityRequired": "Every row needs an opponent (matchups) or an event name (events).",
         "defaultRowType": "Default row type",
         "baseYear": "Season (Base year)",
         "baseYearHint": "Resolves dates with no year (e.g. \"Nov 1-2\"). Fall uses this year; spring/summer roll to the next.",
         "gameType": {
            "MATCHUP": "Matchup",
            "EVENT": "Event"
         },
         "eventType": {
            "TOURNAMENT": "Tournament",
            "TRAINING_CAMP": "Training Camp",
            "SHOWCASE": "Showcase",
            "LEAGUE": "League",
            "OTHER": "Other"
         },
         "destinationImage": "Destination image",
         "opponentLogo": "Opponent logo",
         "tvNetworkLogo": "TV network logo",
         "confirmed": "Confirmed",
         "confirmFailed": "Could not save the selected image.",
         "noImageHint": "Please generate or paste an image URL",
         "orPasteImageUrl": "Or paste image URL",
         "pasteImageUrlLabel": "Paste image URL",
         "aiBanner": "These logos are generated by AI. Please select an image below or paste an image URL.",
         "chooseFromExisting": "Choose from existing",
         "candidateAlt": "Candidate image for {{label}}",
         "logoStatus": {
            "noLogo": "No Logo",
            "unconfirmed": "Unconfirmed",
            "confirmed": "Confirmed"
         },
         "removeEntry": "Remove {{name}}",
         "regenerateEntry": "Regenerate {{name}}",
         "regenerateAllTitle": "Regenerate all logos?",
         "regenerateAllBody": "This regenerates logos for every entry and may take a while.",
         "noImageYet": "No image selected yet",
         "saving": "Saving…",
         "selectThisImage": "Use this image",
         "syncedOn": "Synced on {{date}}",
         "synced": "Synced",
         "logoStats": {
            "totalOpponents": "Total Opponents",
            "totalTvNetworks": "Total TV Networks",
            "withLogo": "With Logo (this page)",
            "noLogo": "No Logo (this page)",
            "unconfirmed": "Unconfirmed (this page)"
         },
         "changeImage": "Change image",
         "pasteImageUrl": "Paste an image URL",
         "useUrl": "Use URL",
         "table": {
            "name": "Name",
            "season": "Season",
            "games": "Games",
            "status": "Status",
            "created": "Created"
         },
         "game": {
            "type": "Type",
            "date": "Date",
            "startDate": "Start date",
            "endDate": "End date",
            "dates": "Date(s)",
            "time": "Time",
            "opponent": "Opponent",
            "eventName": "Event name",
            "eventType": "Event type",
            "needsAttention": "Needs attention",
            "homeTeam": "Home team",
            "needsDestination": "This location couldn't be placed on a map. Pick a precise venue or town so hotels and the guide can go live.",
            "location": "Location",
            "locationPlaceholder": "Search a city or venue…",
            "locationResolved": "✓ Location set for hotel search",
            "originalLocation": "Original schedule location: {{location}}",
            "checkIn": "Hotel check-in",
            "checkOut": "Hotel check-out",
            "teamHotel": "Team hotel ID (optional)",
            "teamHotelPlaceholder": "Hotel id the team stays at — shown first in recommended",
            "homeAway": "Home/Away",
            "tvNetwork": "TV Network",
            "title": "Title",
            "lowConfidencePlace": "Low-confidence location match: \"{{place}}\". Confirm it is the right venue before hotels go live."
         },
         "coverage": {
            "filterMissing": "Missing schedules",
            "filterNeedsAttention": "Needs attention",
            "createSchedules": "Create schedules",
            "selectedCount": "{{count}} selected",
            "selectAll": "Select all rows missing a schedule",
            "missing": "No schedule uploaded",
            "needsDestinationMissing": "{{count}} missing",
            "empty": "No programs or schedules match the current filters.",
            "copyLink": "Copy",
            "totalSchedules": "Total Schedules",
            "activeSchedules": "Active Schedules",
            "missingSchedules": "Missing Schedules",
            "table": {
               "name": "Name",
               "schedule": "Schedule",
               "needsDestination": "Needs destination",
               "lastUpdated": "Last updated",
               "organization": "Organization",
               "program": "Program",
               "programName": "Program Name",
               "season": "Season",
               "games": "Games",
               "actions": "Actions",
               "link": "Season planner link"
            },
            "modal": {
               "title": "Create schedules",
               "help": "Creates one empty schedule for each of the {{count}} selected rows (organization + program).",
               "help_one": "Creates one empty schedule for the selected row (organization + program).",
               "nameLabel": "Schedule name",
               "namePlaceholder": "e.g. 2026 Spring Season",
               "nameRequired": "Enter a schedule name.",
               "baseYearHint": "Season label for the new schedules.",
               "submit": "Create",
               "creating": "Creating…",
               "failed": "Failed to create schedules.",
               "resultsTitle": "Results",
               "done": "Done",
               "status": {
                  "created": "Created",
                  "updated": "Updated",
                  "skipped": "Skipped",
                  "error": "Error"
               },
               "pasteHelp": "Paste one CSV for the whole club — each row names its org and program, and every (org, program) group becomes that team’s schedule.",
               "selectedTab": "Selected teams ({{count}})",
               "selectedTabDesc": "Choose the teams that will receive a new schedule.",
               "selectedTab_one": "Selected team ({{count}})",
               "pasteTab": "Paste schedules",
               "pastePlaceholder": "Paste CSV or JSON with org, program and game/event columns…",
               "pasteHint": "Org and program values must match the names shown in the admin panel (org slugs work too). The program column may be blank when the org has exactly one program.",
               "downloadTemplate": "Download multi-org CSV template",
               "downloadTemplateDesc": "Use our CSV template to format your data.",
               "nameOverrideHint": "A \"Schedule Name\" column in the paste overrides this per team.",
               "parseReview": "Parse & review",
               "createSchedules": "Create schedules",
               "back": "Back",
               "reviewTitle": "Review: {{groups}} schedules, {{games}} rows",
               "groupGames": "{{count}} rows",
               "groupGames_one": "{{count}} row",
               "groupWarnings": "{{count}} need attention",
               "groupWarnings_one": "{{count}} needs attention",
               "skippedTitle": "{{count}} rows will NOT be imported",
               "skippedTitle_one": "{{count}} row will NOT be imported",
               "skippedRow": "Row {{row}}: {{message}}",
               "acknowledge": "Create anyway — I’ll spot-check the flagged locations on each team afterwards. Warnings are kept on every created row.",
               "nothingToCreate": "No rows matched an org/program in this scope — nothing to create.",
               "createCount": "Create {{count}} schedules",
               "createCount_one": "Create {{count}} schedule",
               "updateCount": "Update {{count}} schedules",
               "updateCount_one": "Update {{count}} schedule",
               "createAndUpdateCount": "Create {{createCount}} & update {{updateCount}} schedules",
               "collisionWarning": "{{count}} of these teams already have a schedule with this name and season — they will be skipped and no rows will be added to them. Change the schedule name to create new ones.",
               "collisionWarning_one": "One of these teams already has a schedule with this name and season — it will be skipped and no rows will be added to it. Change the schedule name to create a new one.",
               "groupExists": "Exists ({{season}})",
               "groupUpdateExists": "Will update ({{season}})",
               "noTeamsSelected" : "No teams selected yet",
               "noTeamsSelectedDesc" : "Enter your team names below, or paste a CSV/JSON to create schedules in bulk.",
               "newToThis": "New to this?",
               "newToThisDesc": "Start from a template or convert with AI.",
               "tipsTitle": "Tips for best results",
               "tipsDesc": "Upload a clear schedule file with dates, times, opponents, and locations.",
               "stepUploadTitle": "Upload & Details",
               "stepUploadDesc": "Upload file or paste data and set basic info",
               "stepReviewTitle": "Review Schedule Upload",
               "stepReviewDesc": "Review detected games & events",
               "showAllTeams": "Show all {{count}} teams",
               "hideTeams": "Hide teams",
               "defaultScheduleName": "Match Schedule",
               "copyPromptDesc": "Use this prompt to generate your file with AI.",
               "downloadJsonTemplateDesc": "Use our JSON template to format your data.",
               "pasteTabDesc": "Add games and events by pasting a CSV/JSON file.",
               "parsing": "Parsing...",
               "saving": "Saving..."
            },
            "allOrganizations": "All organizations",
               "selectOrgFirst": "Select an organization first to create schedules.",
               "selectOrg": "Select an organization",
            "selectOrgPrompt": "Select an organization to see its programs and schedules (children included).",
            "searchLabel": "Search",
            "allSeasons": "All seasons",
            "selectRow": "Select {{name}}",
            "noPrograms": "No programs",
            "create": "Create",
            "import": "Import",
            "manager": "Manager",
            "delete": "Delete schedule"
         },
         "hotelTiers": {
            "label": "Hotel tiers",
            "title": "Hotel tiers (Team / Budget / Luxury)",
            "open": "Manage hotel tiers (Team / Budget / Luxury)",
            "manage": "Manage hotel tiers",
            "summary": "Team / Budget / Luxury",
            "close": "Collapse",
            "saveGameFirst": "Save the schedule first, then manage this row's hotel tiers.",
            "eventScopeNote": "These hotel tiers apply to every team attached to this event. Individual schedule rows can extend or override them.",
            "gameOverlayNote": "This row is attached to a library event — inherited event tiers are shown below and can be extended or overridden by this row's own picks.",
            "category": {
               "TEAM": "Team hotel",
               "BUDGET": "Budget picks",
               "LUXURY": "Luxury picks"
            },
            "emptyCategory": "No hotels designated.",
            "addPlaceholder": "Hotel ID (numeric), e.g. 8473921",
            "add": "Add",
            "remove": "Remove",
            "fromEvent": "From event",
            "duplicate": "That hotel is already designated.",
            "alreadyInherited": "That hotel is already inherited from the event in this tier. Add it to a different tier to override it for this row.",
            "movedFromEvent": "Moved to this tier for this row — it overrides the event's tier once you save.",
            "noSuggestions": "No hotels to suggest for this stay window. Preferences only change the ranking; only blocked brands and hotels, and the adults-only setting, remove a hotel.",
            "notFound": "Hotel \"{{id}}\" was not found — check the hotel ID.",
            "save": "Save hotel tiers",
            "saved": "Hotel tiers saved.",
            "saveFailed": "Could not save hotel tiers.",
            "suggest": "Suggest hotels",
            "suggesting": "Searching hotels…",
            "suggestFailed": "Could not fetch suggestions — the game needs a resolved location and an upcoming stay window."
         },
         "destinations": {
            "open": "View destinations on map",
            "title": "Destinations — {{name}}",
            "help": "Every game and event location for this organization and its chapters. Look for a pin somewhere the teams do not play.",
            "empty": "No placed destinations yet for this organization.",
            "pinCount": "{{count}} location(s)",
            "flaggedCount": "{{count}} location(s) with a warning",
            "unresolvedTitle": "Not placed ({{count}})",
            "unresolvedNone": "Every row resolved to a place.",
            "unnamedRow": "Untitled row",
            "selectOrgFirst": "Select an organization to view its destinations on the map.",
            "popupCount": "{{count}} games and events",
            "tabAll": "All Locations ({{count}})",
            "tabNotPlaced": "Not placed ({{count}})",
            "legendPlaced": "Placed ({{count}})",
            "legendNotPlaced": "Not placed ({{count}})",
            "statusPlaced": "Placed",
            "statusNotPlaced": "Not placed",
            "statusReview": "Needs review",
            "viewFullMap": "View full map",
            "zoomIn": "Zoom in",
            "zoomOut": "Zoom out",
            "fitAll": "Show every pin",
            "window": "Showing rows dated within the last {{days}} days, and everything ahead.",
            "close": "Close",
            "openRow": "Open in new tab",
            "openSchedule": "Open schedule, scroll to this game",
            "openEvent": "Open event"
         }
      },
      "organization": {
         "export": {
            "action": "Export",
            "success": "Organization exported. Your download should begin shortly.",
            "error": "Could not export this organization."
         },
         "import": {
            "action": "Import",
            "confirmTitle": "Confirm overwrite",
            "overwriteWarning": "An organization with slug \"{{slug}}\" already exists in this environment. Importing will overwrite it.",
            "existing": "Existing in this environment",
            "incoming": "Importing",
            "lastModified": "Last modified {{date}}",
            "exportedFrom": "Exported from {{env}} on {{date}}",
            "countPrograms": "Programs: {{count}}",
            "countPopularDestinations": "Popular destinations: {{count}}",
            "countTrendingDestinations": "Trending destinations: {{count}}",
            "countEvents": "Events: {{count}}",
            "countFiles": "Asset files: {{count}}",
            "cancel": "Cancel",
            "confirmOverwrite": "Yes, overwrite",
            "submitting": "Importing…",
            "successCreate": "Imported new organization \"{{name}}\".",
            "successUpdate": "Overwrote organization \"{{name}}\" with the imported bundle.",
            "errorPreflight": "Could not read the import bundle.",
            "errorCommit": "Could not complete the import."
         },
         "acSync": {
            "action": "Sync to ActiveCampaign",
            "syncing": "Syncing…",
            "success": "AC sync complete: {{accountsCreated}} accounts created, {{accountsExisted}} already existed, {{contactsSynced}} contacts synced, {{contactsAssociated}} associations made.",
            "error": "Could not sync to ActiveCampaign."
         },
         "chapters": {
            "newChapter": "New chapter",
            "newChapterTitle": "Create a team chapter",
            "newChapterDescription": "Creates a chapter that inherits this club's branding and settings. Edit any section on the chapter's page to override it.",
            "teamNameLabel": "Team name",
            "teamNamePlaceholder": "e.g. Boys 2028 Army",
            "create": "Create",
            "creating": "Creating…",
            "createSuccess": "Chapter \"{{name}}\" created.",
            "createSkipped": "Could not create \"{{name}}\": {{reason}}",
            "bulkImport": "Bulk import teams",
            "bulkImportTitle": "Bulk import teams",
            "bulkImportHelp": "Upload a CSV or paste a list with one team name per line (header row optional). Each team becomes a chapter that inherits this club's settings. No schedules are created.",
            "uploadFile": "Upload file",
            "pasteList": "Paste list",
            "chooseFile": "Choose file",
            "noFileChosen": "No file chosen",
            "pastePlaceholder": "Boys 2028 Army\nGirls 2030 Navy\n…",
            "parse": "Preview",
            "parsing": "Parsing…",
            "preflightFailed": "Could not parse the team list.",
            "reviewTitle": "Review teams",
            "reviewHelp": "Rows with warnings will be skipped. Go back to fix the list, or continue to create the remaining teams.",
            "columnName": "Team name",
            "columnSlug": "Slug",
            "columnWarnings": "Warnings",
            "warningOk": "Ready",
            "warning": {
               "EMPTY_NAME": "Empty team name",
               "NAME_TOO_LONG": "Name is longer than 100 characters",
               "DUPLICATE_IN_LIST": "Duplicate of an earlier row",
               "DUPLICATE_SLUG_IN_LIST": "Another row in this list produces the same slug",
               "NAME_CONFLICT": "An organization with this name already exists",
               "SLUG_CONFLICT": "An organization with this slug already exists"
            },
            "back": "Back",
            "commit": "Create {{count}} chapters",
            "commitOne": "Create 1 chapter",
            "committing": "Creating…",
            "commitFailed": "Could not create the chapters.",
            "summaryTitle": "Chapters created",
            "summaryCreated": "{{count}} chapters created",
            "summarySkipped": "{{count}} rows skipped",
            "summaryOpen": "Open",
            "done": "Done"
         },
         "scheduleDefaults": {
            "title": "Schedule defaults",
            "description": "Defaults applied when schedules are created for this club's chapters.",
            "defaultGameType": "Default row type",
            "gameTypeMatchup": "Matchup (opponents)",
            "gameTypeEvent": "Event (tournaments, camps)",
            "baseYear": "Base year",
            "baseYearHint": "Resolves dates without a year, e.g. \"Nov 1-2\".",
            "save": "Save defaults",
            "saved": "Schedule defaults saved."
         },
         "inheritance": {
            "inheritedBadge": "Inherited from club",
            "overriddenBadge": "Overridden",
            "inheritedHint": "This section currently uses the club's values. Edit a field and save to override it for this chapter.",
            "overriddenHint": "This section uses this chapter's own values.",
            "revert": "Revert to club",
            "revertSuccess": "Section reverted to the club's values.",
            "updateFailed": "Could not update the section.",
            "unsetBadge": "Not set",
            "unsetHint": "Neither this chapter nor the club has values here. Fill a field in and save to set them for this chapter.",
            "clearingNote": "Clearing a field returns it to the club's value — it does not blank it for this chapter.",
            "revertAllTitle": "Revert everything to the club",
            "revertAllDescription": "This chapter overrides {{count}} settings. Reverting clears them so every section follows the club again.",
            "revertAllNone": "This chapter has no overrides — every section already follows the club.",
            "revertAll": "Revert all to club",
            "revertAllSuccess": "All sections reverted to the club's values."
         }
      },
      "teamHotels": {
         "changeable": {
            "unknown": "Unknown",
            "noneTitle": "None of the {{total}} rates checked can be changed after booking",
            "none": "Not changeable",
            "refundableToo": "Includes a refundable rate",
            "title": "{{amendable}} of {{total}} rates can be changed after booking (dates, guest names)",
            "label": "Changeable: {{amendable}} of {{total}} rates"
         },
         "title": "Team hotels",
         "description": "Games and events that still have no team hotel, soonest trip first. Rows at the same venue on the same dates are filled together, so one decision can cover a whole tournament.",
         "from": "Travelling from",
         "to": "Travelling to",
         "count": "{{count}} still need a team hotel",
         "loading": "Loading the queue",
         "empty": "Nothing is waiting. Every upcoming trip in range has a team hotel.",
         "rowCount": "{{count}} row",
         "rowCount_other": "{{count}} rows",
         "noVenue": "Venue not set",
         "needsLocation": "Needs a location before we can search",
         "findHotels": "Find hotels",
         "hideOptions": "Hide options",
         "untitled": "Untitled row",
         "searching": "Searching hotels and checking the block",
         "searchFailed": "Could not search hotels for this venue.",
         "noOptions": "No hotel here is a strong enough match for this organization's preferences. Check the excluded list below, or adjust the preferences on the organization's Team Hotels tab.",
         "appliedPreferences": "Using {{band}} preferences: a block of {{rooms}} rooms within {{distance}}.",
         "bestOverall": "Best overall",
         "nightly": "Nightly",
         "margin": "Margin",
         "estimated": "estimated",
         "roomsLeft": "Rooms left",
         "distance": "Distance",
         "applyTo": "Set as team hotel for {{count}} row",
         "applyTo_other": "Set as team hotel for {{count}} rows",
         "showExcluded": "Show {{count}} excluded",
         "hideExcluded": "Hide excluded",
         "includeExcluded": "Use {{hotel}} anyway",
         "search": "Search all hotels",
         "searchTitle": "Open a hotel search for this venue and these dates, at block size ({{rooms}} rooms, {{adults}} adults)",
         "applied": "Team hotel set for {{count}} row",
         "applied_other": "Team hotel set for {{count}} rows",
         "skipped": "{{count}} row could not be set: {{reason}}",
         "skipped_other": "{{count}} rows could not be set: {{reason}}",
         "applyFailed": "Could not set the team hotel. Nothing was changed.",
         "noDates": "Dates not set",
         "noPhoto": "No photo",
         "availabilityUnknown": "Availability not checked",
         "blockNotVerified": "Block not verified",
         "blockShort": "Block short",
         "blockQuotedNoCount": "Block available, count not given",
         "blockRefused": "Supplier won't quote a block of {{rooms}} rooms",
         "blockProbeFailed": "Availability check failed",
         "openGame": "View in Schedule",
         "openGameTitle": "View this row in {{schedule}}",
         "tryAgain": "Try again",
         "needsDates": "Needs check-in and check-out dates before we can search",
         "photoAlt": "Photo of {{hotel}}",
         "photoNumber": "Photo {{number}}",
         "eventLibrary": "Event library",
         "eventCovers": "Covers {{count}} attached row",
         "eventCovers_other": "Covers {{count}} attached rows",
         "applyToEvent": "Set for the whole event ({{count}} row)",
         "applyToEvent_other": "Set for the whole event ({{count}} rows)",
         "viewHotel": "View hotel",
         "organization": "Organization",
         "allOrganizations": "All organizations",
         "clubIncludesChapters": "Picking a club includes its chapters.",
         "choices": "A family picks between",
         "cheapestChoice": "Cheapest",
         "refundableChoice": "Cheapest refundable"
      },
      "sites": {
         "allSites": "All sites",
         "column": "Site"
      }
   },
   "hotel": {
      "distanceFromPlace": "{{distance}} from {{place}}",
      "policy": {
         "tiersAria": "See the cancellation schedule",
         "badge": {
            "changeable": "Changeable"
         },
         "label": {
            "suffixChangeable": " · Date changes may be allowed",
            "suffixNonChangeable": ", non-changeable",
            "nonRefundableChangeable": "Non-refundable · Date changes may be allowed",
            "nonRefundableOnly": "Non-refundable",
            "nonRefundable": "Non-refundable, non-changeable",
            "partial": "Partially refundable: {{pct}}% back",
            "partialBefore": "Partially refundable: {{pct}}% back before {{date}}",
            "full": "Fully refundable",
            "fullBefore": "Fully refundable before {{date}}"
         },
         "group": {
            "cancellableTitle": "For bookings that allow cancellation",
            "nonRefundableTitle": "For non-refundable bookings",
            "nonRefundableText": "These bookings cannot be amended or modified. Failure to arrive at your hotel or property will be treated as a No-Show and will incur a charge of 100% of the booking value (Hotel policy).",
            "nonRefundableTextMaybeChangeable": "These bookings can't be refunded. Some hotels allow date changes, subject to availability and any price difference. Failure to arrive at your hotel or property will be treated as a No-Show and will incur a charge of 100% of the booking value (Hotel policy)."
         },
         "previewFallback": "For non-refundable bookings · Child & extra bed policy"
      },
      "share": {
         "title": {
            "proceeds": "{{hotelName}} in {{destination}} | Support {{orgName}}",
            "savings": "{{hotelName}} in {{destination}} | Save with {{orgName}}",
            "neutral": "{{hotelName}} in {{destination}} | {{orgName}}"
         },
         "description": {
            "proceeds": "Book via {{siteName}} to support {{orgName}} with your stay at no extra cost to you.",
            "savings": "Book via {{siteName}} and save on your stay with {{orgName}}.",
            "neutral": "Book your stay via {{siteName}} with {{orgName}}."
         },
         "sms": {
            "proceeds": "I found {{hotelName}} in {{destination}}. Book via this link to support {{orgName}}",
            "savings": "I found {{hotelName}} in {{destination}}. Book via this link to save with {{orgName}}",
            "neutral": "I found {{hotelName}} in {{destination}}. Book via this link with {{orgName}}"
         }
      },
      "mapView": {
         "pageTitle": "Hotel search results on the map",
         "mapRegion": "Hotel map",
         "closeMap": "Close map",
         "searchPin": "Search pin",
         "mapUnavailable": "The map can't be shown on this device. The hotel list still shows results for this area.",
         "loading": "Finding hotels...",
         "updating": "Updating results",
         "searchAsIMove": "Search as I move the map",
         "searchThisArea": "Search this area",
         "priceNote": "Per room, per night, before taxes.",
         "distanceFrom": "{{distance}} from {{place}}",
         "list": {
            "count_one": "{{count}} hotel in this area",
            "count_other": "{{count}} hotels in this area",
            "soldOutCount_one": "· {{count}} sold out",
            "soldOutCount_other": "· {{count}} sold out",
            "truncated": "Showing {{shown}} of {{total}} hotels in this area. Zoom in to see more.",
            "ariaLabel": "Hotels in this map area",
            "hide": "Hide hotel list",
            "show": "Show hotel list"
         },
         "sort": {
            "label": "Sort by",
            "recommended": "Recommended",
            "priceLow": "Price: low to high",
            "priceHigh": "Price: high to low",
            "distance": "Distance to {{place}}",
            "rating": "Guest rating"
         },
         "empty": {
            "noHotelsTitle": "No hotels in this area",
            "noHotelsBody": "Zoom out or move the map to see more hotels.",
            "zoomOut": "Zoom out",
            "outsideTitle": "This area is too far away",
            "outsideBody": "Hotels for this trip are within {{distance}} of {{place}}.",
            "showAnchor": "Back to {{place}}",
            "noPricesTitle": "No prices for these dates",
            "noPricesBody": "The hotels in this area have no rooms left for your dates. Try different dates or another area.",
            "changeDates": "Change dates",
            "noMatchesTitle": "No hotels match your filters",
            "noMatchesBody": "Clear some filters to see more hotels in this area.",
            "clearFilters": "Clear filters",
            "errorTitle": "We couldn't load hotels",
            "errorBody": "We couldn't update the results for this area.",
            "retry": "Try again"
         },
         "preview": {
            "showOnMap": "Show on map"
         },
         "event": {
            "fallbackLabel": "your search",
            "pinLabel": "{{eventName}}: this is where the event is",
            "offscreen": "{{name}} · {{distance}}",
            "offscreenAria": "{{name}} is {{distance}} away. Show it on the map."
         },
         "pin": {
            "ariaPriced": "{{name}}, {{price}} per night",
            "ariaSoldOut": "{{name}}, sold out for your dates",
            "ariaLoading": "{{name}}, price loading",
            "favorite": "in your favorites",
            "visited": "viewed",
            "soldOut": "Sold out",
            "designation": {
               "team": "where the team stays",
               "sponsor": "official sponsor",
               "luxury": "luxury pick",
               "budget": "budget pick"
            }
         },
         "badge": {
            "team": "Team",
            "sponsor": "Sponsor",
            "luxury": "Luxury",
            "budget": "Budget",
            "multiBed": "2-bed rooms"
         },
         "card": {
            "ariaLabel": "{{name}} details",
            "close": "Close hotel details",
            "photoAlt": "{{name}}, photo {{index}}",
            "imageAlt": "Hotel photo",
            "reviews_one": "{{score}} ({{count}}\u00a0review)",
            "reviews_other": "{{score}} ({{count}}\u00a0reviews)",
            "perNight": "{{amount}} per night",
            "total": "{{amount}} total",
            "priceLoading": "Price loading",
            "notAvailable": "Not available for your dates",
            "notAvailableShort": "Not available",
            "viewRooms": "View rooms"
         },
         "price": {
            "title": "Price",
            "perRoomPerNight": "per room, per night",
            "chip": "Price",
            "chipFrom": "${{min}}+",
            "chipRange": "${{min}} to ${{max}}",
            "clear": "Clear price"
         },
         "controls": {
            "reset": "Reset view",
            "zoomIn": "Zoom in",
            "zoomOut": "Zoom out",
            "locate": "Show my location"
         },
         "geolocation": {
            "unsupported": "Your browser can't share your location.",
            "denied": "Location access is off. You can turn it on in your browser settings.",
            "failed": "We couldn't get your location."
         },
         "toolbar": {
            "allFilters": "All filters",
            "prevAmenities": "Previous amenities",
            "nextAmenities": "More amenities"
         },
         "filters": {
            "clear": "Clear",
            "close": "Close filters"
         },
         "toggle": {
            "showList": "List",
            "showMap": "Map"
         },
         "searchBar": {
            "back": "Back",
            "placeholder": "Where are you going?",
            "locationAria": "Destination",
            "clearLocation": "Clear destination",
            "checkIn": "Check-in",
            "checkOut": "Check-out",
            "selectDates": "Select dates",
            "searchLocation": "Search location",
            "whereTo": "Where to?",
            "done": "Done",
            "update": "Update search",
            "share": "Share"
         }
      },
      "card": {
         "driveTime": {
            "under": "Under 10\u00a0min drive to {{place}}",
            "underNoPlace": "Under 10\u00a0min drive",
            "approx": "~{{minutes}}\u00a0min drive to {{place}}",
            "approxNoPlace": "~{{minutes}}\u00a0min drive",
            "loading": "Calculating drive time"
         },
         "unrated": "Unrated",
         "unratedAria": "This hotel has no star rating"
      },
      "search": {
         "share": {
            "title": {
               "proceeds": "Hotels in {{destination}} - Support {{supportName}}",
               "savings": "Hotels in {{destination}} - Save with {{orgName}}",
               "neutral": "Hotels in {{destination}} - Book with {{orgName}}"
            },
            "description": {
               "proceeds": "Browse {{hotelCount}}+ places in {{destination}} for {{checkIn}} to {{checkOut}}. Booking here helps fund {{supportName}} at no extra cost to you.",
               "savings": "Browse {{hotelCount}}+ places in {{destination}} for {{checkIn}} to {{checkOut}}. Book here for lower prices with {{orgName}}.",
               "neutral": "Browse {{hotelCount}}+ places in {{destination}} for {{checkIn}} to {{checkOut}} with {{orgName}}."
            },
            "sms": {
               "proceeds": "Checking {{destination}}? Book here to support {{supportName}}",
               "savings": "Checking {{destination}}? Book here and save with {{orgName}}",
               "neutral": "Checking {{destination}}? Book here with {{orgName}}"
            }
         },
         "driveTime": {
            "calculating": "Calculating drive times…",
            "attribution": "Drive times © OpenStreetMap contributors"
         },
         "sort": {
            "recommended": "Recommended",
            "distance": "Distance",
            "driveTime": "Drive time",
            "priceLow": "Price: low to high",
            "priceHigh": "Price: high to low",
            "rating": "Guest rating"
         },
         "requestedHotelBadge": "The hotel you searched for",
         "textFilterLabel": "Search hotels by name or chain",
         "unofferedHotelTitle": "We don't offer {{hotelName}}.",
         "unofferedHotelSubtitle": "Here are hotels nearby that support {{orgName}}.",
         "soldOut": "Sold Out",
         "soldOutDescription": "Not available for your dates",
         "selectCheckInAndCheckOut": "Select check-in and check-out date",
         "selectCheckOut": "Select your check-out date",
         "tierBadge": {
            "team": "Team hotel",
            "teamStays": "Where {{orgName}} stays",
            "sponsor": "Official sponsor",
            "sponsorOf": "The official hotel sponsor of {{orgName}}!",
            "luxury": "Luxury pick for this trip",
            "budget": "Budget pick for this trip",
            "preferred": "Preferred",
            "preferredPartnerOf": "Preferred Partner of {{orgName}}"
         },
         "multiBedBadge": "2-bed rooms available",
         "filters": {
            "popularHeading": "Popular filters",
            "twoBeds": "Two beds",
            "twoBedsAria": "Two beds — show only hotels with a room that has two beds, or a bed plus a sofa bed"
         },
         "eventMatch": {
            "promptTitle": "Are you going to {{eventName}}?",
            "promptTitleMulti": "Are you attending one of these events?",
            "promptSubtitleWithOrg": "We found a {{orgName}} event matching your dates and destination. See the curated team hotel and special rates.",
            "promptSubtitle": "We found an event matching your dates and destination. See the curated team hotel and special rates.",
            "accept": "Yes, show team hotels",
            "dismiss": "No, continue search",
            "hasTeamHotel": "Team hotel available",
            "showingTeamHotels": "Showing team hotels for {{eventName}}",
            "clearEventFilter": "Clear event filter"
         }
      },
      "pricing": {
         "perNight": "{{amount}} per night",
         "perNightSuffix": "/ night",
         "totalLabel": "Total:",
         "limitedTimeOffer": "Limited Time Offer",
         "saveAmount": "Save {{amount}}",
         "wasAmount": "Was {{amount}}",
         "savePercent": "Save {{percent}}%",
         "taxesAndFees": "+ taxes & fees",
         "savingPercent": "Saving {{percent}}%",
         "ourPrice": "Our Price",
         "publicPriceElsewhere": "Price you'll see elsewhere",
         "youSaveAmount": "You're saving {{amount}} on this booking",
         "savedAmount": "You saved {{amount}}",
         "youSavedTitle": "You saved",
         "ourPriceDiscount": "Our Price discount",
         "bannerSavedExplainer": "<b>{{amount}}</b> comes off the public rate on this booking. That commission exists wherever you book — <b>{{siteName}}</b> shares it with you instead of keeping it. See <b>{{orgName}}</b>'s FAQ for how this works.",
         "bannerSaveLabel": "Save"
      },
      "rateCta": {
         "reserveNow": "Reserve Now",
         "continueBooking": "Continue Booking",
         "notChargedYet": "You will not be charged, yet.",
         "loginToBook": "You must log in to finish your booking."
      },
      "benefits": {
         "moreCount": "+{{count}} more",
         "priceChip": {
            "proceeds": "{{percent}}% of proceeds to {{orgName}}",
            "savings": "Lower prices on every booking"
         }
      },
      "urgency": {
         "onlyXLeft_one": "Only {{count}} room left!",
         "onlyXLeft_other": "Only {{count}} rooms left!",
         "limitedAvailability": "Limited availability",
         "highDemandSubtitle": "High demand — book now to secure your stay.",
         "limitedSubtitle": "Few rooms remaining — prices may increase soon.",
         "roomsLeft": "rooms left",
         "ariaLabel_one": "{{count}} room remaining at this rate",
         "ariaLabel_other": "{{count}} rooms remaining at this rate"
      },
      "preselectedRoomGone": "The room you picked is no longer available for these dates. The rooms below are what this hotel still has.",
      "yourPick": "Your pick",
      "roomSoldOut": {
         "refundableKept": "The room you picked just sold out. We've kept free cancellation selected on the rooms below wherever the hotel offers it.",
         "generic": "The room you picked just sold out. Please choose another room below."
      },
      "detail": {
         "adminHideRoom": {
            "modalTitle": "Hide room type",
            "hideButton": "Hide",
            "unhideButton": "Unhide",
            "hideRoomAria": "Hide {{roomName}}",
            "unhideRoomAria": "Unhide {{roomName}}",
            "hiddenBadge": "Hidden",
            "reasonLabel": "Reason",
            "reasonPlaceholder": "Explain why this room type is being hidden (e.g. incorrect bed configuration)...",
            "reasonRequired": "Reason is required",
            "disclaimer": "Hiding this room type will prevent travelers on all sites from seeing or booking it across all dates. Existing bookings are not changed. The hotel itself will remain visible.",
            "confirm": "Hide room type",
            "hiding": "Hiding...",
            "parentRoomId": "Room Type ID",
            "cancel": "Cancel",
            "hiddenNotBookable": "Hidden (not bookable)",
            "unhideModalTitle": "Unhide room type",
            "unhideConfirm": "Unhide",
            "unhideModalBody": "Are you sure you want to unhide this room type? It will immediately become visible and bookable by travelers on all sites.",
            "hideSuccess": "Room type successfully hidden",
            "hideError": "Failed to hide room type",
            "unhideSuccess": "Room type successfully unhidden",
            "unhideError": "Failed to unhide room type"
         },
         "cheapestRateUnavailable": {
            "title": "The lowest rate is no longer available",
            "body": "The rate shown in search results for this hotel is no longer available. The rooms below are the best rates this hotel has for your dates.",
            "cta": "See available rooms"
         }
      }
   },
   "homeFilter": {
      "recent": "RECENT",
      "trending": "TRENDING",
      "clearRecents": "Clear recent",
      "removeRecent": "Remove recent search",
      "location": {
         "placeholder": "Where are you going?",
         "mapMovePlaceholder": "Search as You move the map",
         "clear": "Clear location",
         "missingError": "Enter a destination to start searching.",
         "missingCenterError": "Select a destination from the list to start searching.",
         "retrieveError": "We couldn't load that location. Try again, or pick another result."
      },
      "nationality": {
         "label": "Nationality",
         "tooltip": "Some countries and hotels have citizenship based priced adjustments. If booked with a value that doesn’t match your passport, you may owe additional fees at check in."
      },
      "time": {
         "checkIn": "Check-in",
         "checkOut": "Check out",
         "placeholder": "Check-in - Check-out",
         "missingDatesError": "Enter Check-in/Checkout to start searching.",
         "maxRangeError": "Search range cannot exceed {{count}} days."
      },
      "room": {
         "adults": "Adults",
         "adultsHelper": "Total across all rooms (max {{count}} per room)",
         "children": "Children",
         "childrenHelper": "Total across all rooms (max {{count}} per room)",
         "rooms": "Rooms",
         "roomsHelper": "At least 1 adult per room (max {{count}} rooms)",
         "childrenAgesTitle": "Enter Children’s Ages",
         "childrenAgesHelper": "Knowing your children’s ages will help us find you suitable accommodations",
         "childNumber": "Child {{number}}",
         "age": "age",
         "travelingWithPets": "Traveling with pets?",
         "modalTitle": "Select room"
      },
      "program": {
         "modalTitle": "Select program",
         "searchPlaceholder": "Search"
      },
      "summary": {
         "adults_one": "{{count}} adult",
         "adults_other": "{{count}} adults",
         "children_one": "{{count}} child",
         "children_other": "{{count}} children",
         "rooms_one": "{{count}} room",
         "rooms_other": "{{count}} rooms",
         "pets": "pets"
      }
   },
   "priceTracking": {
      "title": "Price Tracking",
      "description": "Monitor hotel prices and get notified of changes",
      "trackSearch": "Track This Search",
      "trackHotel": "Track This Hotel",
      "trackHotelForDates": "Track this hotel for {{dates}}",
      "signInToTrack": "Sign in to track prices and get notified when rates drop. If you don't have an account you can make one now!",
      "banner": {
         "title": "Track prices for this search",
         "description": "We'll monitor the top hotels in {{destination}} and notify you when rates drop.",
         "thisArea": "this area"
      },
      "trackingStarted": "Price tracking started! We'll notify you of changes.",
      "trackingExists": "You're already tracking this item.",
      "stopTracking": "Stop Tracking",
      "trackingRemoved": "Price tracking removed.",
      "removeError": "Failed to remove price tracking.",
      "createError": "Failed to create price tracking.",
      "removeConfirmTitle": "Stop Price Tracking",
      "removeConfirmMessage": "Stop tracking this price? You'll no longer receive notifications about rate changes.",
      "removeCancel": "Keep Tracking",
      "removeConfirm": "Stop Tracking",
      "tabs": {
         "all": "All",
         "active": "Active",
         "paused": "Paused",
         "unavailable": "No Longer Available"
      },
      "emptyState": {
         "title": "No price tracking yet",
         "description": "Start tracking hotel prices to get notified about deals. Look for the tracking button on search results or hotel pages.",
         "cta": "Search Hotels"
      },
      "row": {
         "search": "Search",
         "hotel": "Hotel",
         "baseline": "Baseline / night",
         "current": "Current / night",
         "change": "Change",
         "lastChecked": "Last checked",
         "neverChecked": "Not yet checked",
         "unavailable": "No longer available"
      },
      "actions": {
         "viewResults": "View Results",
         "search": "Search",
         "findRooms": "Find Rooms",
         "pause": "Pause Tracking",
         "resume": "Resume Tracking",
         "delete": "Delete",
         "editSettings": "Edit Settings"
      },
      "bulk": {
         "selected": "{{count}} selected",
         "pauseAll": "Pause All",
         "resumeAll": "Resume All",
         "deleteAll": "Delete All"
      },
      "settings": {
         "title": "Tracking Settings",
         "cadence": "Regular Update Frequency",
         "cadenceHint": "How often you'll receive a summary of all your tracked prices.",
         "cadenceOptions": {
            "daily": "Daily",
            "weekly": "Weekly"
         },
         "threshold": "Instant Alert Threshold",
         "thresholdHint": "Get an immediate alert when the nightly rate changes by at least this much.",
         "thresholdPercent": "Percentage (%)",
         "thresholdAbsolute": "Amount ($)",
         "useDefault": "Default",
         "save": "Save Settings",
         "cancel": "Cancel"
      },
      "confirmDelete": {
         "title": "Delete Price Tracking",
         "message": "Are you sure you want to stop tracking this item? This action cannot be undone.",
         "confirm": "Delete",
         "cancel": "Cancel"
      },
      "signInPrompt": "Sign in to track prices"
   },
   "cardName": {
      "addAction": "Add name",
      "editAction": "Edit name",
      "modalTitle": "Name on card",
      "subtitle": "The name printed on {{card}}. Leave it blank if you would rather not store one.",
      "label": "Name on card",
      "placeholder": "As printed on the card",
      "hint": "Letters, spaces, apostrophes, hyphens and periods — up to 50 characters.",
      "save": "Save",
      "saving": "Saving…",
      "cancel": "Cancel",
      "tooLong": "Name must be 50 characters or fewer.",
      "invalidChars": "Name may only contain letters, spaces, apostrophes, hyphens and periods.",
      "success": "The name on this card was updated",
      "error": "We couldn't update the name on this card. Please try again."
   },
   "distance": {
      "short": {
         "mi": "{{value}}\u00a0mi",
         "km": "{{value}}\u00a0km"
      },
      "long": {
         "mi": "{{value}}\u00a0miles",
         "km": "{{value}}\u00a0kilometers"
      },
      "adjective": {
         "mi": "{{value}}-mile",
         "km": "{{value}}-kilometer"
      }
   },
   "errorBoundary": {
      "title": "Something went wrong here",
      "body": "This part of the page didn't load. Trying again usually fixes it.",
      "retry": "Try again",
      "reload": "Reload the page"
   },
   "address": {
      "country": "Country",
      "countries": {
         "US": "United States",
         "CA": "Canada",
         "MX": "Mexico"
      },
      "state": "State/Province",
      "statePlaceholder": "Select state/province",
      "postalCode": "ZIP/Postal code",
      "postalPlaceholder": {
         "US": "ZIP code",
         "CA": "A1A 1A1",
         "MX": "Postal code"
      },
      "streetPlaceholder": "Street address 1",
      "street2Placeholder": "Street address 2",
      "cityPlaceholder": "Your City",
      "errors": {
         "stateRequired": {
            "US": "State is required. Please select a state.",
            "CA": "Province or territory is required. Please select one.",
            "MX": "State is required. Please select a state."
         },
         "postalRequired": {
            "US": "ZIP code is required. Please enter your ZIP code.",
            "CA": "Postal code is required. Please enter your postal code.",
            "MX": "Postal code is required. Please enter your postal code."
         },
         "postalInvalid": {
            "US": "ZIP code is invalid. Use 5 digits, like 12345 or 12345-6789.",
            "CA": "Postal code is invalid. Use the format A1A 1A1.",
            "MX": "Postal code is invalid. Use 5 digits, like 64000."
         }
      }
   },
   "phoneField": {
      "countrySelect": "Country calling code",
      "countries": {
         "US": "+1 US/CA",
         "MX": "+52 MX"
      }
   },
   "missingField": {
      "title": "Complete your booking details",
      "description": "Your booking can't be submitted yet. Please provide the missing information below.",
      "requiredFields": "{{size}} required field{{n}} are missing",
      "note": " These details help us process your booking, keep your information secure, and provide better support if you need to reach us.",
      "continue": "Continue to booking →",
      "ariaLabel": "Missing fields",
      "close": "Close dialog",
      "badge": {
         "required": "Required",
         "invalid": "Validate"
      },
      "fields": {
         "contactFirstName": "First name",
         "contactLastName": "Last name",
         "phoneNumber": "Phone number",
         "email": "Email",
         "travelerEmail": "Traveler's Email",
         "billingFirstName": "Billing first name",
         "billingLastName": "Billing last name",
         "address": "Address",
         "city": "City",
         "state": "State/Province",
         "zip": "ZIP/Postal code"
      }
   },
   "adminTrips": {
      "supportRequests": {
         "title": "Support requests",
         "open": "Open in Help Scout",
         "supplierRequest": "Supplier request",
         "entry": "{{date}}: {{reason}}"
      },
      "supportCases": {
         "title": "Help Scout cases",
         "entry": "opened {{date}} by {{by}}",
         "unknownAdmin": "an admin"
      },
      "viewCases": {
         "button": "View cases",
         "buttonWithCount": "View cases ({{count}} open)",
         "title": "Help Scout cases for this trip",
         "close": "Close",
         "loading": "Loading cases...",
         "failed": "The cases could not be loaded. Try again in a moment.",
         "helpScoutUnavailable": "Couldn't reach Help Scout. Showing the cases recorded on this booking; their status may be out of date.",
         "helpScoutDisabled": "Help Scout isn't connected here. Showing the cases recorded on this booking.",
         "empty": "No cases for this trip yet.",
         "noneOpen": "No open cases.",
         "closedToggle": "Closed cases ({{count}})",
         "noSubject": "(no subject)",
         "assignee": "Assigned to {{name}}",
         "unassigned": "Unassigned",
         "snoozedUntil": "snoozed until {{date}}",
         "updated": "updated {{date}}",
         "opened": "opened {{date}}",
         "statuses": {
            "active": "Active",
            "pending": "Pending",
            "snoozed": "Snoozed",
            "closed": "Closed",
            "spam": "Spam",
            "unknown": "Status unknown"
         },
         "sources": {
            "admin": "opened from admin",
            "traveller": "traveller request",
            "helpscout": "found in Help Scout"
         }
      },
      "openCase": {
         "button": "Open a case",
         "title": "Open a Help Scout case",
         "type": "Case type",
         "types": {
            "email": "Email",
            "phone": "Phone call"
         },
         "emailHint": "The message is emailed to the customer from Help Scout.",
         "phoneHint": "Records the call. Nothing is emailed to the customer.",
         "email": "Customer email",
         "emailRequired": "Enter the customer's email",
         "emailInvalid": "Enter a valid email",
         "subject": "Subject",
         "subjectRequired": "Enter a subject",
         "subjectTooLong": "The subject is too long",
         "defaultSubject": "Your booking {{ref}} at {{hotel}}",
         "defaultSubjectNoHotel": "Your booking {{ref}}",
         "message": "Message to the customer",
         "callNotes": "Call notes",
         "messageRequired": "Enter a message",
         "messageTooLong": "The message is too long",
         "status": "Status",
         "statuses": {
            "pending": "Pending",
            "active": "Active"
         },
         "statusHint": "Pending cases get the reminder emails. Tag the case no-reminder in Help Scout to stop them.",
         "assignToMe": "Assign to me",
         "submit": "Open case",
         "submitting": "Opening...",
         "created": "Case opened:",
         "caseNumber": "Case #{{number}}",
         "caseNoNumber": "Open in Help Scout",
         "failed": "The case could not be opened in Help Scout. Try again or open it in Help Scout."
      },
      "modifications": {
         "title": "Changes",
         "attentionTitle": "This booking's change needs attention",
         "attentionListTitle": "Booking changes that need attention ({{count}})",
         "viewTrip": "Open trip",
         "since": "since {{date}}",
         "attention": {
            "supplier_pending": "Still pending at the supplier after 30 minutes. Contact BH customer service.",
            "two_reservations": "Two live reservations: the original is not cancelled yet. Retrying automatically; rolls back after about 2 hours.",
            "rollback_failed": "Rollback failed: both reservations are live and the card authorization is held. Cancel one with BH customer service.",
            "capture_failed": "The change went through but charging the price difference keeps failing.",
            "refund_problem": "The change went through but the price-difference refund needs a manual refund."
         },
         "historyMechanism": "How",
         "historyNote": "Note",
         "recordNames": {
            "button": "Record name change",
            "title": "Record a name change made by the supplier",
            "intro": "Use this when BH or the supplier changed the guest names through customer service. Nothing is sent to BH: the booking is updated to match what the hotel now has. Leave a guest blank if the hotel has no name for them.",
            "note": "Note",
            "noteHelp": "Who at the supplier confirmed the change, and when (e.g. the support thread).",
            "noteRequired": "Add a note saying who confirmed the change.",
            "notifyTraveler": "Email the traveler the updated booking",
            "submit": "Record change",
            "success": "Name change recorded"
         },
         "mechanism": {
            "amendment": "Supplier amendment",
            "rebook": "New reservation, original cancelled",
            "manual": "Made by the supplier, recorded by an admin"
         },
         "historyBy": "By",
         "actor": {
            "traveler": "Traveler",
            "admin": "Admin"
         },
         "actorWithId": "{{role}} (user {{id}})",
         "historyOverride": "Deadline override",
         "historyOrders": "BH orders",
         "error": "Last error",
         "resolve": {
            "button": "Mark resolved",
            "buttonFor": "Mark resolved: change on {{id}}",
            "title": "Close the stuck change on {{id}}",
            "description": "Use this once BH customer service has sorted the reservations out. Say what BH did and the booking is updated to match. The change is then closed, and the booking can be cancelled or changed again.",
            "outcomeLegend": "What did BH do?",
            "outcomeRequired": "Choose what BH did.",
            "orders": "Original order {{original}}, new order {{replacement}}",
            "outcomes": {
               "rebook": {
                  "keep_original": {
                     "label": "BH kept the original reservation and cancelled the new one",
                     "hint": "The booking stays as it was. A card hold for the price difference is released. A difference that was already charged is not refunded automatically."
                  },
                  "apply_change": {
                     "label": "BH kept the new reservation and cancelled the original",
                     "hint": "The booking moves to the new reservation, and the price difference is charged or refunded."
                  },
                  "noReplacement": "Not available: this change never got a new reservation."
               },
               "amendment": {
                  "keep_original": {
                     "label": "BH did not apply the change",
                     "hint": "The booking stays as it was. A card hold for the price difference is released. A difference that was already charged is not refunded automatically."
                  },
                  "apply_change": {
                     "label": "BH applied the change",
                     "hint": "The booking is updated to the new dates or guest names, and the price difference is charged or refunded."
                  }
               }
            },
            "note": "What was done",
            "noteHelp": "Required. For example: which reservation BH cancelled, the BH case number, and any refund or charge made by hand.",
            "noteRequired": "Add a note saying how this change was resolved.",
            "submit": "Close change",
            "saving": "Closing...",
            "success": "Change closed. The booking can be cancelled or changed again.",
            "successApplied": "Booking updated to match BH. It can be cancelled or changed again.",
            "closed": "Change closed. The booking can be cancelled or changed again.",
            "closedApplied": "Booking updated to match BH. It can be cancelled or changed again.",
            "followUpTitle": "Still to check",
            "followUpNote": "BH did not return the status of every reservation, so confirm this with BH:",
            "hold": {
               "released": "The card hold of {{amount}} for the price difference was released.",
               "already_released": "The card hold of {{amount}} for the price difference had already been released.",
               "expired": "The card hold of {{amount}} for the price difference had already expired, so nothing is held.",
               "captured": "The price difference of {{amount}} was already charged to the card and was not refunded. Refund it from the trip if the traveler should not pay it.",
               "release_failed": "The card hold of {{amount}} for the price difference could not be released, and the team was alerted. Void it in the Authorize.net dashboard, or it expires on its own after about 30 days."
            },
            "errors": {
               "MODIFICATION_NOT_RESOLVABLE": "This change is no longer waiting on supplier support, so it can't be closed by hand. Reload to see where it stands.",
               "MODIFICATION_CHANGED": "This change was updated while you were writing. Reload and try again.",
               "NOTE_REQUIRED": "Add a note saying how this change was resolved.",
               "OUTCOME_REQUIRED": "Choose what BH did.",
               "ORIGINAL_STILL_LIVE": "BH still shows the original reservation as live. Cancel it with BH first, or choose that BH kept the original.",
               "REPLACEMENT_STILL_LIVE": "BH still shows the new reservation as live. Cancel it with BH first, or choose that BH kept the new one.",
               "ORIGINAL_NOT_LIVE": "BH shows the original reservation as cancelled, so the booking can't keep it.",
               "REPLACEMENT_NOT_LIVE": "BH shows the new reservation as cancelled, so the booking can't move to it.",
               "NO_REPLACEMENT_ORDER": "This change never got a new reservation, so there is nothing to move the booking to."
            }
         }
      },
      "bookedFor": {
         "title": "Booked for {{name}}. The trip is in their account and they got the confirmation email.",
         "titleSelf": "Booking created.",
         "claimSent": "They don't have an account yet. The confirmation email sent to {{email}} has a link to create one."
      },
      "paymentStatus": {
         "processing": "Processing",
         "refundPending": "Refund pending",
         "invoicePending": "Invoice pending",
         "invoicePaid": "Invoice paid",
         "manualRefundPending": "Manual refund pending"
      },
      "paymentMethod": {
         "invoiceNoCard": "Invoice (No card)"
      },
      "flag": {
         "placeholder": "Payment flag",
         "invoice": "Invoice bookings",
         "manualRefund": "Needs manual refund"
      },
      "payment": {
         "title": "Payment Information",
         "method": "Payment Method",
         "invoiceStatus": "Invoice Status",
         "invoiceAmount": "Invoice Amount",
         "amountPaid": "Amount Paid",
         "outstandingBalance": "Outstanding Balance",
         "paidOn": "Paid On",
         "paymentReference": "Payment Reference",
         "coupon": "Coupon",
         "invoiceCode": "Invoice Code",
         "invoiceNote": "Invoice Note",
         "internalNote": "Internal Note",
         "bookedBy": "Booked By",
         "invoiceHint": "Not charged to a card — billed offline to the organization.",
         "markPaid": "Mark as paid",
         "transactionId": "Transaction ID",
         "card": "Card",
         "cardValue": "**** {{last4}}  |  Exp: {{expiry}}",
         "notAvailable": "N/A",
         "depositReceived": "Deposit Received"
      },
      "owner": {
         "title": "Booking Owner",
         "assign": "Assign user",
         "reassign": "Re-assign",
         "none": "No user assigned to this booking.",
         "assignedToast": "Booking re-assigned.",
         "assignedEmailToast": "Booking re-assigned and the new owner has been emailed.",
         "unchangedToast": "This user already owns the booking — nothing changed.",
         "assignError": "Could not re-assign this booking. Please try again."
      },
      "assignUser": {
         "titleAssign": "Assign booking",
         "titleReassign": "Re-assign booking",
         "changeUser": "Change user",
         "confirm": "Confirm",
         "assigning": "Assigning...",
         "currentOwner": "Current owner",
         "newOwner": "New owner",
         "unassigned": "Unassigned",
         "reason": "Reason (optional)",
         "reasonPlaceholder": "Why is this booking being re-assigned?",
         "sendEmail": "Email the new owner about this booking",
         "emailNote": "A 'new booking added to your My Trips' email will be sent to the new owner."
      },
      "manualRefund": {
         "title": "This booking requires a manual refund",
         "reasonNoTransaction": "This booking has no card on file (invoice booking), so the refund cannot be sent automatically.",
         "reasonNoProviderTxn": "No payment gateway transaction was found for this booking, so the refund cannot be sent automatically.",
         "reasonFallback": "The refund could not be sent automatically.",
         "amountDue": "Amount due:",
         "flagged": "Flagged {{date}}",
         "resolve": "Mark as resolved",
         "resolvedTitle": "Manual refund resolved",
         "resolvedOn": "{{amount}} refunded on {{date}}",
         "resolvedBy": "by {{email}}",
         "reference": "Reference: {{reference}}",
         "note": "Note: {{note}}",
         "resolvedToast": "Manual refund marked as resolved.",
         "resolveError": "Could not mark the refund as resolved. Please try again."
      },
      "resolveRefund": {
         "title": "Mark refund as resolved",
         "description": "Confirm the refund was issued outside the system (check, ACH, wire...). The booking will no longer show as pending a manual refund.",
         "cancel": "Cancel",
         "saving": "Saving...",
         "submit": "Mark as resolved",
         "amount": "Refunded amount (optional)",
         "amountHint": "Leave empty to use the calculated amount ({{amount}}).",
         "reference": "Refund reference (optional)",
         "referencePlaceholder": "Check number, ACH trace ID...",
         "note": "Note (optional)",
         "amountInvalid": "Enter a valid amount",
         "referenceTooLong": "Reference must be at most 100 characters",
         "noteTooLong": "Note must be at most 500 characters"
      },
      "markPaid": {
         "title": "Mark invoice as paid",
         "description": "Record the payment the organization made outside the system. The invoice will show as paid.",
         "cancel": "Cancel",
         "saving": "Saving...",
         "submit": "Mark as paid",
         "amount": "Amount paid (optional)",
         "amountHint": "Leave empty to use the invoice amount ({{amount}}).",
         "reopenedDescription": "This invoice was paid, then a change to the booking raised its total. Record the payment of the difference. The invoice will show as paid again.",
         "reopenedAmountHint": "Leave empty to use the difference still due ({{amount}}).",
         "method": "Payment method (optional)",
         "methodPlaceholder": "Select a method",
         "methods": {
            "check": "Check",
            "ach": "ACH",
            "wire": "Wire transfer",
            "cash": "Cash",
            "credit_card_offline": "Credit card (offline)",
            "other": "Other"
         },
         "paidAt": "Paid on (optional)",
         "paidAtHint": "Leave empty to use today.",
         "reference": "Payment reference (optional)",
         "referencePlaceholder": "Check number, wire reference...",
         "note": "Note (optional)",
         "amountInvalid": "Enter a valid amount",
         "paidAtInFuture": "The payment date cannot be in the future",
         "referenceTooLong": "Reference must be at most 100 characters",
         "noteTooLong": "Note must be at most 500 characters",
         "paidToast": "Invoice marked as paid.",
         "unchangedToast": "This invoice is already marked as paid.",
         "error": "Could not mark the invoice as paid. Please try again."
      },
      "cancellationPolicy": {
         "title": "Cancellation Policy",
         "freeBefore": "Free cancellation before {{date}}",
         "nonRefundable": "Non-refundable",
         "partial": "Partially refundable",
         "partialUntil": "Partially refundable: {{pct}}% refund if cancelled before {{date}}",
         "unknown": "Policy details unavailable",
         "between": "{{after}} to {{before}}",
         "before": "Before {{before}}",
         "from": "From {{after}}",
         "fromBooking": "From time of booking",
         "refund": "Refund: {{amount}}",
         "refundIfCancelledNow": "Refund if cancelled now",
         "atCheckout": "At checkout · {{date}}",
         "atCancellation": "When cancelled · {{date}}",
         "today": "Today",
         "refundRecorded": "Refund recorded",
         "refundMismatch": "The policy at cancellation gave {{pct}}% back, but the booking records a refund of {{amount}}. Check the refund.",
         "getQuote": "Get live quote",
         "quoting": "Asking the supplier…",
         "quoteHint": "Asks the supplier what cancelling now would refund. Nothing is cancelled.",
         "quoteResult": "Supplier would refund {{refund}} of {{paid}} (our supplier cost).",
         "quotedAt": "Quoted {{time}}. Nothing was cancelled.",
         "quoteRefused": "The supplier did not quote: {{error}}",
         "quoteError": "Could not reach the server for a quote. Try again.",
         "supplierCode": "Supplier policy code",
         "hotelPolicy": "Hotel policy text"
      },
      "summary": {
         "supplier": "Supplier",
         "supplierStatus": "Supplier Status",
         "supplierStatusUnavailable": "Unavailable",
         "termsAccepted": "Terms Accepted",
         "downloadAgreement": "Download agreement",
         "downloadingAgreement": "Downloading…",
         "agreementDownloadFailed": "Could not download the signed agreement. Try again, or get it from the ToughClicks portal.",
         "pendingSupplier": "Pending supplier confirmation",
         "startedNotFinalized": "Not finalized (started {{date}})",
         "cancelledOn": "Cancelled On"
      },
      "stay": {
         "rooms": "Rooms"
      },
      "guest": {
         "travelerEmail": "Traveler Email",
         "travelerPhone": "Traveler Phone",
         "namesRecorded": "{{recorded}} of {{total}} guest names on file. The rest were not collected for this booking."
      },
      "hotel": {
         "title": "Hotel Details",
         "hotelId": "Hotel ID",
         "address": "Address",
         "phone": "Phone",
         "email": "Email",
         "website": "Website",
         "checkInTime": "Check-in Time",
         "checkOutTime": "Check-out Time",
         "starRating": "Star Rating",
         "stars_one": "{{count}}\u00a0star",
         "stars_other": "{{count}}\u00a0stars",
         "brand": "Brand",
         "propertyType": "Property Type",
         "viewOnPlatform": "View on our site",
         "viewOnPlatformLabel": "Our hotel page"
      },
      "rate": {
         "title": "Rate & Price Breakdown",
         "paidToUs": "Charged by us",
         "priceBeforeDiscount": "Price before discount",
         "discount": "Discount",
         "discountWithCode": "{{amount}} (code {{code}})",
         "includedTaxes": "Taxes included",
         "averagePerNight": "Average per night",
         "dueAtProperty": "Due at property",
         "nothingDue": "Nothing due at property",
         "totalStayCost": "Total stay cost",
         "supplierCost": "Supplier cost"
      },
      "support": {
         "status": {
            "title": "Payment and hotel status",
            "payment": "Payment (Authorize.net)",
            "hotel": "Hotel booking ({{provider}})",
            "checkNow": "Check now",
            "checking": "Checking...",
            "lastChecked": "Last checked {{time}}",
            "neverChecked": "Not checked yet. Use Check now to ask the supplier for the live status.",
            "unreachable": "The supplier did not answer. Try again in a minute.",
            "checkError": "Could not check the supplier status.",
            "transactionId": "Transaction {{id}}",
            "factSource": "Recorded by {{source}}",
            "supplierRef": "Supplier ref {{ref}}",
            "rawStatus": "Supplier says: {{status}}",
            "panelUnavailable": "Support details could not be loaded. The rest of the page is still accurate."
         },
         "paymentState": {
            "none": "No payment recorded",
            "authorized": "Authorized",
            "held": "Held for review",
            "captured": "Captured",
            "settled": "Settled",
            "voided": "Voided",
            "partially_refunded": "Partially refunded",
            "refunded": "Refunded",
            "refund_pending": "Refund pending",
            "invoice_pending": "Invoice pending",
            "invoice_paid": "Invoice paid"
         },
         "hotelState": {
            "booked": "Booked",
            "pending": "Pending at supplier",
            "cancelled": "Cancelled at supplier",
            "failed": "Failed at supplier",
            "not_submitted": "Not sent to supplier yet",
            "unknown": "Unknown"
         },
         "factSource": {
            "api": "our API",
            "authorize_webhook": "an Authorize.net webhook",
            "reconcile_job": "the reconcile job",
            "booking_record": "the booking record"
         },
         "mismatch": {
            "title": "Payment and hotel disagree",
            "payment_gone_hotel_live": "The payment is {{payment}} but the hotel reservation is still live, so the hotel expects the guest and we hold no money for the stay. Collect payment again (new card or invoice), or cancel the reservation with the supplier if the traveler is not going.",
            "hotel_cancelled_payment_kept": "The reservation is cancelled at the supplier but the payment is still {{payment}}. Check the cancellation policy and refund what is owed, or confirm with the supplier that the reservation really is cancelled.",
            "hotel_failed_payment_kept": "The supplier rejected or failed this reservation but the payment is still {{payment}}. Void or refund the payment, then rebook if the traveler still needs a room."
         },
         "transactions": {
            "title": "Transactions",
            "empty": "No payment activity recorded for this booking.",
            "time": "Time",
            "type": "Type",
            "amount": "Amount",
            "card": "Card",
            "reference": "Reference",
            "kind": {
               "authorization": "Authorization",
               "capture": "Capture",
               "void": "Void",
               "refund": "Refund",
               "refund_pending": "Refund (pending)",
               "invoice": "Invoice",
               "other": "Other",
               "failed": "Failed attempt"
            },
            "viewInTransactions": "View in Transactions",
            "declineReason": "Reason: {{reason}}",
            "cardValue": "{{brand}} ending {{last4}}",
            "failedHint": "Failed attempts come from the booking failure log and never reached the ledger."
         },
         "balance": {
            "totalPrice": "Total price",
            "collected": "Collected",
            "refunded": "Refunded",
            "authorizedPending": "Authorized, not captured",
            "outstanding": "Outstanding balance",
            "owed": "Traveler owes {{amount}}",
            "refundDue": "Refund due {{amount}}",
            "settled": "Nothing outstanding"
         },
         "organization": {
            "title": "Organization",
            "organization": "Organization",
            "program": "Program",
            "beneficiary": "Beneficiary",
            "none": "No organization on this booking",
            "open": "Open in admin"
         },
         "source": {
            "title": "How they booked",
            "bookedFrom": "Booked from",
            "values": {
               "search": "Hotel search",
               "hotel_detail": "Hotel page",
               "season_planner": "Season planner",
               "team_hotel": "Team hotel pick",
               "admin": "Admin booking",
               "unknown": "Unknown"
            },
            "seasonPlanGame": "Season plan game",
            "openSchedule": "Open schedule"
         },
         "user": {
            "title": "Traveler account",
            "account": "Account",
            "open": "Open user",
            "otherTrips": "Other trips",
            "otherTripsCount_one": "{{count}} other trip",
            "otherTripsCount_other": "{{count}} other trips",
            "noOtherTrips": "No other trips",
            "viewAll": "View all trips"
         },
         "rateAtBooking": {
            "title": "Room and rate at booking",
            "room": "Room",
            "bedType": "Bed type",
            "mealPlan": "Meal plan",
            "roomOnly": "Room only",
            "freeParking": "Free parking",
            "yes": "Yes",
            "no": "No",
            "otherBenefits": "Other benefits",
            "notRecorded": "Not recorded (booked before this was tracked)",
            "refundability": "Refundability at booking",
            "refundFull": "Fully refundable until {{date}}",
            "refundFullNoDate": "Fully refundable",
            "refundPartial": "Partially refundable: {{pct}}% back until {{date}}",
            "refundPartialNoDate": "Partially refundable: {{pct}}% back",
            "refundNone": "Non-refundable",
            "modifiable": "Can it be changed?",
            "notModifiable": "No. Date or room changes need a cancel and rebook (in-place changes are not supported yet)."
         },
         "path": {
            "title": "Path to booking",
            "intro": "What the traveler did in the 30 days before booking, from Mixpanel.",
            "load": "Load activity",
            "loading": "Loading activity...",
            "incompleteNote": "Activity before sign-in may be incomplete.",
            "unavailable": "Activity unavailable",
            "reason": {
               "not_configured": "Mixpanel access is not configured for this environment.",
               "rate_limited": "Mixpanel's query limit was reached. Try again later.",
               "timeout": "Mixpanel did not answer in time.",
               "error": "Mixpanel returned an error.",
               "no_user": "This booking has no user account."
            },
            "empty": "No activity found in this window.",
            "searches": "Searches",
            "hotelsViewed": "Hotels viewed",
            "ratesSelected": "Rates selected",
            "plannerEvents": "Season planner events",
            "checkoutSteps": "Checkout steps",
            "checkoutFailures": "Checkout problems",
            "timeline": "Timeline",
            "openInMixpanel": "Open user in Mixpanel",
            "views_one": "{{count}} view",
            "views_other": "{{count}} views",
            "fetchedAt": "Fetched {{time}}",
            "dateRange": "{{from}} to {{to}}"
         }
      }
   },
   "a11y": {
      "routeChanged": "Navigated to {{title}}",
      "moreInformation": "More information",
      "skipToMain": "Skip to main content",
      "close": "Close",
      "closeDialog": "Close dialog",
      "closeNotification": "Close notification",
      "clearSearch": "Clear search",
      "clearAllFilters": "Clear all filters ({{active}} active)",
      "scrollToTop": "Scroll to top",
      "openNavigationMenu": "Open navigation menu",
      "adminNavigation": "Admin navigation",
      "openInstagram": "Open Instagram",
      "pricesHoldTimer": "Prices hold timer",
      "selectOrganization": "Select organization to support",
      "searchOrganizations": "Search for organizations",
      "continueToOrganization": "Continue to organization page",
      "removeItem": "Remove {{label}}",
      "more": "More",
      "viewPhoto": "View photo {{index}} of {{total}}",
      "photoAlt": "{{name}}, photo {{index}} of {{total}}",
      "carousel": {
         "label": "Carousel",
         "roleDescription": "carousel",
         "slideRoleDescription": "slide",
         "photos": "{{name}} photos",
         "guestReviews": "Guest reviews",
         "slide": "Slide {{index}} of {{total}}",
         "previous": "Previous slide",
         "next": "Next slide",
         "goTo": "Go to slide {{index}}",
         "play": "Play carousel",
         "pause": "Pause carousel"
      },
      "slider": {
         "label": "Slider",
         "thumbnails": "Photo thumbnails",
         "previous": "Previous",
         "next": "Next"
      },
      "priceRange": {
         "min": "Minimum price",
         "max": "Maximum price"
      },
      "dialog": {
         "guestNamesReminder": "Add guest names",
         "generic": "Dialog",
         "organizationSearch": "Find an organization to support",
         "roomUnavailable": "Room no longer available",
         "nonRefundableConfirm": "Confirm your rate's cancellation terms",
         "paymentSessionEnded": "Your payment session has ended",
         "selectRegion": "Select your region",
         "hotelMap": "Hotel map",
         "removeFromFavorites": "Which favorites list do you want to remove this hotel from?",
         "guestReviews": "What guests say about their stay",
         "addOrganization": "Add organization",
         "ratesUpdated": "Rates have been updated",
         "continueCheckout": "Continue checkout?",
         "paymentSuccessful": "Payment successful",
         "bookingFailed": "Booking failed",
         "rateExpired": "Your rate has expired",
         "signInForFavorites": "You must sign in to create a favorites list",
         "priceChanged": "Price has changed",
         "unfinishedBooking": "You didn't finish your booking",
         "homePageTemplate": "Home page template",
         "homePagePreview": "Home page preview",
         "overviewScorecards": "Overview scorecards",
         "landingPagePreview": "Landing page preview",
         "confirm": "Confirm"
      }
   }
}